/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		4: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({}[chunkId]||chunkId) + ".chunk." + {"0":"582d6","1":"e134e","2":"ed31b","3":"ad56f"}[chunkId] + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://static-staging.paytm.in/merchantpgpui/595/checkout/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "cs3a");
/******/ })
/************************************************************************/
/******/ ({

/***/ "+y/E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"btn-secondary":"_1yZm"};

/***/ }),

/***/ "/TZ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return convertOpacityToHex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return onChange; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_common__ = __webpack_require__("2UA+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_utility__ = __webpack_require__("Lssw");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/**
 * Convert the opacity value to Hexa Decimal
 * @param {Objec} colorObj - Color Object
 */
var convertOpacityToHex = function convertOpacityToHex(colorObj) {
  var a = '';
  if (colorObj && colorObj.rgb && colorObj.rgb.hasOwnProperty('a') && colorObj.rgb.a != 1) {
    a = Math.floor(colorObj.rgb.a * 255).toString(16);
    if (a.length === 1) {
      a = '0' + a;
    }
  }
  return a;
};

/**
 * Common Action for `theme` and `checkout`
 * @param {Object} store - Store Object
 */
var onChange = function onChange() {
  return {
    /**
     * Update the `preview` as `Mobile` or `Website`
     * @param {Object} state - Store Object
     */
    onPreviewToggle: function onPreviewToggle(state, value) {
      return { isMobilePreviewSelected: value };
    },


    /**
     * Update the `preview` Tab as `JS Checkout` or `Redirection`
     * @param {Object} state - State Object
     */
    onPreviewTabChange: function onPreviewTabChange(state, value) {
      return { isRedirectionTabSelected: value };
    },


    /**
     * Toggle the Key's value as `true` or `false`
     * @param {Object} state - State Object
     * @param {String} key - Key name
     * @param {String} value - Value of Key
     */
    onToggleChange: function onToggleChange(state, key, value) {
      var _ref;

      return _ref = {}, _ref[key] = value, _ref;
    },


    /**
     * Update the `theme` as `Light`, `Dark` or `Custom` theme
     * @param {Object} state - Store Object
     * @param {Object} webInfo - webInfo Object
     * @param {Object} mobileInfo - mobileInfo Object
     */
    onThemeChange: function onThemeChange(state, webInfo, mobileInfo) {
      webInfo.isSelected = true;
      mobileInfo.isSelected = true;
      var selected = { mobile: mobileInfo, web: webInfo, gradient: state.selected.gradient, merchant: state.selected.merchant };
      selected.gradient.buttonGradientsColors = [];
      selected.gradient.headerGradientsColors = [];
      selected.gradient.buttonGradientsColors.push(mobileInfo.PAYBUTTONBG);
      selected.gradient.buttonGradientsColors.push(Object(__WEBPACK_IMPORTED_MODULE_1__common_utility__["b" /* lightenDarkenColor */])(mobileInfo.PAYBUTTONBG));
      selected.gradient.headerGradientsColors.push(mobileInfo.HEADERPANEL);
      selected.gradient.headerGradientsColors.push(Object(__WEBPACK_IMPORTED_MODULE_1__common_utility__["b" /* lightenDarkenColor */])(mobileInfo.HEADERPANEL));
      return { selected: selected };
    },


    /**
     * Update the `theme` as `Light`, `Dark` or `Custom` theme
     * @param {Object} state - Store Object
     * @param {Object} logoFile - logoFile Object
     */
    onMerchantLogoChange: function onMerchantLogoChange(state, logoFile, logoFileUrl) {
      var selected = _extends({}, state.selected);
      if (!selected.merchant) {
        selected.merchant = {};
      }
      selected.merchant.merchantLogoFile = logoFile;
      selected.merchant.merchantLogoUrl = logoFileUrl;
      return { selected: selected };
    },


    /**
     * Update the color of `HEADERPANEL`, `HEADERTEXT`, `PAYBUTTONBG`, `PAYBUTTONTEXT`, `BODYBG`, `BODYTEXT`, `BOTTOMBG`
     * @param {Object} state - Store Object
     * @param {String} type - color code type, like `HEADERPANEL`, `HEADERTEXT`, etc. all six
     * @param {String} color - color code of particular type
     */
    onColorChange: function onColorChange(state, type, color) {
      var _extends2;

      var a = convertOpacityToHex(color);
      var colorObj = _extends({}, state.selected.mobile, (_extends2 = {}, _extends2[type] = color.hex + a, _extends2));
      var selected = { mobile: colorObj, web: colorObj, gradient: state.selected.gradient, merchant: state.selected.merchant };

      if (type === 'HEADERPANEL') {
        selected.gradient.headerGradientsColors = [];
        selected.gradient.headerGradientsColors.push(Object(__WEBPACK_IMPORTED_MODULE_1__common_utility__["a" /* get */])(selected, 'mobile.HEADERPANEL'));
        selected.gradient.headerGradientsColors.push(Object(__WEBPACK_IMPORTED_MODULE_1__common_utility__["b" /* lightenDarkenColor */])(Object(__WEBPACK_IMPORTED_MODULE_1__common_utility__["a" /* get */])(selected, 'mobile.HEADERPANEL')));
      }

      if (type === 'PAYBUTTONBG') {
        selected.gradient.buttonGradientsColors = [];
        selected.gradient.buttonGradientsColors.push(Object(__WEBPACK_IMPORTED_MODULE_1__common_utility__["a" /* get */])(selected, 'mobile.PAYBUTTONBG'));
        selected.gradient.buttonGradientsColors.push(Object(__WEBPACK_IMPORTED_MODULE_1__common_utility__["b" /* lightenDarkenColor */])(Object(__WEBPACK_IMPORTED_MODULE_1__common_utility__["a" /* get */])(selected, 'mobile.PAYBUTTONBG')));
      }
      return { selected: selected };
    },


    /**
     * Save the `Custom` theme to persist the changes
     * @param {Object} state - State Object
     * @param {Object} colorObj - Color Object
     */
    onSaveCustomTheme: function onSaveCustomTheme(state, colorObj) {
      return {
        MobileTheme: {
          LIGHTTHEME: state.MobileTheme.LIGHTTHEME,
          DARKTHEME: state.MobileTheme.DARKTHEME,
          CUSTOMTHEME: colorObj.mobile
        },
        WebTheme: {
          LIGHTTHEME: state.WebTheme.LIGHTTHEME,
          DARKTHEME: state.WebTheme.DARKTHEME,
          CUSTOMTHEME: colorObj.web
        }
      };
    },

    /**
     * Update the Payment Mode Order
     * @param {Object} state - State Object
     * @param {Integer} oldIndex - Old Index
     * @param {Integer} newIndex - New Index
     */
    onPaymodeReOrder: function onPaymodeReOrder(state, oldIndex, newIndex) {
      var merchantPayModes = state.merchantPayModes,
          timestamp = state.timestamp;

      if (merchantPayModes) {
        var updateIndexValue = merchantPayModes.splice(oldIndex, 1);
        merchantPayModes.splice(newIndex, 0, updateIndexValue[0]);
        timestamp = new Date().getTime();
        __WEBPACK_IMPORTED_MODULE_0__common_common__["a" /* default */].log('onPaymodeReorder', updateIndexValue, merchantPayModes);
        return { merchantPayModes: merchantPayModes, timestamp: timestamp };
      }
    },


    /**
     * Toggle the Key's value as `true` or `false`
     * @param {Object} state - State Object
     * @param {String} key - Key name
     * @param {String} value - Value of Key
     */
    onKeyValueChange: function onKeyValueChange(state, key, value) {
      var _ref2;

      return _ref2 = {}, _ref2[key] = value, _ref2;
    }
  };
};

/***/ }),

/***/ "/Uqj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__("/sXU");

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),

/***/ "/sXU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function warning() {};

if (false) {
  warning = function warning(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.length < 10 || /^[s\W]*$/.test(format)) {
      throw new Error('The warning format should be able to uniquely identify this ' + 'warning. Please, use a more descriptive format than: ' + format);
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    }
  };
}

module.exports = warning;

/***/ }),

/***/ "07fW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0M3z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"introLeft":"_1PKP","subtext":"_2V7h","intro-heading":"_1efF","benefits-heading":"_2Wqs","ribbon":"_gLhv","intro-list":"_YbaH","payment-step-info":"_2VxQ","payment-heading":"_2Sds","payment-para":"_xcbK","step-row":"_2jo_","step-wrap":"_2U15","arrow-icon":"_3n3l","btm-info":"_LD2y","introRight":"_1Nk0","cta-wrap":"_2rNb","cta-btn":"_1G7U","cta-btn2":"_2R6X"};

/***/ }),

/***/ "2UA+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__("hafV");

// EXTERNAL MODULE: ./common/cache.js
var cache = __webpack_require__("WsRd");
var cache_default = /*#__PURE__*/__webpack_require__.n(cache);

// EXTERNAL MODULE: ./common/utility.js
var utility = __webpack_require__("Lssw");

// CONCATENATED MODULE: ./common/getObjectKey.js
/**
 * obj is the object in which you want to find the key
 * path is the key you want to find
 * default value is the one which you want to return if no value is found
 */
var getObjectKey = function getObjectKey(obj, path, defaultValue) {
  var result = String.prototype.split.call(path, /[,[\].]+?/).filter(Boolean).reduce(function (res, key) {
    return res !== null && res !== undefined ? res[key] : res;
  }, obj);
  return result === undefined || result === obj ? defaultValue : result;
};
// CONCATENATED MODULE: ./utils/utility.js


var numberWithCommas = function numberWithCommas(x) {
  if (x === undefined || x == null) {
    return '';
  }
  var numbers = x.toString().split('.');
  var output = '';
  if (numbers.length >= 1) {
    numbers[0] = numbers[0].replace(/[^0-9]/g, '');
    numbers[0] = isNaN(parseInt(numbers[0])) ? '' : parseInt(numbers[0]);
    if (numbers[0]) {
      if (numbers[0] >= 100000000) {
        numbers[0] = parseInt(('' + numbers[0]).substring(0, 8));
      }
      if (window.Number && window.Number.prototype.toLocaleString) {
        output = numbers[0].toLocaleString('en-in');
      } else {
        output = numbers[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
    }
  }
  if (numbers.length >= 2) {
    if (numbers[1]) {
      numbers[1] = numbers[1].toString().replace(/[^0-9]/g, '');
    }
    output = output + '.' + numbers[1].substring(0, 2);
  }
  return output;
};

var isNullOrUndefined = function isNullOrUndefined(val) {
  return val === undefined || val === null;
};

var numberWithoutCommas = function numberWithoutCommas(number) {
  if (isNullOrUndefined(number)) {
    return '';
  }
  return ("" + number).replace(/\,/g, '');
};

var formatTotalAmount = function formatTotalAmount(x) {
  if (x === undefined || x == null) {
    return '';
  }
  var numbers = x.toString().split('.');
  var output = '';
  if (numbers.length >= 1) {
    numbers[0] = numbers[0].replace(/[^0-9]/g, '');
    numbers[0] = isNaN(parseInt(numbers[0])) ? '' : parseInt(numbers[0]);
    if (numbers[0]) {
      if (window.Number && window.Number.prototype.toLocaleString) {
        output = numbers[0].toLocaleString('en-in');
      } else {
        output = numbers[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
    }
  }
  if (numbers.length >= 2) {
    if (numbers[1]) {
      numbers[1] = numbers[1].toString().replace(/[^0-9]/g, '');
    }
    output = output + '.' + numbers[1].substring(0, 2);
  }
  return output;
};

/**
 * obj is the object in which you want to find the key
 * path is the key you want to find
 * default value is the one which you want to return if no value is found
 */
var getKey = function getKey(obj, path, defaultValue) {
  var result = String.prototype.split.call(path, /[,[\].]+?/).filter(Boolean).reduce(function (res, key) {
    return res !== null && res !== undefined ? res[key] : res;
  }, obj);
  return result === undefined || result === obj ? defaultValue : result;
};

var utility_getMonthNameDate = function getMonthNameDate(inputDate) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : constants["n" /* default */].DMY_FORMAT;
  var monthType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'full';

  if (!inputDate) {
    return '';
  }
  var date = inputDate.split('/');
  var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  if (date.length === 3) {
    var day = Number(date[0]);
    var year = date[2];
    var month = monthType === 'short' ? monthNames[date[1] - 1].substring(0, 3) : monthNames[date[1] - 1];
    if (format === constants["n" /* default */].YMD_FORMAT) {
      year = date[0];
      day = Number(date[2]);
    }
    return day + ' ' + month + ' ' + year;
  }
  return '';
};
// CONCATENATED MODULE: ./common/common.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var isWindowDefined = typeof window !== 'undefined';

var _getStaticPath = function _getStaticPath() {
  var _url = "https://static-staging.paytm.in";
  try {
    if (true) {
      _url += '/' + "merchantpgpui" + '/' + "595" + '/' + "checkout";
    }
  } catch (e) {}
  return _url;
};

/**
 * Get the Hosted Origin
 */
var _getIframeOrigin = function _getIframeOrigin() {
  return "https://ump-staging3.paytm.com";
};

/**
 * Get the running Environment
 */
var _getEnv = function _getEnv() {
  return undefined;
};

var common__parseData = function _parseData() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  initiateLogger('MerchantTemplateForm', input.body && input.body.mid || '', {
    FORM_TYPE: input.body && input.body.templateId ? 'EDIT_FORM' : 'CREATE_FORM'
  });
  var initialObj = {
    linkDescription: '',
    templateName: '',
    templateId: '',
    fields: [],
    givenFields: [],
    inDelible: {},
    isEdit: '',
    errorFieldName: '',
    displayedTooltip: '',
    displayedPopup: '',
    showSaveTemplateScreen: false,
    disableAddFieldButton: false,
    isEditTemplate: false
  };
  if (input) {
    var data = input.body;
    var customPlaceHolder = { name: constants["n" /* default */].CUSTOM_DESC, type: constants["n" /* default */].CUSTOM };
    var initialdropdownFields = void 0;

    if (_isNullOrUndefined(data.templateId) && data.mandatoryFields && data.mandatoryFields.length > 0) {
      initialObj.fields = data.mandatoryFields.map(function (field) {
        initialObj.inDelible[field.name] = true;
        return _extends({}, field, { mandatory: true });
      });
    }
    if (data.fields && data.fields.length > 0) {
      parseSuggestedField(data.fields);
      initialObj.fields = [].concat(initialObj.fields, data.fields);
    }
    if (data.suggestedFields && data.suggestedFields.length > 0) {
      parseSuggestedField(data.suggestedFields);
      initialdropdownFields = data.suggestedFields.map(function (field) {
        initialObj.inDelible[field.name] = false;
        return field;
      });
    }

    if (data.templateInfo) {
      initialObj.linkDescription = data.templateInfo; // Setting linkDescription in Edit Form Case
    }

    if (data.templateName) {
      initialObj.templateName = data.templateName; // Setting templateName in Edit Form Case
    }

    if (data.templateId) {
      initialObj.isEditTemplate = true; // Checking for template create or edit
    }

    initialObj.customField = false; // Need to toggle from form to dropdown of fields and vice-versa
    initialObj.givenFields = [customPlaceHolder].concat(initialdropdownFields);
    initialObj.addField = false;
    if (data.templateId) {
      initialObj.templateId = data.templateId;
    }
    Object(cache["set"])(constants["n" /* default */].MID, data.mid);
    Object(cache["set"])(constants["n" /* default */].TOKEN, data.token);
    initialObj.fields = parseAmountFields(initialObj.fields);
    return initialObj;
  }
};

var parseSuggestedField = function parseSuggestedField(fields) {
  fields.map(function (field) {
    if (field.hasOwnProperty('isEditable') && field.isEditable === false) {
      field.isSuggestedField = true;
    } else {
      field.isSuggestedField = false;
    }
    return field;
  });
};
/**
 * Need to group amount and non amount fields in order to support drag drop functionality
 * @param {fields} fields - passed fields
 */
var parseAmountFields = function parseAmountFields(fields) {
  fields = fields || [];
  // fields other than amount
  var parsedFields = fields.filter(function (field) {
    return !common_isAmountField(field);
  });
  // fields wiht amount
  parsedFields = parsedFields.concat(fields.filter(function (field) {
    return common_isAmountField(field);
  }));

  return parsedFields;
};

/**
 * gets index of first amount field in the fields map
 * @param {options} options - passed fields
 */
var getAmountFieldFirstIndex = function getAmountFieldFirstIndex(options) {
  var item = void 0;
  var lastIndex = -1;
  for (var index = 0; index < options.length; index++) {
    item = options[index];
    if (common_isAmountField(item)) {
      lastIndex = index;
      break;
    }
  }
  return lastIndex;
};

/**
 * Initiate the Logger with the MID and ENV Name
 * @param {String} envName - ENV Name ex `THEMATIC` or `CHECKOUT`
 * @param {String} mid - Merchant ID
 */
var initiateLogger = function initiateLogger(envName, mid) {
  var others = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (isWindowDefined) {
    var env = _getEnv();
    var pushEvent = window.UILogger;
    pushEvent && pushEvent.init(_extends({
      debug: !(env === 'prod' || env === 'qa'),
      env: envName + '_' + env,
      MID: mid
    }, others));
  }
};

/**
 * parse the APP_DATA
 * @param {Object} input  -  Incoming APP_DATA Object
 */
var common__themeParse = function _themeParse() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  initiateLogger('THEMATIC', input.body && input.body.mid || '');
  input = common_commonThemeCheckout(input, true);
  // isRedirectionTabSelected set to false
  input.isRedirectionTabSelected = false;
  input.isMobilePreviewSelected = false;
  Object(cache["set"])(constants["n" /* default */].SAVEURL, constants["n" /* default */].saveThemePreferences);
  return input;
};

/**
 * parse the APP_DATA
 * @param {Object} input  -  Incoming APP_DATA Object
 */
var common__checkoutParse = function _checkoutParse() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  initiateLogger('CHECKOUT', input.body && input.body.mid || '');
  // Dummy Paymodes
  input = common_commonThemeCheckout(input, false);
  input.isRedirectionTabSelected = false;
  input.isGenerateCodeStepEnabled = false;
  input.isMobilePreviewSelected = false;
  Object(cache["set"])(constants["n" /* default */].SAVEURL, constants["n" /* default */].saveCheckoutPreferences);
  return input;
};

/**
 * Convert into new Paymode, Display `Card` , for `Credit Card`, `Debit Card` or either
 * @param {Object} paymodes - Paymode Object
 */
var common_parsePaymodes = function parsePaymodes(paymodes) {
  var newPaymodes = constants["f" /* DEFULTPAYMODES */];
  if (paymodes && Object.keys(paymodes).length > 0) {
    newPaymodes = [{ name: 'Paytm', type: constants["n" /* default */].LOGIN, id: 1 }];
    for (var key in paymodes) {
      var _paymodes$key = paymodes[key],
          displayName = _paymodes$key.displayName,
          payMethod = _paymodes$key.payMethod,
          recordId = _paymodes$key.recordId;

      var paymodeObj = { name: displayName, type: payMethod, id: recordId };
      newPaymodes.push(paymodeObj);
    }
  }
  return newPaymodes;
};

/**
 *
 * Update the Orderdered Paymodes, based on merchanct has added or removed the paymodes
 * @param {Object} orderedPaymodes - saved Ordered Paymodes
 * @param {Object} newPaymodes - New Paymodes
 */
var common_updatePaymodes = function updatePaymodes(orderedPaymodes, newPaymodes) {
  var paymodes = [];
  if (newPaymodes && Object.keys(newPaymodes).length > 0) {
    // Remove the un-used paymodes
    // let isLogin = false;
    for (var _iterator = orderedPaymodes, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var paymode = _ref;

      if (paymode.type && newPaymodes[paymode.type]) {
        paymodes.push(paymode);
        newPaymodes[paymode.type].isUsed = true;
      }

      // if (!isLogin && paymode.type == constant.LOGIN) {
      //   isLogin = true
      //   paymodes.push({ name: 'Paytm', type: constant.LOGIN, id: 1 });
      // }
    }

    // if (!isLogin) {
    //   paymodes.unshift({ name: 'Paytm', type: constant.LOGIN, id: 1 });
    // }

    // Add the newly added paymodes by merchant
    for (var key in newPaymodes) {
      var _newPaymodes$key = newPaymodes[key],
          displayName = _newPaymodes$key.displayName,
          payMethod = _newPaymodes$key.payMethod,
          recordId = _newPaymodes$key.recordId;

      if (newPaymodes[key] && !newPaymodes[key].isUsed) {
        var paymodeObj = { name: displayName, type: payMethod, id: recordId };
        paymodes.push(paymodeObj);
      }
    }
  }
  return paymodes || orderedPaymodes || constants["f" /* DEFULTPAYMODES */];
};

var common_addThemeProperty = function addThemeProperty(theme) {
  var isTheme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (isTheme) {
    if (!Object(utility["a" /* get */])(theme, 'mobile.BORDER') && Object(utility["a" /* get */])(theme, 'mobile.HEADERPANEL')) {
      theme.mobile.BORDER = theme.mobile.HEADERPANEL;
    }

    if (!Object(utility["a" /* get */])(theme, 'web.BORDER') && Object(utility["a" /* get */])(theme, 'web.HEADERPANEL')) {
      theme.web.BORDER = theme.web.HEADERPANEL;
    }
  } else if (!Object(utility["a" /* get */])(theme, 'style.borderColor') && Object(utility["a" /* get */])(theme, 'style.headerBackgroundColor')) {
    theme.style.borderColor = theme.style.headerBackgroundColor;
  }
};

/**
 * Common logic for theme and checkout
 * @param {Object} input - Incoming APP_DATA Object
 */
var common_commonThemeCheckout = function commonThemeCheckout() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var isThemeParse = arguments[1];

  if (input.body && input.body.themePreferenceInfos && input.body.themePreferenceInfos.CHECKOUT && input.body.themePreferenceInfos.REDIRECTION) {
    var _input$body = input.body,
        themePreferenceInfos = _input$body.themePreferenceInfos,
        merchantPreferenceInfos = _input$body.merchantPreferenceInfos,
        merchantPaymodesPreferenceOrder = _input$body.merchantPaymodesPreferenceOrder,
        mid = _input$body.mid,
        token = _input$body.token,
        merchantLogoUrl = _input$body.merchantLogoUrl;
    var REDIRECTION = themePreferenceInfos.REDIRECTION,
        CHECKOUT = themePreferenceInfos.CHECKOUT,
        isCustomPaymodeSelected = themePreferenceInfos.isCustomPaymodeSelected,
        isGradientEffectEnable = themePreferenceInfos.isGradientEffectEnable;

    input.selected = REDIRECTION;
    input.CHECKOUT_THEME = CHECKOUT;
    input.token = token;
    input.isCustomPaymodeSelected = !!isCustomPaymodeSelected;

    if (themePreferenceInfos.hasOwnProperty('paytmLogo')) {
      input.onInvertImgLogo = themePreferenceInfos.paytmLogo !== constants["n" /* default */].BLUE_LOGO;
    } else {
      input.onInvertImgLogo = false;
    }

    common_addThemeProperty(CHECKOUT);
    common_addThemeProperty(REDIRECTION, true);

    input.isGradientEffectEnable = isGradientEffectEnable !== false;
    if (isGradientEffectEnable !== true || Object(utility["a" /* get */])(REDIRECTION, 'gradient.buttonGradientsColors', []).length === 0 || Object(utility["a" /* get */])(REDIRECTION, 'gradient.headerGradientsColors', []).length === 0) {
      input.selected.gradient = JSON.parse(JSON.stringify(constants["e" /* DEFAULT_GRADIENT_COLOR */]));
      input.selected.gradient.buttonGradientsColors = [];
      input.selected.gradient.headerGradientsColors = [];
      input.selected.gradient.buttonGradientsColors.push(Object(utility["a" /* get */])(REDIRECTION, 'mobile.PAYBUTTONBG'));
      input.selected.gradient.buttonGradientsColors.push(Object(utility["b" /* lightenDarkenColor */])(Object(utility["a" /* get */])(REDIRECTION, 'mobile.PAYBUTTONBG')));
      input.selected.gradient.headerGradientsColors.push(Object(utility["a" /* get */])(REDIRECTION, 'mobile.HEADERPANEL'));
      input.selected.gradient.headerGradientsColors.push(Object(utility["b" /* lightenDarkenColor */])(Object(utility["a" /* get */])(REDIRECTION, 'mobile.HEADERPANEL')));
    }
    if (REDIRECTION && REDIRECTION.merchant) {
      input.isPaytmBrandingDisplay = REDIRECTION.merchant.hidePaytmBranding === false;
    } else {
      input.isPaytmBrandingDisplay = true;
    }

    if (!input.selected.merchant) {
      input.selected.merchant = {};
    }

    if (merchantLogoUrl === null || merchantLogoUrl && merchantLogoUrl !== '' && (merchantLogoUrl.endsWith('.png') || merchantLogoUrl.endsWith('.jpg') || merchantLogoUrl.endsWith('.jpeg'))) {
      input.selected.merchant.merchantLogoUrl = merchantLogoUrl;
    }

    // Enable Paytm Branding by Default. Reference: https://jira.mypaytm.com/browse/PGP-20733
    input.isPaytmBrandingDisplay = true;

    if (merchantPreferenceInfos.PG_AUTOLOGIN_ENABLED == 'N') {
      input.isAutoLoginSupported = false;
    } else {
      input.isAutoLoginSupported = true;
    }

    if (isThemeParse || merchantPreferenceInfos.THEMATIC_FEATURE_USED == 'Y') {
      input.isThematicFeatureUsed = true;
    } else {
      input.isThematicFeatureUsed = false;
    }

    if (merchantPreferenceInfos.IS_JSCHECKOUT_USED == 'Y') {
      input.isIntroductionPageVisible = false;
    } else {
      input.isIntroductionPageVisible = true;
    }

    if (merchantPreferenceInfos.IS_JSCHECKOUT_CODE_INTEGRATED == 'Y') {
      input.isJSCheckoutIntegrated = !!isThemeParse;
    } else if (isThemeParse) {
      if (merchantPreferenceInfos.IS_JSCHECKOUT_CODE_INTEGRATED == 'N') {
        input.isJSCheckoutIntegrated = true;
      } else {
        input.isJSCheckoutIntegrated = false;
      }
    } else {
      input.isJSCheckoutIntegrated = true;
    }

    input.isParentThemeOverwriteEnabled = !isThemeParse ? true : input.isJSCheckoutIntegrated;

    Object(cache["set"])(constants["n" /* default */].TOKEN, token);
    Object(cache["set"])(constants["n" /* default */].MID, mid);

    var customThemeMob = constants["b" /* CUSTOMTHEME */];
    var customThemeWeb = constants["b" /* CUSTOMTHEME */];

    if (input.selected.mobile && input.selected.mobile.NAME == constants["m" /* THEME_CONSTANTS */].CUSTOM) {
      customThemeMob = input.selected.mobile;
      customThemeWeb = input.selected.web;
    }
    if (REDIRECTION && REDIRECTION.payMode && REDIRECTION.payMode.order && REDIRECTION.payMode.order.length > 0) {
      if (merchantPaymodesPreferenceOrder) {
        input.merchantPayModes = common_updatePaymodes(REDIRECTION.payMode.order, merchantPaymodesPreferenceOrder);
      } else {
        input.merchantPayModes = REDIRECTION.payMode.order;
      }
    } else {
      input.merchantPayModes = common_parsePaymodes(merchantPaymodesPreferenceOrder);
    }
    if (input.merchantPayModes) {
      input.merchantPayModes = input.merchantPayModes.filter(function (item) {
        return item.type == constants["n" /* default */].NB || item.type == constants["n" /* default */].UPI || item.type == constants["n" /* default */].CARD || item.type == constants["n" /* default */].EMI;
      });
    }

    input.MobileTheme = { LIGHTTHEME: constants["h" /* LIGHTTHEME */], DARKTHEME: constants["c" /* DARKTHEME */], CUSTOMTHEME: customThemeMob };
    input.WebTheme = { LIGHTTHEME: constants["h" /* LIGHTTHEME */], DARKTHEME: constants["c" /* DARKTHEME */], CUSTOMTHEME: customThemeWeb };

    input.customBar = constants["a" /* CUSTOMBAR */];
    input.isMobilePreviewSelected = true;
    input.timestamp = new Date().getTime();
  } else {
    input.isError = true;
    input.errorMSG = 'Opps! Something went wrong (Invalid Data).';
  }

  return input;
};

var _preventDefault = function _preventDefault(event) {
  event.preventDefault();
  event.stopPropagation();
  return false;
};

/**
 * is value is `null` or `undefined`
 * @param {any} val - any value
 */
var _isNullOrUndefined = function _isNullOrUndefined(val) {
  return val === undefined || val === null;
};

/**
 * log the event type and values
 * @param {String} eventType - type of event
 * @param {String} value - event value
 * @param {String} otherObj - other object to log
 */
var _log = function _log(eventType, value) {
  var otherObj = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var pushEvent = window && window.UILogger || undefined;
  pushEvent && pushEvent.log && pushEvent.log(_extends({ eventType: eventType, eventValue: value }, otherObj));
};

var buttonTypes = [constants["k" /* QuickButton */], constants["g" /* DonateButton */]],
    //customButton
buttonSize = [constants["l" /* SmallButtonSize */], constants["j" /* MediumButtonSize */], constants["i" /* LargeButtonSize */]],
    buttonTypeField = {
  placeholder: 'Button Type',
  type: 'Dropdown',
  constraints: {
    maxLength: '200',
    minLength: '3',
    allowedValues: buttonTypes
  },
  orientation: 'H',
  size: '100',
  isEditable: false,
  display: true
},
    buttonTitleField = {
  placeholder: 'Button Title',
  type: 'Text',
  constraints: {
    maxLength: constants["n" /* default */].SHORT_TEXT_MAX_CHAR,
    minLength: '3'
  },
  orientation: 'H',
  size: '100',
  isEditable: false
},
    buttonStyleField = {
  placeholder: 'Button Style',
  type: 'ColorButton',
  orientation: 'H',
  size: '50',
  isEditable: false,
  display: true
},
    buttonTextField = {
  placeholder: 'Button Font Color',
  type: 'ColorButton',
  orientation: 'H',
  size: '50',
  isEditable: false,
  display: true
},
    buttonSizeField = {
  placeholder: 'Button Size',
  type: 'RadioInput',
  constraints: {
    maxLength: '200',
    minLength: '3',
    allowedValues: buttonSize
  },
  orientation: 'H',
  size: '100',
  isEditable: false,
  display: true
},
    buttonPurposeField = {
  placeholder: 'Purpose of Payment',
  type: 'Text',
  hint: 'This will be shown to your customers when they make a payment',
  constraints: {
    maxLength: constants["n" /* default */].SHORT_TEXT_MAX_CHAR,
    minLength: '3'
  },
  orientation: 'H',
  size: '100',
  isEditable: false,
  name: 'Purpose of Payment'
};

var getButtons = function getButtons() {
  return {
    QUICK: {
      BUTTON: {
        type: 'QUICK',
        name: 'Quick-Pay Button',
        bgImage: 'quick-btn.png'
      },
      STEPS: {
        STEP1: {
          id: 1,
          name: 'Button Details',
          fields: {
            buttonType: buttonTypeField,
            buttonTitle: buttonTitleField,
            buttonStyle: buttonStyleField,
            buttonText: buttonTextField,
            buttonSize: buttonSizeField,
            buttonAmount: {
              placeholder: 'Add Your Amount',
              type: 'Amount',
              hint: 'Your customers will pay this amount to you',
              constraints: {
                maxLength: '10000000',
                minLength: '0'
              },
              orientation: 'H',
              size: '100',
              isEditable: false,
              name: 'Amount'
            },
            buttonPurpose: buttonPurposeField
          },
          nextStepButton: {
            placeholder: 'Proceed to Collect Customer Details',
            type: 'nextStepButton'
          }
        },
        STEP2: { id: 2, name: 'Collect Customer Details' },
        STEP3: { id: 3, name: 'Review Details' }
      }
    },
    DONATE: {
      BUTTON: {
        type: 'DONATE',
        name: 'Donate Button',
        bgImage: 'donate-btn.png'
      },
      STEPS: {
        STEP1: {
          id: 1,
          name: 'Button Details',
          fields: {
            buttonType: buttonTypeField,
            buttonTitle: buttonTitleField,
            buttonStyle: buttonStyleField,
            buttonText: buttonTextField,
            buttonSize: buttonSizeField,
            buttonPurpose: _extends({}, buttonPurposeField, {
              hint: 'This will be shown to your customers when they make a payment'
            })
          },
          nextStepButton: {
            placeholder: 'Proceed to Donation Amount',
            type: 'nextStepButton'
          }
        },
        STEP2: { id: 2, name: 'Donation Amount' },
        STEP3: { id: 3, name: 'Donor Details' },
        STEP4: { id: 4, name: 'Review Details' }
      }
    }
    // CUSTOM: {
    //   BUTTON: {
    //     type: 'CUSTOM',
    //     name: 'Custom Button',
    //     bgImage: 'custom-btn.png'
    //   },
    //   STEPS: {
    //     STEP1: {
    //       id: 1,
    //       name: 'Button Details',
    //       fields: {
    //         buttonType: buttonTypeField,
    //         buttonTitle: buttonTitleField,
    //         buttonStyle: buttonStyleField,
    //         buttonText: buttonTextField,
    //         buttonSize: buttonSizeField,
    //         buttonPurpose: {
    //           ...buttonPurposeField,
    //           hint: 'This will be shown to your customers when they make a payment'
    //         }
    //       },
    //       nextStepButton: {
    //         placeholder: 'Proceed to Amount \u0026 Customer Details',
    //         type: 'nextStepButton'
    //       }
    //     },
    //     STEP2: { id: 2, name: 'Amount \u0026 Customer Details' },
    //     STEP3: { id: 3, name: 'Review Details' }
    //   }
    // }
  };
};

var common_getSelectedButtonDetails = function getSelectedButtonDetails(data) {
  if (getObjectKey(data, 'buttonDetails.buttonType')) {
    var buttonDetails = _extends({}, getObjectKey(data, 'buttonDetails'));
    buttonDetails['buttonType'] = buttonTypes.filter(function (obj) {
      return obj.type === buttonDetails['buttonType'];
    })[0] || constants["k" /* QuickButton */];
    buttonDetails['buttonSize'] = buttonSize.filter(function (obj) {
      return obj.type === buttonDetails['buttonSize'];
    })[0] || constants["i" /* LargeButtonSize */];
    buttonDetails['buttonPurpose'] = getObjectKey(data, 'description');
    if (getObjectKey(data, 'amount', '')) {
      buttonDetails['buttonAmount'] = numberWithoutCommas(getObjectKey(data, 'amount', ''));
    }
    return buttonDetails;
  }
  return {};
};

var donateButtonDefaultFields = function donateButtonDefaultFields(data) {
  var nameField = data.suggestedFields.filter(function (field) {
    if (field && field.name === 'Full Name') {
      return field;
    }
  });

  var mobileField = data.suggestedFields.filter(function (field) {
    if (field && field.name === 'Mobile Number') {
      return field;
    }
  });

  var emailField = {
    constraints: { maxLength: 200, minLength: 3 },
    displayText: '',
    helpText: '',
    isEditable: true,
    name: 'Email ID',
    orientation: 'H',
    size: '100',
    type: 'Text',
    mandatory: false
  };

  return [].concat(nameField, [emailField], mobileField);
};

var common_parsePaymentButton = function parsePaymentButton() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  initiateLogger('MerchantPaymentButton', input && input.body && input.body.mid || '', {
    BUTTON_TYPE: input && input.body && input.body.linkId ? 'EDIT_BUTTON' : 'CREATE_BUTTON'
  });
  var dataObject = { inDelible: {} };
  var data = input.body || {},
      customPlaceHolder = { name: constants["n" /* default */]['CUSTOM_DESC'], type: constants["n" /* default */].CUSTOM },
      initialdropdownFields = [];

  if (data.suggestedFields && data.suggestedFields.length > 0) {
    parseSuggestedField(data.suggestedFields);
    initialdropdownFields = data.suggestedFields.map(function (field) {
      dataObject.inDelible[field.name] = false;
      return field;
    });
  } else {
    data['suggestedFields'] = [];
  }

  dataObject['donateDefaultFields'] = donateButtonDefaultFields(data);
  dataObject['paymentButtons'] = getButtons();
  dataObject['buttonConfig'] = common_getSelectedButtonDetails(data);
  dataObject['selectedButton'] = dataObject['buttonConfig']['buttonType'] || {};
  dataObject['activeStep'] = Object.keys(dataObject['buttonConfig']).length > 1 ? 'STEP1' : 'NONE';
  dataObject['fields'] = data.fields || [];
  dataObject['givenFields'] = [customPlaceHolder].concat(initialdropdownFields);
  dataObject['displayedTooltip'] = '';
  dataObject['displayedPopup'] = '';
  dataObject['merchantInfo'] = {
    name: getObjectKey(data, 'merchantName', ''),
    logoURL: getObjectKey(data, 'logo', '')
  };
  dataObject['activeScreen'] = constants["n" /* default */]['BUTTON_SCREEN'];
  dataObject['customPaymentSuccessMessage'] = data.customPaymentSuccessMessage;
  dataObject['redirectionUrlFailure'] = data.redirectionUrlFailure;
  dataObject['redirectionUrlSuccess'] = data.redirectionUrlSuccess;
  dataObject['customFieldsValidationErrors'] = {};
  Object(cache["set"])(constants["n" /* default */].MID, data.mid);
  Object(cache["set"])(constants["n" /* default */].TOKEN, data.token);
  return dataObject;
};

var filterAmountFields = function filterAmountFields(fields) {
  if (Array.isArray(fields)) {
    return fields.filter(function (field) {
      return common_isAmountField(field);
    });
  }
  return [];
};

var filterInfoFields = function filterInfoFields(fields) {
  if (Array.isArray(fields)) {
    return fields.filter(function (field) {
      return !common_isAmountField(field);
    });
  }
  return [];
};

var common_isAmountField = function isAmountField(field) {
  var fieldType = field && field.type;
  if (fieldType === constants["n" /* default */]['CUSTOM_AMOUNT_MERCHANT'] || fieldType === constants["n" /* default */]['CUSTOM_AMOUNT_FLEXIBLE'] || fieldType === constants["n" /* default */]['CUSTOM_AMOUNT_QUANTATIVE']) {
    return true;
  }
  return false;
};

var common_isInputInvalid = function isInputInvalid(value, min, max, type) {
  if (type === constants["n" /* default */]['TEXT']) {
    if (!value || value && (value.length < min || value.length > max)) {
      return true;
    }
  } else if (type === constants["n" /* default */]['NUMBER']) {
    if (!value || Number(value) && (Number(value) < min || Number(value) > max)) {
      return true;
    }
  } else if (type === constants["n" /* default */].CUSTOM_AMOUNT_MERCHANT) {
    value = Number(value.replace(/[^0-9]/g, ''));
    if (isNaN(value) || value <= min || value >= max) {
      return true;
    }
  } else if (type === constants["n" /* default */]['URL']) {
    if (!value.match(constants["n" /* default */]['URL_REGEX'])) {
      return true;
    }
  }
  return false;
};

var common_parseHeaderData = function parseHeaderData(input) {
  var data = {};
  if (input) {
    var isZeroAmount = (input.upfrontTxnAmount && Number(input.upfrontTxnAmount)) === 0;
    data.upFrontAmount = input.upfrontTxnAmount;
    data.isZeroAmount = isZeroAmount;
    data.payableAmount = isZeroAmount ? constants["n" /* default */].SUBS_MIN_AMOUNT : input.upfrontTxnAmount;
    data.nextBilling = input.nextRenewalDate;
    data.merchantName = input.merchantName;
    data.mid = input.mid;
    data.logoURL = input.merchantLogo;
  }
  return data;
};

var common_parseSubscriptionData = function parseSubscriptionData(input) {
  var data = {};
  if (input) {
    data.name = input.customerName;
    data.mobile = input.customerPhoneNo;
    data.email = input.customerEmail;
    data.planName = input.linkName;
    data.planDescription = input.linkDescription;
    data.frequency = input.frequencyUnit;
    data.nextBilling = input.nextRenewalDate;
    data.endDate = input.subscriptionEndDate;
    data.upFrontAmount = input.upfrontTxnAmount;
    data.planAmount = input.amountType === constants["n" /* default */].AMOUNT_FIXED ? input.renewalAmount : input.maxAmount;
    data.renewalAmount = input.amountType === constants["n" /* default */].AMOUNT_VARIABLE ? input.maxAmount : input.renewalAmount;
    data.amountType = input.amountType;
    data.subscriptionStatus = input.subscriptionStatus;
    data.trialPeriod = input.trialPeriod; // Number(input.trialPeriod);
    data.merchantDetails = { name: input.merchantName, mobile: input.merchantPhoneNo, email: input.merchantEmail };
  }
  return data;
};

var common_parseSubscriptionAppData = function parseSubscriptionAppData(input) {
  var appData = JSON.parse(JSON.stringify(input));
  delete appData.customerPhoneNo;
  delete appData.customerEmail;
  delete appData.customerName;
  var paymentDetails = getObjectKey(appData, 'paymentDetails', []);
  for (var i = 0; i < paymentDetails.length; i++) {
    delete paymentDetails[i].customerMobileNo;
    delete paymentDetails[i].customerEmailId;
    delete paymentDetails[i].cardNo;
  }
  return appData;
};

var rupeeSymbol = function rupeeSymbol() {
  var rupee = '₹';
  if (typeof String.fromCodePoint === 'function') {
    rupee = String.fromCodePoint(0x20b9);
  }
  return rupee;
};

var common_getHeaderLogoUrl = function getHeaderLogoUrl(onInvertImgLogo, themeColor) {
  var logo = '';
  if (constants["m" /* THEME_CONSTANTS */].DARK == themeColor.NAME) {
    logo = 'logo-white.svg';
  } else if (constants["m" /* THEME_CONSTANTS */].LIGHT == themeColor.NAME) {
    logo = 'logo-blue.svg';
  } else if (onInvertImgLogo) {
    logo = 'logo-white.svg';
  } else {
    logo = 'logo-blue.svg';
  }
  return _getStaticPath() + '/assets/images/' + logo;
};

/* harmony default export */ var common = __webpack_exports__["a"] = ({
  getStaticPath: _getStaticPath,
  getIframeOrigin: _getIframeOrigin,
  parseData: common__parseData,
  preventDefault: _preventDefault,
  isNullOrUndefined: _isNullOrUndefined,
  log: _log,
  getEnv: _getEnv,
  isWindowDefined: isWindowDefined,
  themeParse: common__themeParse,
  checkoutParse: common__checkoutParse,
  getAmountFieldFirstIndex: getAmountFieldFirstIndex,
  initiateLogger: initiateLogger,
  parsePaymentButton: common_parsePaymentButton,
  filterAmountFields: filterAmountFields,
  filterInfoFields: filterInfoFields,
  isInputInvalid: common_isInputInvalid,
  parseAmountFields: parseAmountFields,
  isAmountField: common_isAmountField,
  parseHeaderData: common_parseHeaderData,
  parseSubscriptionData: common_parseSubscriptionData,
  parseSubscriptionAppData: common_parseSubscriptionAppData,
  rupeeSymbol: rupeeSymbol,
  getHeaderLogoUrl: common_getHeaderLogoUrl
});

/***/ }),

/***/ "2gTp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function invariant(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;

/***/ }),

/***/ "4gcd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;

  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),

/***/ "5D9O":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("wVGV")();
}

/***/ }),

/***/ "7+MJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"view-tab":"_1nWz","view-list":"_28sn","view-item":"_22mJ","active":"_2Djw","cross":"_zeLK","left":"_NfcG","right":"_1KbE","pos-r":"_1tY6","pos-a":"_1Lef"};

/***/ }),

/***/ "7N8r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (load) {
	function Async() {
		var _this = this;

		_preact.Component.call(this);
		var done = function done(child) {
			_this.setState({ child: child && child.default || child });
		};
		var r = load(done);
		if (r && r.then) r.then(done);
	}
	Async.prototype = new _preact.Component();
	Async.prototype.constructor = Async;
	Async.prototype.render = function (props, state) {
		return (0, _preact.h)(state.child, props);
	};
	return Async;
};

var _preact = __webpack_require__("KM04");

/***/ }),

/***/ "7Tn3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"comp-name":"_1vZQ","theme-colorbox":"_30PC","color-code":"_2xlm","theme-card":"_7zkd","hash-code":"_oPkR"};

/***/ }),

/***/ "7YO4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);

/***/ }),

/***/ "Asjh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),

/***/ "BMrJ":
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var memoize = function memoize(fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = function (fn) {
	var memo = {};

	return function (selector) {
		if (typeof memo[selector] === "undefined") {
			memo[selector] = fn.call(this, selector);
		}

		return memo[selector];
	};
}(function (target) {
	return document.querySelector(target);
});

var singleton = null;
var singletonCounter = 0;
var stylesInsertedAtTop = [];

var fixUrls = __webpack_require__("DRTY");

module.exports = function (list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if (newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if (domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j]();
				}delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom(styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if (domStyle) {
			domStyle.refs++;

			for (var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for (; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for (var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts };
		}
	}
}

function listToStyles(list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = { css: css, media: media, sourceMap: sourceMap };

		if (!newStyles[id]) styles.push(newStyles[id] = { id: id, parts: [part] });else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement(options, style) {
	var target = getElement(options.insertInto);

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if (idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement(options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs(el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle(obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
		result = options.transform(obj.css);

		if (result) {
			// If transform returns a value, use that instead of the original css.
			// This allows running runtime transformations on the css.
			obj.css = result;
		} else {
			// If the transform function returns a falsy value, don't add this css.
			// This allows conditional loading of css
			return function () {
				// noop
			};
		}
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);
	} else if (obj.sourceMap && typeof URL === "function" && typeof URL.createObjectURL === "function" && typeof URL.revokeObjectURL === "function" && typeof Blob === "function" && typeof btoa === "function") {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function remove() {
			removeStyleElement(style);

			if (style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function remove() {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if (newObj) {
			if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
}();

function applyToSingletonTag(style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag(style, obj) {
	var css = obj.css;
	var media = obj.media;

	if (media) {
		style.setAttribute("media", media);
	}

	if (style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while (style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink(link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
 	If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
 	and there is no publicPath defined then lets turn convertToAbsoluteUrls
 	on by default.  Otherwise default to the convertToAbsoluteUrls option
 	directly
 */
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if (oldSrc) URL.revokeObjectURL(oldSrc);
}

/***/ }),

/***/ "DRTY":
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
	// get current location
	var location = typeof window !== "undefined" && window.location;

	if (!location) {
		throw new Error("fixUrls requires window.location");
	}

	// blank or null?
	if (!css || typeof css !== "string") {
		return css;
	}

	var baseUrl = location.protocol + "//" + location.host;
	var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
 This regular expression is just a way to recursively match brackets within
 a string.
 	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
    (  = Start a capturing group
      (?:  = Start a non-capturing group
          [^)(]  = Match anything that isn't a parentheses
          |  = OR
          \(  = Match a start parentheses
              (?:  = Start another non-capturing groups
                  [^)(]+  = Match anything that isn't a parentheses
                  |  = OR
                  \(  = Match a start parentheses
                      [^)(]*  = Match anything that isn't a parentheses
                  \)  = Match a end parentheses
              )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
  \)  = Match a close parens
 	 /gi  = Get all matches, not the first.  Be case insensitive.
  */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl.trim().replace(/^"(.*)"$/, function (o, $1) {
			return $1;
		}).replace(/^'(.*)'$/, function (o, $1) {
			return $1;
		});

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
			return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
			//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};

/***/ }),

/***/ "FZsR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Sortable = __webpack_require__("vV8Q").default;

module.exports = Sortable;

/***/ }),

/***/ "GAtr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"view-tab":"_2AKw","view-list":"_169p","view-item":"_3O4v","active":"_1tax"};

/***/ }),

/***/ "GcWV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"logo-upload-section":"_1SKq","heading":"_3_97","helper-text":"_2-yG","upload-section":"_1Hji","upload-button":"_hNLa","upload-button-label":"_zmgd","selected-logo":"_2rfF","selected-logo-name":"_14zP","fileup":"_-FLk","upload-logo":"_2ZOE","close-button":"_1Aa_","logo-upload-input":"_3xFS","error":"_32TX","button-container":"_2X0t","reset-button-container":"_2K3o"};

/***/ }),

/***/ "HJKR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tab-content":"_OvMM","mer-name":"_3K2_","ptm-head-logo":"_30KT","sc-img":"_2qTh","ptm-logo":"_2zAX","grid-wrap":"_31_R","grid-inner":"_2rZV","grid":"_UvT6","pay-method":"_237N","grid-img":"_3_1n","mobile-wrap":"_3y1L","m-header":"_2Hww","amount-txt":"_rcCI","amount-para":"_2tCf","amount":"_2tZL","backSection":"_2xsK","arrow":"_2qwF","back":"_21KM","m-content":"_1cSq","select-txt":"_2NTQ","choose-txt":"_287g","pay-mode-wrap":"_1X_9","pay-list-wrap":"_bBPT","pay-list":"_1Hgx","border-div":"_2a4_","radio-circle":"_2sGA","m-footer":"_14lI","dark-border":"_KfsX","secure":"_12Ki","default":"_2irH","header":"_2Kf4","header-top":"_31of","head-select":"_riun","header-bottom":"_1QkQ","logo-amount":"_3ym4","mer-logo":"_2ECK","user-bg":"_3ROg","brand-logo":"_2cMV","subheading":"_2HKB","cross-wrap":"_7EvE","cross":"_29N7","cross-line1":"_Dz8A","cross-line2":"_39Zg","payBtnWrap":"_vXZm","payBtn":"_1pgO","payBtnimg":"_2hDO","cardtype":"_130C","wallet":"_3VLV","wallet-inner":"_iy5x","check":"_3bGP","sign1":"_3ks3","sign2":"_3X5X","check-txt":"_3XjN","w100":"_1jFz","wallet-txt":"_1ju8","wallet-para":"_3FXx"};

/***/ }),

/***/ "JKLE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/history/createBrowserHistory.js
var createBrowserHistory = __webpack_require__("wJDa");
var createBrowserHistory_default = /*#__PURE__*/__webpack_require__.n(createBrowserHistory);

// EXTERNAL MODULE: ./checkout/style/style.css
var style = __webpack_require__("07fW");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ../node_modules/unistore/preact.js
var preact = __webpack_require__("o6ac");
var preact_default = /*#__PURE__*/__webpack_require__.n(preact);

// CONCATENATED MODULE: ../node_modules/unistore/dist/unistore.es.js
function n(n, t) {
  for (var r in t) {
    n[r] = t[r];
  }return n;
}/* harmony default export */ var unistore_es = (function (t) {
  var r = [];function u(n) {
    for (var t = [], u = 0; u < r.length; u++) {
      r[u] === n ? n = null : t.push(r[u]);
    }r = t;
  }function e(u, e, f) {
    t = e ? u : n(n({}, t), u);for (var i = r, o = 0; o < i.length; o++) {
      i[o](t, f);
    }
  }return t = t || {}, { action: function action(n) {
      function r(t) {
        e(t, !1, n);
      }return function () {
        for (var u = arguments, e = [t], f = 0; f < arguments.length; f++) {
          e.push(u[f]);
        }var i = n.apply(this, e);if (null != i) return i.then ? i.then(r) : r(i);
      };
    }, setState: e, subscribe: function subscribe(n) {
      return r.push(n), function () {
        u(n);
      };
    }, unsubscribe: u, getState: function getState() {
      return t;
    } };
});
//# sourceMappingURL=unistore.es.js.map
// EXTERNAL MODULE: ./utils/i18n.js
var i18n = __webpack_require__("LnyB");

// CONCATENATED MODULE: ./locale/en.js
var _en = {};

_en.createForm = {
  'header.title': 'Create template',
  'header.description': 'Templates can be saved and reused.',
  'header.details.description': 'You can add up to 20 fields.',
  'custInfo.heading': 'Capture Additional Information from customer',
  'linkInfo.placeholder': 'Description',
  'templateName.placeholder': 'Template Name',
  'linkInfo.helpText': 'You can enter instructions for filling the details. This would be shown to the user before filling the details.',
  'define.amount': 'Define how customer Pays you',
  'collect.additional': 'Collect Additional Information from customer',
  'addField': '+ Add Information Field',
  'template.details': 'Template Details',
  'payment.details': 'Define how customer Pays you',
  'amountField': '+ Add Type of Amount Field',
  'select.info.field': 'Select customer information type',
  'edit.header.title': 'Edit payment template'
};

_en.addField = {
  'header.title': 'Add field for customer information',
  'header.description': 'You can either select from the suggested list or create a custom field.',
  'customField.button': '+ Add Another option',
  'button': 'Add field',
  'errMsg': 'You can add upto 10 fields in a template',
  'customField.one.button': '+ Add option',
  'save.field': 'Save field',
  'field.details': 'Add Field details',
  'option.prefix': 'Option',
  'another.info': '+ Add Another Information Field',
  'another.amount': '+ Add Another Amount Field',
  'select.info.field': 'Select customer information type',
  'select.amount.field': 'Select Type of Amount Field',
  'feild.validation': 'FIELD VALIDATION'
};

_en.amountField = {
  'header.title': 'Add Custom Amount field',
  'header.description': 'You can choose between the given amount types and customize it',
  subHeading: 'Type of Amount Field',
  'quantity.amount': 'SET ORDER QUANTITY LIMITS',
  'flexible.amount': 'SET ALLOWED AMOUNT THAT YOUR CUSTOMERS CAN ENTER',
  error: "can't be greater than",
  'edit.button': 'Save field',
  'edit.title': 'Edit field',
  'edit.description': 'You can customize the field according to your business requirement',
  'fixed.description': 'Customer pays the amount entered by you',
  'amount.description': 'Set a price for your product or service. Your customers will be able to choose the quantity',
  'flexible.description': 'Your customer can choose the amount they wish to pay',
  'select.amount.field': 'Select Type of Amount Field',
  'amount.greater.error': 'Min Quantity can\'t be greater than Max Quantity',
  'mandatory.quantity': 'For mandatory Add product or service field, min quantity must be greater than 0',
  'min.amount': 'Min Amount',
  'max.amount': 'Max Amount',
  'min.quantity': 'Min Quantity',
  'max.quantity': 'Max Quantity',
  'amount.min.max.error': 'Min Amount can\'t be greater than Max Amount',
  optional: 'Optional'
};

_en.customDate = {
  'invalid.error': "Min Date can't be greater than Max Date",
  'min.date': 'Min Date',
  'max.date': 'Max Date'
};

_en.createField = {
  'mandatory.label': 'It is mandatory for the customer to fill this field',
  'help.label': 'I want to add a help text for this field',
  'maxDate.label': 'Your customers will not be able to select a date greater than the day of payment',
  'minDate.label': 'Your customers will not be able to select a date lesser than the day of payment',
  'date.label': 'Transaction Date',
  'select.field.validation': 'Select Field Validation',
  'short.text': 'upto 30 chars',
  'long.text': 'upto 200 chars',
  'fixed.length': 'Fixed Length',
  'custom.empty.error': 'Please choose a field validation',
  'custom.no.options.error': 'Please add dropdown options',
  'custom.two.options.error': 'Please add at least two options',
  'view.field.preview': 'View field preview',
  text: 'Text',
  numeric: 'Numeric',
  dropdown: 'Dropdown',
  date: 'Date',
  field: 'field'
};

_en.static = {
  'dialog.info': 'Remove Field',
  'dialog.description': 'Are you sure you want to remove the field from the list of suggestions?',
  'dialog.yes': 'Confirm',
  'yes': 'Yes',
  'change.button': 'Change Button Type',
  'confirmation': 'All changes would be lost. Do you want to proceed?',
  'dialog.no': 'Cancel',
  'deleteApi.failMsg': 'The chosen field is not deleted. Please retry again...',
  'saveApi.failMsg': 'The form is not submitted. Please retry again...',
  'characters.remaining': 'characters remaining',
  'editField.header.title': "Edit field",
  'editField.header.description': "You can customize the field according to your business requirement",
  'update.links': 'Update Links',
  'template.updated': 'Template Updated successfully',
  'template.update.msg': 'This template has been attached to the following payment links. Please select the links you want to update with the current template.',
  'not.now': 'Not Now',
  'update.pages': 'Update Links',
  'update.single.page': 'Update 1 Link',
  'update.multiple.pages': 'Update $pages Links',
  'empty.error': 'can\'t be empty',
  'rang.error': 'should be between $min to $max characters',
  'valid.text.error': 'Please enter valid text',
  'add.a.field': 'Please add fields',
  'template.updated.msg': 'Template updated successfully',
  'retry': 'Retry',
  'oops.error': 'Oops! Something went wrong'
};

_en.default = { error: 'Something went wrong...' };

_en.step2 = {
  title: 'JS Code',
  desc: 'Embed the JS Snippet below (in the body section of your HTML) for the customisation to take place.',
  copy: 'Copy JS Snippet',
  copied: 'Code Copied !!!',
  'copied.opps': 'Oops, unable to copy',
  'server.integration': 'Server Integration',
  'server.desc': 'View detailed configurations and documentation at our'
};

_en.theme = {
  note: 'Please Note',
  'note.desc': 'Same settings will be applied to both integrations.',
  title: 'Checkout Page Customization',
  'save.error': 'Please enter correct color code or choose from color picker',
  'display.secure.label': 'Display "Secured payments powered by Paytm"',
  'display.secure.desc': 'Displaying payments powered by Paytm helps sustain user\'s trust in payments and results in higher success rates.',
  'autologin.label': 'Support auto-login into Paytm',
  'autologin.desc': 'Auto-logging into Paytm allows users to quickly access 200M+ saved cards with Paytm resulting in faster checkouts.',
  'sort.paymodes': 'Sort payment instruments',
  'select.theme': 'Select theme for your checkout page',
  'default.order': 'Default specified by Paytm',
  'customize.order': 'Customize order',
  'save.setting': 'Save Settings',
  'sort.paymode.title': 'Drag and drop to re-order payment instruments',
  'save.success': 'Theme saved successfully',
  'checkout.tab': 'JS Checkout',
  'redirection.tab': 'Checkout',
  mobile: 'Mobile',
  'gradient.label': 'Gradient effect',
  'gradient.desc': 'A subtle style effect which makes the colour of the header and the pay button fade out from top to bottom',
  'invert.logo.label': 'Invert Logo',
  'invert.logo.desc': 'All-In-One Paytm logo can be customized as per theme',
  'select.color.head': 'Select color for different components of checkout page'
};

_en.checkout = {
  title: 'JS Checkout',
  preview: 'Preview',
  'checkout.tab': 'JS Checkout',
  'redirection.tab': 'Checkout',
  mobile: 'Mobile',
  web: 'Web',
  'generate.code': 'Generate JS Code',
  'get.api': 'Get API Keys'
};

_en['button'] = {
  'add': 'Add',
  "create": "Create a Button",
  "create.info": "Customers will see this button to initiate Payment",
  "skip.to.review": "Skip to Review Detail",
  "proceed.to.review": "Proceed to Review Details",
  "proceed.donor": "Proceed to Donor Details",
  "donate.default.text": "Donate an amount of your choice",
  "donate.min.max.amount": "Set min and max amount limit",
  "amount.to.pay": "Amount to be paid",
  "pay": "Proceed to Pay",
  "next": "Next",
  "custom.msg": "Show a Cutom Message",
  "redirect.url": "Redirect URL",
  "automated.receipt": "Send automated Payment Receipts",
  "payment.reciept": "Send automated Payment Receipts",
  "custom.msg.info": "This message is shown after Successful payment and on Payment receipt",
  "redirect.url.info": "The customer would be redirected to this URL after Successful payment",
  "payment.reciept.info": "We will send payment confirmation receipt to customer",
  "success.placholder": "Enter Payment Success Message",
  "fail.placholder": "Enter Payment Failure Message",
  "success.url.placholder": "Enter Payment Success Redirect URL",
  "fail.url.placholder": "Enter Payment Failure Redirect URL",
  "URL.error": "Please enter a valid URL",
  "no.preview": "No preview",
  "page.preview": "Payment page Preview",
  "no.preview.info.line1": "Add fields to view preview.",
  "no.preview.info.line2": "Amount fields can be used to list your products. You can also add more fields to collect additional information from your customers.",
  "preview.btn": "Button preview",
  "no.btn.preview.info": "Select a Button Type to see preview",
  'create.button': 'Create Button',
  'save': 'Save',
  'save.template': 'Save template',
  'proceed': 'Proceed',
  'select.btn': 'Select a Button Type',
  'select.btn.help': 'Pick a button which meets your requirements and get a head start on collecting payments',
  'pay.now': 'Pay Now',
  "field.name": "Field Name",
  "enter.field.name": "Enter Field Name",
  "enter.help.text": "Enter help Text",
  "after.payment": "After a Successful Payment",
  "after.payment.help": 'Custom Message & Redirect URL',
  "donate.title": "Donate Now",
  "max.amt.error": "Maximum amount should be more than minimum amount",
  "no.amt": "No amount Limits",
  'min.amount': 'Minimum Amount',
  'max.amount': 'Maximum Amount',
  'edit.button': 'Edit Button',
  'update.button': 'Update Button'
};
_en['preview'] = {
  "payment.details": "Payment Details"
};

_en.subscription = {
  name: 'Name',
  email: 'Email',
  mobile: 'Mobile',
  'subscription.at': 'Your Subscription at',
  'subscription.for': 'subscription for',
  'subscription.details': 'subscription details',
  'your.subs': 'Your Subscription at',
  'plan.desc': 'Plan Name and Description',
  'plan.amount': 'Plan Amount',
  'next.bill': 'Next Billing Date',
  'valid.till': 'Subscription Valid Till',
  'first.payment': 'FIRST PAYMENT',
  'next.payment': 'NEXT PAYMENTS',
  'footer.text': '100% Secure Payments Powered by Paytm',
  upto: 'upto',
  'pay.info': 'IMPORTANT: Please ensure that you only pay to merchants you already know. Never make a payment to a non-trusted merchant for offers or prizes as it may be a scam',
  'next.on.demand': 'Upto \u20B9$amount will be charged until the subscription is valid',
  'next.fixed.interval': '$frequency after the first payment upto \u20B9$amount will be charged until the subscription is valid',
  'first.amount': 'Amount',
  inclusive: '(inclusive of one time charge)',
  'upto.min': 'upto \u20B9$amount may be deducted from your bank',
  'is.active': 'Your subscription is active',
  'trial.period': 'TRIAL PERIOD',
  'trial.text': '$time day trial period',
  DAY: ' Per Day',
  MONTH: ' Per Month',
  YEAR: ' Per Year',
  WEEK: ' Per Week',
  QUARTER: ' Every Quarter',
  BI_MONTHLY: ' Every 2 Months',
  SEMI_ANNUALLY: ' Every Half-year',
  FORTNIGHT: ' Every Fortnight',
  'show.more': 'Show more',
  'merchant.name': 'Merchant name',
  'confirm.cancel': 'Confirm Cancellation',
  'cancel.warning': 'If you cancel now, you can still access your subscription till',
  'cancel.msg': 'You can still access your subscription till',
  'okay.got.it': 'Ok. got it',
  'proceed.cancel': 'Proceed to Cancel',
  'not.now': 'Not Now',
  'mobile.number': 'Mobile Number',
  update: 'Update',
  'update.mobile': 'Update Mobile No.',
  'verify.number': 'Verify Mobile Number',
  'enter.otp.mobile': 'Enter OTP sent to mobile no.',
  otp: 'One Time Password (OTP)',
  'resend.otp': 'Resend OTP',
  confirm: 'Confirm',
  'failed.resend.otp': 'Failed to resend OTP. No attempts left!',
  'sent.success': 'OTP resent Successfully.',
  'attempt.left': 'attempt left',
  contact: 'Contact Merchant',
  'pay.history': 'Payment History',
  cancel: 'Cancel Subscription',
  'invalid.otp': 'Please enter a valid OTP',
  'email.id': 'Email ID',
  'update.email': 'Update Email ID',
  'proceed.to.pay': 'Proceed to Pay',
  'amount.to.paid': 'Amount to be paid',
  'oops.error': 'Oops! Something went wrong',
  retry: 'Retry'
};

/* harmony default export */ var en = (_en);
// EXTERNAL MODULE: ./common/cache.js
var cache = __webpack_require__("WsRd");
var cache_default = /*#__PURE__*/__webpack_require__.n(cache);

// EXTERNAL MODULE: ./common/common.js + 2 modules
var common = __webpack_require__("2UA+");

// EXTERNAL MODULE: ./common/postMessage.js
var postMessage = __webpack_require__("em/f");

// EXTERNAL MODULE: ./checkout/components/steps/style.css
var steps_style = __webpack_require__("fgEf");
var steps_style_default = /*#__PURE__*/__webpack_require__.n(steps_style);

// EXTERNAL MODULE: ./controller/theme_checkout/index.js
var theme_checkout = __webpack_require__("/TZ0");

// CONCATENATED MODULE: ./checkout/components/steps/index.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var steps_Steps = function (_Component) {
  _inherits(Steps, _Component);

  function Steps(props) {
    _classCallCheck(this, Steps);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.goBackStep = function (e) {
      e.preventDefault();
      if (_this.props && _this.props.isGenerateCodeStepEnabled && _this.props.onKeyValueChange) {
        common["a" /* default */].log('onClick', 'STEP 1');
        _this.props.onKeyValueChange('isGenerateCodeStepEnabled', false);
      }
    };

    return _this;
  }

  Steps.prototype.render = function render(_ref) {
    var isGenerateCodeStepEnabled = _ref.isGenerateCodeStepEnabled;

    return Object(preact_min["h"])(
      'div',
      { className: '' + steps_style_default.a['stage-wrap'] },
      Object(preact_min["h"])(
        'div',
        {
          className: steps_style_default.a.steps + ' ' + steps_style_default.a[isGenerateCodeStepEnabled ? 'cursor' : 'active'],
          onClick: this.goBackStep
        },
        Object(preact_min["h"])(
          'p',
          { className: '' + steps_style_default.a['steps-txt'] },
          'STEP 1',
          isGenerateCodeStepEnabled && Object(preact_min["h"])('img', {
            src: common["a" /* default */].getStaticPath() + '/assets/ic-check-cirlce.svg',
            className: '' + steps_style_default.a['succ-icon'],
            alt: ''
          })
        ),
        Object(preact_min["h"])(
          'p',
          { className: steps_style_default.a['steps-subtxt'] + ' ' + (isGenerateCodeStepEnabled ? steps_style_default.a['prev-active'] : '') },
          'Checkout page customization'
        )
      ),
      Object(preact_min["h"])(
        'div',
        { className: steps_style_default.a.steps + ' ' + steps_style_default.a[isGenerateCodeStepEnabled ? 'active' : ''] },
        Object(preact_min["h"])(
          'p',
          { className: '' + steps_style_default.a['steps-txt'] },
          'STEP 2'
        ),
        Object(preact_min["h"])(
          'p',
          { className: '' + steps_style_default.a['steps-subtxt'] },
          'Code integration'
        )
      )
    );
  };

  return Steps;
}(preact_min["Component"]);

/* harmony default export */ var steps = (Object(preact["connect"])('isGenerateCodeStepEnabled', theme_checkout["b" /* onChange */])(steps_Steps));
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__("hafV");

// CONCATENATED MODULE: ./checkout/components/radio/index.js


function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function radio__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function radio__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function radio__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var _ref3 = Object(preact_min["h"])("span", { className: "checkmark" });

var radio_RadioGroup = function (_Component) {
  radio__inherits(RadioGroup, _Component);

  function RadioGroup() {
    radio__classCallCheck(this, RadioGroup);

    return radio__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  RadioGroup.prototype.render = function render(_ref, _ref2) {
    var label = _ref.label,
        inputName = _ref.inputName,
        isChecked = _ref.isChecked,
        onChange = _ref.onChange;

    _objectDestructuringEmpty(_ref2);

    return Object(preact_min["h"])(
      "div",
      { onClick: function onClick(e) {
          return onChange(e);
        }, className: "theme-card pos-r" },
      Object(preact_min["h"])(
        "div",
        { className: "theme-strip" },
        Object(preact_min["h"])(
          "label",
          { className: "lbl" },
          label,
          Object(preact_min["h"])("input", { type: "radio", name: inputName, checked: isChecked }),
          _ref3
        )
      )
    );
  };

  return RadioGroup;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./checkout/components/colorbar/style.css
var colorbar_style = __webpack_require__("7Tn3");
var colorbar_style_default = /*#__PURE__*/__webpack_require__.n(colorbar_style);

// EXTERNAL MODULE: ../node_modules/preact-cli/lib/components/async.js
var components_async = __webpack_require__("7N8r");
var async_default = /*#__PURE__*/__webpack_require__.n(components_async);

// CONCATENATED MODULE: ./checkout/components/async/colorpicker/index.js

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(0).then((function(require) {
				cb(__webpack_require__("fUHF"));
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var colorpicker = (async_default()(load));
	
// CONCATENATED MODULE: ./checkout/components/colorbar/index.js


function colorbar__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function colorbar__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function colorbar__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var colorbar_ColorBar = function (_Component) {
  colorbar__inherits(ColorBar, _Component);

  function ColorBar(props) {
    colorbar__classCallCheck(this, ColorBar);

    var _this = colorbar__possibleConstructorReturn(this, _Component.call(this, props));

    _this.toggleColorPicker = _this.toggleColorPicker.bind(_this, props.colorInfo.NAME);
    _this.hideColorPicker = _this.hideColorPicker.bind(_this);
    _this.onKeyupHandle = _this.onKeyupHandle.bind(_this, props.colorInfo.NAME);
    _this.state = { isColorPickerOpen: false, isColorBoxClicked: false };
    return _this;
  }

  ColorBar.prototype.componentDidMount = function componentDidMount() {
    window.addEventListener('click', this.hideColorPicker);
  };

  ColorBar.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('click', this.hideColorPicker);
  };

  ColorBar.prototype.hideColorPicker = function hideColorPicker() {
    this.setState({ isColorPickerOpen: false, isColorBoxClicked: false });
  };

  ColorBar.prototype.toggleColorPicker = function toggleColorPicker(label, e) {
    if (this.state.isColorBoxClicked === false) {
      document.getElementById('app').click();
    }
    e.preventDefault();
    e.stopPropagation();
    if (!this.state.isColorPickerOpen) {
      common["a" /* default */].log('onColorPickerClick', label);
    }
    this.setState(function (state) {
      return {
        isColorPickerOpen: !state.isColorPickerOpen,
        isColorBoxClicked: true
      };
    });
  };

  ColorBar.prototype.onKeyupHandle = function onKeyupHandle(label, e) {
    if (e) {
      var colorCode = '#' + e.target.value.replace(/[^0-9a-fA-F]/g, '');
      common["a" /* default */].log('onKeyInput', label, { colorCode: colorCode });
      if (this.props && this.props.onColorChange && this.props.colorInfo) {
        this.props.onColorChange(this.props.colorInfo.KEY, { hex: colorCode });
      }
    }
  };

  ColorBar.prototype.render = function render(_ref, _ref2) {
    var colorInfo = _ref.colorInfo;
    var isColorPickerOpen = _ref2.isColorPickerOpen;

    var codeWithoutHash = colorInfo.CODE.substring(1);
    return Object(preact_min["h"])(
      'div',
      { className: colorbar_style_default.a['theme-card'] + ' ib' },
      Object(preact_min["h"])(
        'span',
        { className: '' + colorbar_style_default.a['comp-name'] },
        colorInfo.NAME
      ),
      Object(preact_min["h"])(
        'div',
        { className: colorbar_style_default.a['theme-colorbox'] + ' right pos-r' },
        Object(preact_min["h"])('input', { type: 'text', value: codeWithoutHash, maxLength: '8', onKeyUp: this.onKeyupHandle }),
        Object(preact_min["h"])(
          'span',
          { className: '' + colorbar_style_default.a['hash-code'] },
          '#'
        ),
        Object(preact_min["h"])('div', {
          className: colorbar_style_default.a['color-code'] + ' pos-a',
          style: 'background:' + colorInfo.CODE,
          onClick: this.toggleColorPicker
        }),
        isColorPickerOpen && Object(preact_min["h"])(colorpicker, { colorInfo: colorInfo })
      )
    );
  };

  return ColorBar;
}(preact_min["Component"]);

/* harmony default export */ var colorbar = (Object(preact["connect"])(null, theme_checkout["b" /* onChange */])(colorbar_ColorBar));
// EXTERNAL MODULE: ./checkout/components/customtheme/style.css
var customtheme_style = __webpack_require__("s8o+");
var customtheme_style_default = /*#__PURE__*/__webpack_require__.n(customtheme_style);

// CONCATENATED MODULE: ./checkout/components/customtheme/index.js


function customtheme__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function customtheme__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function customtheme__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var customtheme_CustomThemeSection = function (_Component) {
  customtheme__inherits(CustomThemeSection, _Component);

  function CustomThemeSection(props) {
    customtheme__classCallCheck(this, CustomThemeSection);

    return customtheme__possibleConstructorReturn(this, _Component.call(this, props));
  }

  CustomThemeSection.prototype.render = function render(_ref) {
    var customBar = _ref.customBar,
        selected = _ref.selected;

    return Object(preact_min["h"])(
      'div',
      null,
      Object(preact_min["h"])(
        'div',
        null,
        Object(preact_min["h"])(
          'h6',
          { className: customtheme_style_default.a['select-color'] + ' uppercase' },
          'Select color for different components of checkout page'
        ),
        customBar && customBar.map(function (colorObj) {
          colorObj.CODE = selected.mobile[colorObj.KEY];
          return Object(preact_min["h"])(colorbar, { colorInfo: colorObj });
        })
      )
    );
  };

  return CustomThemeSection;
}(preact_min["Component"]);

/* harmony default export */ var customtheme = (Object(preact["connect"])('customBar, selected')(customtheme_CustomThemeSection));
// EXTERNAL MODULE: ./checkout/components/merchantLogoSection/style.css
var merchantLogoSection_style = __webpack_require__("GcWV");
var merchantLogoSection_style_default = /*#__PURE__*/__webpack_require__.n(merchantLogoSection_style);

// CONCATENATED MODULE: ./checkout/components/merchantLogoSection/index.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function merchantLogoSection__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function merchantLogoSection__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function merchantLogoSection__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var merchantLogoSection__ref2 = Object(preact_min["h"])(
  'ul',
  null,
  Object(preact_min["h"])(
    'li',
    null,
    Object(preact_min["h"])(
      'span',
      null,
      'Max Size: 3MB'
    )
  ),
  Object(preact_min["h"])(
    'li',
    null,
    Object(preact_min["h"])(
      'span',
      null,
      'Size: 80X40PX'
    )
  ),
  Object(preact_min["h"])(
    'li',
    null,
    Object(preact_min["h"])(
      'span',
      null,
      'Format: JPG, JPEG, PNG'
    )
  )
);

var merchantLogoSection__ref3 = Object(preact_min["h"])(
  'strong',
  null,
  'Error: File size or type not appropriate.'
);

var merchantLogoSection_MerchantLogoSection = function (_Component) {
  merchantLogoSection__inherits(MerchantLogoSection, _Component);

  function MerchantLogoSection(props) {
    merchantLogoSection__classCallCheck(this, MerchantLogoSection);

    // this.onMerchantLogoFileChange = this.onMerchantLogoFileChange.bind(this);
    var _this = merchantLogoSection__possibleConstructorReturn(this, _Component.call(this, props));

    _this.merchantLogoFileRef = Object(preact_min["createRef"])();
    _this.onFileChange = _this.onFileChange.bind(_this);
    _this.onRemoveLogoFile = _this.onRemoveLogoFile.bind(_this);
    _this.onResetDefaultLogoClick = _this.onResetDefaultLogoClick.bind(_this);
    _this.state = {
      selectedFile: null,
      showErrorMessage: false,
      imageUrl: null,
      enableLogo: false,
      imageUrlFromMapping: null
    };
    return _this;
  }

  MerchantLogoSection.prototype.componentDidMount = function componentDidMount() {
    if (this.props.selected.merchant) {
      this.setState({
        imageUrlFromMapping: this.props.selected.merchant.merchantLogoUrl
      });
    }
  };

  MerchantLogoSection.prototype.onFileChange = function onFileChange(event, logoFile) {
    var _this2 = this;

    if (!logoFile.type || !(logoFile.type.includes('image/png') || logoFile.type.includes('image/jpeg')) || logoFile.size > 3000000) {
      console.log("invalid file");
      this.setState(_extends({}, this.state, {
        showErrorMessage: true,
        enableLogo: false
      }));
      event.preventDefault();
      return;
    }

    this.setState(_extends({}, this.state, {
      showErrorMessage: false,
      selectedFile: logoFile,
      imageUrl: URL.createObjectURL(logoFile),
      enableLogo: true
    }), function () {
      var onMerchantLogoChange = _this2.props.onMerchantLogoChange;

      onMerchantLogoChange && onMerchantLogoChange(logoFile, _this2.state.imageUrl);
    });
  };

  MerchantLogoSection.prototype.onRemoveLogoFile = function onRemoveLogoFile() {
    var onMerchantLogoChange = this.props.onMerchantLogoChange;

    onMerchantLogoChange && onMerchantLogoChange(null, this.state.imageUrlFromMapping);

    this.setState(_extends({}, this.state, {
      enableLogo: false,
      showErrorMessage: false,
      selectedFile: null
    }));
  };

  MerchantLogoSection.prototype.onResetDefaultLogoClick = function onResetDefaultLogoClick() {
    var _this3 = this;

    var onMerchantLogoChange = this.props.onMerchantLogoChange;


    fetch(common["a" /* default */].getStaticPath() + '/assets/images/merc-default.png').then(function (res) {
      return res.blob();
    }).then(function (data) {
      var metadata = { type: 'image/png' };
      var file = new File([data], "merc-default.png", metadata);
      var defaultLogoUrl = URL.createObjectURL(file);

      // onMerchantLogoChange && onMerchantLogoChange(file, defaultLogoUrl)
      _this3.setState(_extends({}, _this3.state, {
        showErrorMessage: false,
        selectedFile: file,
        imageUrl: defaultLogoUrl,
        enableLogo: true
      }), function () {
        onMerchantLogoChange && onMerchantLogoChange(file, defaultLogoUrl);
      });
    });
  };

  MerchantLogoSection.prototype.render = function render(_ref) {
    var _this4 = this;

    var selected = _ref.selected;

    return Object(preact_min["h"])(
      'div',
      { className: '' + merchantLogoSection_style_default.a['logo-upload-section'] },
      Object(preact_min["h"])(
        'h6',
        { className: merchantLogoSection_style_default.a['heading'] + ' uppercase' },
        ' Upload Brand Logo '
      ),
      Object(preact_min["h"])(
        'div',
        { className: '' + merchantLogoSection_style_default.a['helper-text'] },
        merchantLogoSection__ref2
      ),
      Object(preact_min["h"])(
        'div',
        { className: merchantLogoSection_style_default.a["upload-section"] + ' df' },
        Object(preact_min["h"])(
          'div',
          { className: "upload-loader" },
          this.state.selectedFile ? Object(preact_min["h"])(
            'div',
            { className: merchantLogoSection_style_default.a["upload-logo"] },
            Object(preact_min["h"])('img', { className: merchantLogoSection_style_default.a["selected-logo"], src: this.state.imageUrl, alt: this.state.selectedFile ? this.state.selectedFile.name : '' }),
            Object(preact_min["h"])('img', {
              className: merchantLogoSection_style_default.a["close-button"],
              src: common["a" /* default */].getStaticPath() + '/assets/images/ic-clear.svg',
              alt: 'Clear',
              onClick: this.onRemoveLogoFile
            }),
            Object(preact_min["h"])(
              'span',
              { className: merchantLogoSection_style_default.a["selected-logo-name"] },
              this.state.selectedFile.name
            )
          ) : Object(preact_min["h"])(
            'div',
            { className: '' + merchantLogoSection_style_default.a["button-container"] },
            Object(preact_min["h"])(
              'div',
              { className: '' + merchantLogoSection_style_default.a["upload-button"] },
              Object(preact_min["h"])(
                'label',
                { className: '' + merchantLogoSection_style_default.a["upload-button-label"], 'for': 'merchantLogoFileUpload' },
                Object(preact_min["h"])('img', { src: common["a" /* default */].getStaticPath() + '/assets/images/upload.svg', alt: 'Upload' })
              ),
              Object(preact_min["h"])('input', {
                type: 'file',
                accept: 'image/png, image/jpeg',
                className: merchantLogoSection_style_default.a["fileup"],
                id: 'merchantLogoFileUpload',
                ref: this.merchantLogoFileRef,
                onChange: function onChange(e) {
                  _this4.onFileChange(e, _this4.merchantLogoFileRef.current.files[0]);
                }
              })
            ),
            !this.state.selectedFile && selected.merchant && selected.merchant.merchantLogoUrl && selected.merchant.merchantLogoUrl !== '' && selected.merchant.merchantLogoUrl.includes('http') && Object(preact_min["h"])(
              'div',
              { className: merchantLogoSection_style_default.a["reset-button-container"] + ' right pos-r', onClick: this.onResetDefaultLogoClick },
              'Reset default logo'
            )
          )
        )
      ),
      this.state.showErrorMessage && Object(preact_min["h"])(
        'div',
        { className: merchantLogoSection_style_default.a["error"] },
        merchantLogoSection__ref3
      )
    );
  };

  return MerchantLogoSection;
}(preact_min["Component"]);

/* harmony default export */ var merchantLogoSection = (Object(preact["connect"])('selected', theme_checkout["b" /* onChange */])(merchantLogoSection_MerchantLogoSection));
// EXTERNAL MODULE: ./common/api.js + 1 modules
var api = __webpack_require__("XeJm");

// CONCATENATED MODULE: ./checkout/components/async/notificationsuccess/index.js

		

		function notificationsuccess_load(cb) {
			__webpack_require__.e/* require.ensure */(1).then((function(require) {
				cb(__webpack_require__("3K5E"));
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var notificationsuccess = (async_default()(notificationsuccess_load));
	
// CONCATENATED MODULE: ./checkout/components/async/notification/index.js

		

		function notification_load(cb) {
			__webpack_require__.e/* require.ensure */(2).then((function(require) {
				cb(__webpack_require__("zKPq"));
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var notification = (async_default()(notification_load));
	
// EXTERNAL MODULE: ./checkout/components/toggle/style.css
var toggle_style = __webpack_require__("wMfb");
var toggle_style_default = /*#__PURE__*/__webpack_require__.n(toggle_style);

// CONCATENATED MODULE: ./checkout/components/toggle/index.js


function toggle__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function toggle__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function toggle__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var toggle_CustomToggle = function (_Component) {
  toggle__inherits(CustomToggle, _Component);

  function CustomToggle(props) {
    toggle__classCallCheck(this, CustomToggle);

    return toggle__possibleConstructorReturn(this, _Component.call(this, props));
  }

  CustomToggle.prototype.render = function render(_ref) {
    var isChecked = _ref.isChecked,
        info = _ref.info,
        onToggleChange = _ref.onToggleChange;

    return Object(preact_min["h"])(
      'div',
      { className: '' + toggle_style_default.a['control-box'] },
      Object(preact_min["h"])(
        'div',
        { className: 'theme-heading ' + toggle_style_default.a['toggle-wrapper'] },
        Object(preact_min["h"])(
          'label',
          { className: '' + toggle_style_default.a.switch },
          Object(preact_min["h"])('input', { type: 'checkbox', checked: isChecked, onChange: onToggleChange }),
          Object(preact_min["h"])('span', { className: toggle_style_default.a.slider + ' ' + toggle_style_default.a.round })
        ),
        info.label
      ),
      Object(preact_min["h"])(
        'p',
        { className: '' + toggle_style_default.a['small-txt'] },
        info.desc
      )
    );
  };

  return CustomToggle;
}(preact_min["Component"]);


// EXTERNAL MODULE: ../node_modules/react-sortablejs/lib/index.js
var lib = __webpack_require__("FZsR");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./checkout/components/draganddrop/style.css
var draganddrop_style = __webpack_require__("dDmy");
var draganddrop_style_default = /*#__PURE__*/__webpack_require__.n(draganddrop_style);

// CONCATENATED MODULE: ./checkout/components/draganddrop/index.js


function draganddrop__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function draganddrop__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function draganddrop__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function draganddrop__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var draganddrop_DragAndDrop = function (_Component) {
  draganddrop__inherits(DragAndDrop, _Component);

  function DragAndDrop(props) {
    draganddrop__classCallCheck(this, DragAndDrop);

    return draganddrop__possibleConstructorReturn(this, _Component.call(this, props));
  }

  DragAndDrop.prototype.render = function render(_ref, _ref2) {
    var merchantPayModes = _ref.merchantPayModes,
        onPaymodeReOrder = _ref.onPaymodeReOrder;

    draganddrop__objectDestructuringEmpty(_ref2);

    return Object(preact_min["h"])(
      'section',
      null,
      Object(preact_min["h"])(
        'div',
        { style: { marginTop: 50 } },
        Object(preact_min["h"])(
          'h6',
          { className: 'select-color uppercase' },
          Object(i18n["b" /* locale */])('theme.sort.paymode.title')
        ),
        Object(preact_min["h"])(
          lib_default.a,
          {
            options: { animation: 150 },
            className: 'block-list',
            tag: 'div',
            onEnd: function onEnd(event) {
              return onPaymodeReOrder(event.oldIndex, event.newIndex);
            }
          },
          merchantPayModes && merchantPayModes.map(function (paymodeObj) {
            var paymodeName = paymodeObj.name;
            if (paymodeObj.type == 'CARD') {
              paymodeName = constants["n" /* default */].CARD_NAME;
            }
            if (paymodeObj.type == 'UPI') {
              paymodeName = constants["n" /* default */].UPI;
            }
            return Object(preact_min["h"])(
              'div',
              { 'data-id': paymodeObj.id, className: '' + draganddrop_style_default.a['drag-card'] },
              Object(preact_min["h"])('span', { className: draganddrop_style_default.a.dash + ' pos-r' }),
              Object(preact_min["h"])(
                'span',
                { className: '' + draganddrop_style_default.a['drag-txt'] },
                paymodeName
              )
            );
          })
        )
      )
    );
  };

  return DragAndDrop;
}(preact_min["Component"]);

/* harmony default export */ var draganddrop = (Object(preact["connect"])('merchantPayModes', theme_checkout["b" /* onChange */])(draganddrop_DragAndDrop));
// EXTERNAL MODULE: ./checkout/components/themesection/style.css
var themesection_style = __webpack_require__("qtbF");
var themesection_style_default = /*#__PURE__*/__webpack_require__.n(themesection_style);

// EXTERNAL MODULE: ./checkout/components/button/index.js
var components_button = __webpack_require__("SUer");

// EXTERNAL MODULE: ./common/utility.js
var utility = __webpack_require__("Lssw");

// CONCATENATED MODULE: ./checkout/components/themesection/index.js
var themesection__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function themesection__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function themesection__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function themesection__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















// import CodeIntegration from '../async/codeintegration';



var themesection__ref3 = Object(preact_min["h"])(customtheme, null);

var _ref4 = Object(preact_min["h"])(merchantLogoSection, null);

var _ref5 = Object(preact_min["h"])(draganddrop, null);

var themesection_ThemeSection = function (_Component) {
  themesection__inherits(ThemeSection, _Component);

  function ThemeSection(props) {
    themesection__classCallCheck(this, ThemeSection);

    var _this = themesection__possibleConstructorReturn(this, _Component.call(this, props));

    _this.isValidCustomTheme = function (selectedColor) {
      var isValid = true;

      if (selectedColor && selectedColor.mobile) {
        for (var key in selectedColor.mobile) {
          if (typeof selectedColor.mobile[key] === 'string' && selectedColor.mobile[key].indexOf('#') === 0 && selectedColor.mobile[key].length <= 3) {
            isValid = false;
          }
        }
      } else {
        isValid = false;
      }
      return isValid;
    };

    _this.onSaveClick = function () {
      var isGenerateCodeClick = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var event = arguments[1];

      event.preventDefault();
      if (_this.state.isButtonDisabled) {
        return;
      }
      var _this$props = _this.props,
          selected = _this$props.selected,
          CHECKOUT_THEME = _this$props.CHECKOUT_THEME,
          onSaveCustomTheme = _this$props.onSaveCustomTheme,
          isPaytmBrandingDisplay = _this$props.isPaytmBrandingDisplay,
          isAutoLoginSupported = _this$props.isAutoLoginSupported,
          merchantPayModes = _this$props.merchantPayModes,
          onKeyValueChange = _this$props.onKeyValueChange,
          isCustomPaymodeSelected = _this$props.isCustomPaymodeSelected,
          isGradientEffectEnable = _this$props.isGradientEffectEnable,
          onInvertImgLogo = _this$props.onInvertImgLogo,
          isParentThemeOverwriteEnabled = _this$props.isParentThemeOverwriteEnabled;

      var isValidTheme = _this.isValidCustomTheme(selected);
      common["a" /* default */].log('onSaveClick', Object(utility["a" /* get */])(selected, 'web.NAME', ''), {
        isAutoLoginSupported: isAutoLoginSupported,
        isPaytmBrandingDisplay: isPaytmBrandingDisplay,
        isValidTheme: isValidTheme,
        selected: selected
      });

      if (isValidTheme) {
        _this.setState({ isButtonDisabled: true });
        if (CHECKOUT_THEME) {
          _this.setState({ saveErrorMsg: '' });

          var selectedMerchant = themesection__extends({}, selected.merchant);

          Promise.all([api["a" /* default */].onSaveSetting(selected, CHECKOUT_THEME, isPaytmBrandingDisplay, isAutoLoginSupported, isCustomPaymodeSelected, merchantPayModes, isGradientEffectEnable, isParentThemeOverwriteEnabled, onInvertImgLogo), api["a" /* default */].onSaveMerchantLogo(selectedMerchant && selectedMerchant.merchantLogoFile ? selectedMerchant.merchantLogoFile : null)]).then(function () {
            _this.setState({
              resultMsg: Object(i18n["b" /* locale */])('theme.save.success'),
              showSuccessMsg: true,
              isButtonDisabled: false
            });
            if (isGenerateCodeClick && onKeyValueChange) {
              onKeyValueChange('isGenerateCodeStepEnabled', true);
            }
            if (selected.mobile.NAME == constants["m" /* THEME_CONSTANTS */].CUSTOM && onSaveCustomTheme) {
              onSaveCustomTheme(selected);
            }
            setTimeout(function () {
              _this.closeSuccessMsg();
            }, 3000);
          }).catch(function (error) {
            if (error && error.resultInfo) {
              _this.setState({
                saveErrorMsg: error.resultInfo.resultMsg,
                isButtonDisabled: false,
                showSuccessMsg: false
              });
            } else {
              _this.setState({
                saveErrorMsg: Object(i18n["b" /* locale */])('default.error'),
                isButtonDisabled: false,
                showSuccessMsg: false
              });
            }
            setTimeout(function () {
              _this.closeSuccessMsg();
            }, 3000);
          });
        } else {
          _this.setState({ saveErrorMsg: Object(i18n["b" /* locale */])('default.error') });
          setTimeout(function () {
            _this.closeSuccessMsg();
          }, 3000);
        }
      } else {
        _this.setState({ saveErrorMsg: Object(i18n["b" /* locale */])('theme.save.error') });
        setTimeout(function () {
          _this.closeSuccessMsg();
        }, 3000);
      }
    };

    _this.onToggleChange = function (logType, key, event) {
      common["a" /* default */].log(logType, event.target.checked);
      if (_this.props && _this.props.onToggleChange) {
        _this.props.onToggleChange(key, event.target.checked);
      }
      event.preventDefault();
    };

    _this.onCustomPaymodeChange = function (label, key, value, event) {
      if (_this.props && _this.props.onKeyValueChange) {
        _this.props.onKeyValueChange(key, value);
      }
      common["a" /* default */].log('onSortPaymodeChange', label);
      event.preventDefault();
    };

    _this.onThemeChange = function (label, WebTheme, MobileTheme, event) {
      var onThemeChange = _this.props.onThemeChange;

      common["a" /* default */].log('onThemeChange', label);
      onThemeChange && onThemeChange(WebTheme, MobileTheme);
      event.preventDefault();
    };

    _this.state = {
      resultMsg: '',
      isAppDataUpdated: false,
      isButtonDisabled: false,
      showSuccessMsg: false,
      saveErrorMsg: ''
    };
    _this.onSaveClick = _this.onSaveClick.bind(_this);
    _this.closeSuccessMsg = _this.closeSuccessMsg.bind(_this);
    _this.isValidCustomTheme = _this.isValidCustomTheme.bind(_this);
    _this.isThemeSelected = _this.isThemeSelected.bind(_this);

    _this.securePaytmInfo = {
      label: Object(i18n["b" /* locale */])('theme.display.secure.label'),
      desc: Object(i18n["b" /* locale */])('theme.display.secure.desc')
    };
    _this.autoLoginInfo = {
      label: Object(i18n["b" /* locale */])('theme.autologin.label'),
      desc: Object(i18n["b" /* locale */])('theme.autologin.desc')
    };
    _this.gradientInfo = {
      label: Object(i18n["b" /* locale */])('theme.gradient.label'),
      desc: Object(i18n["b" /* locale */])('theme.gradient.desc')
    };
    _this.invertLogoImg = {
      label: Object(i18n["b" /* locale */])('theme.invert.logo.label'),
      desc: Object(i18n["b" /* locale */])('theme.invert.logo.desc')
    };
    return _this;
  }

  ThemeSection.prototype.componentDidMount = function componentDidMount() {
    common["a" /* default */].log('onLoad', 'Theme Page');
  };

  ThemeSection.prototype.closeSuccessMsg = function closeSuccessMsg() {
    this.setState({
      showSuccessMsg: false,
      isButtonDisabled: false,
      resultMsg: '',
      saveErrorMsg: ''
    });
  };

  // onGenerateCodeClick = key => {
  //   if (this.props && this.props.onKeyValueChange) {
  //     this.onSaveClick();
  //     this.props.onKeyValueChange(key, true);
  //   }
  //   event.preventDefault();
  // };

  ThemeSection.prototype.isThemeSelected = function isThemeSelected(infoObj, selectedObj) {
    return infoObj && selectedObj && selectedObj.isSelected && infoObj.NAME === selectedObj.NAME;
  };

  ThemeSection.prototype.render = function render(_ref, _ref2) {
    var selected = _ref.selected,
        MobileTheme = _ref.MobileTheme,
        WebTheme = _ref.WebTheme,
        merchantPayModes = _ref.merchantPayModes,
        isAutoLoginSupported = _ref.isAutoLoginSupported,
        isJSCheckoutIntegrated = _ref.isJSCheckoutIntegrated,
        isRedirectionTabSelected = _ref.isRedirectionTabSelected,
        isThematicFeatureUsed = _ref.isThematicFeatureUsed,
        isCustomPaymodeSelected = _ref.isCustomPaymodeSelected,
        isGradientEffectEnable = _ref.isGradientEffectEnable,
        onInvertImgLogo = _ref.onInvertImgLogo;
    var resultMsg = _ref2.resultMsg,
        showSuccessMsg = _ref2.showSuccessMsg,
        saveErrorMsg = _ref2.saveErrorMsg,
        isButtonDisabled = _ref2.isButtonDisabled;

    return Object(preact_min["h"])(
      'div',
      { 'class': 'left-content left' },
      Object(preact_min["h"])(
        'h5',
        { 'class': 'theme-heading' },
        Object(i18n["b" /* locale */])('theme.select.theme')
      ),
      Object(preact_min["h"])(
        'div',
        { 'class': 'theme-wrap' },
        Object(preact_min["h"])(radio_RadioGroup, {
          label: '' + MobileTheme.LIGHTTHEME.LABEL,
          inputName: 'theme',
          isChecked: this.isThemeSelected(MobileTheme.LIGHTTHEME, selected.mobile),
          onChange: this.onThemeChange.bind(this, MobileTheme.LIGHTTHEME.LABEL, WebTheme.LIGHTTHEME, MobileTheme.LIGHTTHEME)
        }),
        Object(preact_min["h"])(radio_RadioGroup, {
          label: '' + MobileTheme.DARKTHEME.LABEL,
          inputName: 'theme',
          isChecked: this.isThemeSelected(MobileTheme.DARKTHEME, selected.mobile),
          onChange: this.onThemeChange.bind(this, MobileTheme.DARKTHEME.LABEL, WebTheme.DARKTHEME, MobileTheme.DARKTHEME)
        }),
        Object(preact_min["h"])(radio_RadioGroup, {
          label: '' + MobileTheme.CUSTOMTHEME.LABEL,
          inputName: 'theme',
          isChecked: this.isThemeSelected(MobileTheme.CUSTOMTHEME, selected.mobile),
          onChange: this.onThemeChange.bind(this, MobileTheme.CUSTOMTHEME.LABEL, WebTheme.CUSTOMTHEME, MobileTheme.CUSTOMTHEME)
        }),
        selected && selected.mobile && selected.mobile.NAME == constants["m" /* THEME_CONSTANTS */].CUSTOM && themesection__ref3,
        _ref4,
        selected && selected.mobile && selected.mobile.NAME == constants["m" /* THEME_CONSTANTS */].CUSTOM && Object(preact_min["h"])(toggle_CustomToggle, {
          isChecked: onInvertImgLogo,
          'default-checked': true,
          info: this.invertLogoImg,
          onToggleChange: this.onToggleChange.bind(this, 'onInvertImgChange', 'onInvertImgLogo')
        }),
        selected && selected.mobile && selected.mobile.NAME == constants["m" /* THEME_CONSTANTS */].CUSTOM && !isRedirectionTabSelected && Object(preact_min["h"])(toggle_CustomToggle, {
          isChecked: isGradientEffectEnable,
          info: this.gradientInfo,
          onToggleChange: this.onToggleChange.bind(this, 'onGradientEffectChange', 'isGradientEffectEnable')
        })
      ),
      merchantPayModes && merchantPayModes.length > 0 && Object(preact_min["h"])(
        'div',
        null,
        !isRedirectionTabSelected && Object(preact_min["h"])(
          'div',
          null,
          Object(preact_min["h"])(
            'h5',
            { 'class': 'theme-heading mt-30' },
            Object(i18n["b" /* locale */])('theme.sort.paymodes')
          ),
          Object(preact_min["h"])(
            'div',
            { 'class': 'theme-wrap' },
            Object(preact_min["h"])(radio_RadioGroup, {
              label: Object(i18n["b" /* locale */])('theme.default.order'),
              inputName: 'paymode',
              isChecked: !isCustomPaymodeSelected,
              onChange: this.onCustomPaymodeChange.bind(this, Object(i18n["b" /* locale */])('theme.default.order'), 'isCustomPaymodeSelected', false)
            }),
            Object(preact_min["h"])(radio_RadioGroup, {
              label: Object(i18n["b" /* locale */])('theme.customize.order'),
              inputName: 'paymode',
              isChecked: isCustomPaymodeSelected,
              onChange: this.onCustomPaymodeChange.bind(this, Object(i18n["b" /* locale */])('theme.customize.order'), 'isCustomPaymodeSelected', true)
            }),
            isCustomPaymodeSelected && _ref5
          )
        ),
        Object(preact_min["h"])(toggle_CustomToggle, {
          isChecked: isAutoLoginSupported,
          info: this.autoLoginInfo,
          onToggleChange: this.onToggleChange.bind(this, 'onAutoLoginChange', 'isAutoLoginSupported')
        })
      ),
      !isJSCheckoutIntegrated && showSuccessMsg && Object(preact_min["h"])(notificationsuccess, { closeSuccessMsg: this.closeSuccessMsg, msg: resultMsg }),
      saveErrorMsg && Object(preact_min["h"])(notification, { closeWarningMsg: this.closeSuccessMsg, msg: saveErrorMsg }),
      isThematicFeatureUsed && Object(preact_min["h"])(
        'div',
        { className: '' + themesection_style_default.a.notification },
        Object(preact_min["h"])(
          'span',
          { className: '' + themesection_style_default.a['note-txt'] },
          Object(i18n["b" /* locale */])('theme.note'),
          ':'
        ),
        Object(preact_min["h"])(
          'span',
          null,
          Object(i18n["b" /* locale */])('theme.note.desc')
        )
      ),
      !isJSCheckoutIntegrated && Object(preact_min["h"])(components_button["a" /* default */], {
        onButtonClick: this.onSaveClick.bind(this, false),
        isDisabled: isButtonDisabled,
        name: Object(i18n["b" /* locale */])('theme.save.setting')
      }),
      isJSCheckoutIntegrated && Object(preact_min["h"])(components_button["a" /* default */], {
        onButtonClick: this.onSaveClick.bind(this, true),
        name: Object(i18n["b" /* locale */])('checkout.generate.code'),
        isDisabled: isButtonDisabled
      })
    );
  };

  return ThemeSection;
}(preact_min["Component"]);

/* harmony default export */ var themesection = (Object(preact["connect"])('selected, MobileTheme, WebTheme, CHECKOUT_THEME, merchantPayModes, isPaytmBrandingDisplay, isAutoLoginSupported, isThematicFeatureUsed, isJSCheckoutIntegrated, isRedirectionTabSelected, isCustomPaymodeSelected, isGradientEffectEnable, isParentThemeOverwriteEnabled,onInvertImgLogo', theme_checkout["b" /* onChange */])(themesection_ThemeSection));
// EXTERNAL MODULE: ./checkout/components/jscheckout/mobile/style.css
var mobile_style = __webpack_require__("HJKR");
var mobile_style_default = /*#__PURE__*/__webpack_require__.n(mobile_style);

// CONCATENATED MODULE: ./checkout/components/jscheckout/mobile/index.js


function mobile__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function mobile__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function mobile__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var mobile_Mobile = function (_Component) {
  mobile__inherits(Mobile, _Component);

  function Mobile(props) {
    mobile__classCallCheck(this, Mobile);

    return mobile__possibleConstructorReturn(this, _Component.call(this, props));
  }

  Mobile.prototype.render = function render(_ref) {
    var themeColor = _ref.themeColor,
        merchantPayModes = _ref.merchantPayModes,
        isPaytmBrandingDisplay = _ref.isPaytmBrandingDisplay,
        isGradientEffectEnable = _ref.isGradientEffectEnable,
        gradientColor = _ref.gradientColor,
        selectedTheme = _ref.selectedTheme,
        onInvertImgLogo = _ref.onInvertImgLogo,
        merchantLogoUrl = _ref.merchantLogoUrl;

    var headColor = isGradientEffectEnable && selectedTheme === 'CUSTOM' ? 'background-image: linear-gradient(to bottom, ' + gradientColor.headerGradientsColors[0] + ', ' + gradientColor.headerGradientsColors[1] + '); color: ' + themeColor.HEADERTEXT + ';' : 'background: ' + themeColor.HEADERPANEL + '; color: ' + themeColor.HEADERTEXT + ';';
    var buttonbgColor = isGradientEffectEnable && selectedTheme === 'CUSTOM' ? 'background-image: linear-gradient(to top, ' + gradientColor.buttonGradientsColors[0] + ', ' + gradientColor.buttonGradientsColors[1] + '); color: ' + themeColor.PAYBUTTONTEXT + ';' : 'background: ' + themeColor.PAYBUTTONBG + '; color: ' + themeColor.PAYBUTTONTEXT + ';';
    return Object(preact_min["h"])(
      'div',
      {
        className: mobile_style_default.a.default + ' ' + mobile_style_default.a['tab-content'] + ' ' + (themeColor.NAME == constants["m" /* THEME_CONSTANTS */].DARK ? 'dark-theme' : '')
      },
      Object(preact_min["h"])(
        'div',
        {
          className: '' + mobile_style_default.a['mobile-wrap'],
          style: 'background: ' + themeColor.BODYBG + '; color: ' + themeColor.BODYTEXT
        },
        Object(preact_min["h"])(
          'div',
          { className: mobile_style_default.a.header + ' header-bg', style: headColor },
          Object(preact_min["h"])(
            'div',
            { className: '' + mobile_style_default.a['header-top'] },
            Object(preact_min["h"])(
              'div',
              { className: '' + mobile_style_default.a['cross-wrap'] },
              Object(preact_min["h"])('span', {
                className: mobile_style_default.a.cross + ' ' + mobile_style_default.a['cross-line1'],
                style: 'background: ' + themeColor.HEADERTEXT + ';'
              }),
              Object(preact_min["h"])('span', {
                className: mobile_style_default.a.cross + ' ' + mobile_style_default.a['cross-line2'],
                style: 'background: ' + themeColor.HEADERTEXT + ';'
              })
            ),
            Object(preact_min["h"])('img', {
              className: '' + mobile_style_default.a['ptm-head-logo'],
              src: common["a" /* default */].getHeaderLogoUrl(onInvertImgLogo, themeColor),
              alt: ''
            })
          ),
          Object(preact_min["h"])(
            'div',
            { className: mobile_style_default.a['header-bottom'] + ' pos-r' },
            Object(preact_min["h"])(
              'div',
              { className: mobile_style_default.a.subheading + ' header-color' },
              Object(preact_min["h"])(
                'div',
                { className: '' + mobile_style_default.a['mer-name'], style: 'color: ' + themeColor.HEADERTEXT },
                'AJIO Online Shopping'
              )
            ),
            Object(preact_min["h"])(
              'div',
              { className: mobile_style_default.a['mer-logo'] + ' pos-a' },
              Object(preact_min["h"])('img', {
                className: '' + mobile_style_default.a['brand-logo'],
                src: merchantLogoUrl && merchantLogoUrl !== '' ? merchantLogoUrl : common["a" /* default */].getStaticPath() + '/assets/images/merc-default.svg',
                alt: 'merchant logo'
              })
            )
          )
        ),
        Object(preact_min["h"])(
          'div',
          {
            className: '' + mobile_style_default.a['m-content'],
            style: 'background: ' + themeColor.BODYBG + '; color: ' + themeColor.BODYTEXT
          },
          Object(preact_min["h"])(
            'div',
            { className: '' + mobile_style_default.a['select-txt'], style: 'color: ' + themeColor.BODYTEXT },
            'Select an option to pay',
            Object(preact_min["h"])(
              'div',
              { className: mobile_style_default.a.amount + ' right amount-color pos-r', style: 'color: ' + themeColor.BODYTEXT },
              '\u20B95,876'
            )
          ),
          Object(preact_min["h"])(
            'div',
            { className: mobile_style_default.a.wallet + ' w100', style: 'border-color:' + themeColor.BORDER },
            Object(preact_min["h"])(
              'h5',
              { className: '' + mobile_style_default.a['choose-txt'], style: 'color: ' + themeColor.BODYTEXT },
              'Paytm Featured'
            ),
            Object(preact_min["h"])(
              'div',
              { className: '' + mobile_style_default.a['wallet-inner'] },
              Object(preact_min["h"])(
                'div',
                {
                  className: mobile_style_default.a.check + ' left',
                  style: 'background: ' + themeColor.PAYBUTTONBG + '; color: ' + themeColor.PAYBUTTONTEXT
                },
                Object(preact_min["h"])('span', { className: '' + mobile_style_default.a.sign1, style: 'background: ' + themeColor.PAYBUTTONTEXT }),
                Object(preact_min["h"])('span', { className: '' + mobile_style_default.a.sign2, style: 'background: ' + themeColor.PAYBUTTONTEXT })
              ),
              Object(preact_min["h"])(
                'div',
                { className: mobile_style_default.a['check-txt'] + ' left' },
                Object(preact_min["h"])(
                  'h6',
                  { className: '' + mobile_style_default.a['wallet-txt'] },
                  'Paytm Balance'
                ),
                Object(preact_min["h"])(
                  'p',
                  { className: '' + mobile_style_default.a['wallet-para'], style: 'color: ' + themeColor.BODYTEXT },
                  'Available Balance \u20B912,000'
                ),
                Object(preact_min["h"])('img', {
                  className: '' + mobile_style_default.a['sc-img'],
                  src: common["a" /* default */].getStaticPath() + '/assets/images/pb-icon-new.svg',
                  alt: ''
                }),
                Object(preact_min["h"])(
                  'div',
                  { style: buttonbgColor, className: '' + mobile_style_default.a.payBtn },
                  Object(preact_min["h"])('img', {
                    className: mobile_style_default.a.payBtnimg + ' pos-r',
                    src: common["a" /* default */].getStaticPath() + '/assets/images/lock.png',
                    alt: ''
                  }),
                  'Pay \u20B95,876'
                )
              )
            )
          ),
          Object(preact_min["h"])(
            'div',
            { className: '' + mobile_style_default.a['pay-list-wrap'], style: 'border-color:' + themeColor.BORDER },
            Object(preact_min["h"])(
              'h5',
              { className: '' + mobile_style_default.a['choose-txt'], style: 'color: ' + themeColor.BODYTEXT },
              'Saved Cards'
            ),
            Object(preact_min["h"])(
              'ul',
              { className: '' + mobile_style_default.a['pay-list'] },
              Object(preact_min["h"])(
                'li',
                null,
                Object(preact_min["h"])('span', { className: '' + mobile_style_default.a['radio-circle'], style: 'border-color:' + themeColor.BODYTEXT + ';' }),
                Object(preact_min["h"])(
                  'h5',
                  null,
                  'HDFC Credit Card',
                  Object(preact_min["h"])('img', { className: '' + mobile_style_default.a.cardtype, src: common["a" /* default */].getStaticPath() + '/assets/images/master.svg' })
                ),
                Object(preact_min["h"])(
                  'p',
                  { style: 'color:' + themeColor.BODYTEXT + ';' },
                  ' XXXX 2021'
                ),
                Object(preact_min["h"])('img', {
                  className: '' + mobile_style_default.a['sc-img'],
                  src: common["a" /* default */].getStaticPath() + '/assets/images/hdfc-logo-new.png',
                  alt: ''
                }),
                Object(preact_min["h"])('div', { className: mobile_style_default.a['border-div'] + ' pos-a', style: 'background:' + themeColor.BORDER })
              ),
              Object(preact_min["h"])(
                'li',
                null,
                Object(preact_min["h"])('span', { className: '' + mobile_style_default.a['radio-circle'], style: 'border-color:' + themeColor.BODYTEXT + ';' }),
                Object(preact_min["h"])(
                  'h5',
                  null,
                  'Axis Credit Card',
                  Object(preact_min["h"])('img', { className: '' + mobile_style_default.a.cardtype, src: common["a" /* default */].getStaticPath() + '/assets/images/visa.svg' })
                ),
                Object(preact_min["h"])(
                  'p',
                  { style: 'color:' + themeColor.BODYTEXT + ';' },
                  'XXXX 8781'
                ),
                Object(preact_min["h"])('img', {
                  className: '' + mobile_style_default.a['sc-img'],
                  src: common["a" /* default */].getStaticPath() + '/assets/images/axis-logo-new.png',
                  alt: ''
                }),
                Object(preact_min["h"])('div', { className: mobile_style_default.a['border-div'] + ' pos-a', style: 'background:' + themeColor.BORDER })
              )
            )
          )
        ),
        Object(preact_min["h"])(
          'div',
          {
            className: mobile_style_default.a['m-content'] + ' ' + mobile_style_default.a['pay-mode-wrap'] + ' ' + mobile_style_default.a[constants["m" /* THEME_CONSTANTS */].DARK == themeColor.NAME ? 'dark-border' : ''],
            style: 'background: ' + themeColor.BODYBG + '; color: ' + themeColor.BODYTEXT + '; border-top-color:' + themeColor.HEADERPANEL
          },
          Object(preact_min["h"])(
            'div',
            { className: '' + mobile_style_default.a['grid-wrap'], style: 'border-color:' + themeColor.BORDER },
            Object(preact_min["h"])(
              'div',
              { className: '' + mobile_style_default.a['grid-inner'] },
              merchantPayModes && merchantPayModes.length > 0 && Object(preact_min["h"])(
                'h5',
                { className: '' + mobile_style_default.a['choose-txt'], style: 'color: ' + themeColor.BODYTEXT },
                'New Payment Option'
              ),
              merchantPayModes && merchantPayModes.map(function (paymodeObj) {
                if (paymodeObj.type == constants["n" /* default */].LOGIN) {
                  return null;
                }
                var paymodeName = paymodeObj.name;
                if (paymodeObj.type == 'CARD') {
                  paymodeName = constants["n" /* default */].CARD_NAME;
                }
                if (paymodeObj.type == 'UPI') {
                  paymodeName = constants["n" /* default */].UPI;
                }
                return Object(preact_min["h"])(
                  'div',
                  { className: '' + mobile_style_default.a.grid, style: 'border-color:' + themeColor.BORDER },
                  Object(preact_min["h"])(
                    'div',
                    { className: mobile_style_default.a['pay-method'] + ' pos-r' },
                    Object(preact_min["h"])('img', {
                      className: '' + mobile_style_default.a['grid-img'],
                      src: common["a" /* default */].getStaticPath() + '/assets/images/' + ((constants["m" /* THEME_CONSTANTS */].DARK == themeColor.NAME ? paymodeObj.type + '.dark' : paymodeObj.type) + '.svg')
                    }),
                    Object(preact_min["h"])(
                      'span',
                      null,
                      paymodeName
                    )
                  )
                );
              })
            )
          )
        ),
        isPaytmBrandingDisplay && Object(preact_min["h"])(
          'div',
          {
            className: '' + mobile_style_default.a['m-footer']
            // style={`background: ${themeColor.BODYBG}; color: ${themeColor.BODYTEXT}`}
          },
          Object(preact_min["h"])('img', { className: '' + mobile_style_default.a.secure, src: common["a" /* default */].getStaticPath() + '/assets/images/secure.png', alt: '' }),
          ' ',
          '100% Secure Payments Powered by Paytm'
        )
      )
    );
  };

  return Mobile;
}(preact_min["Component"]);

/* harmony default export */ var mobile = (Object(preact["connect"])('merchantPayModes, timestamp, isPaytmBrandingDisplay, isGradientEffectEnable,onInvertImgLogo', null)(mobile_Mobile));
// EXTERNAL MODULE: ./checkout/components/jscheckout/web/style.css
var web_style = __webpack_require__("TCRV");
var web_style_default = /*#__PURE__*/__webpack_require__.n(web_style);

// CONCATENATED MODULE: ./checkout/components/jscheckout/web/index.js


function web__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function web__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function web__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var web_Web = function (_Component) {
  web__inherits(Web, _Component);

  function Web() {
    web__classCallCheck(this, Web);

    return web__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Web.prototype.render = function render(_ref) {
    var themeColor = _ref.themeColor,
        merchantPayModes = _ref.merchantPayModes,
        isPaytmBrandingDisplay = _ref.isPaytmBrandingDisplay,
        isGradientEffectEnable = _ref.isGradientEffectEnable,
        gradientColor = _ref.gradientColor,
        selectedTheme = _ref.selectedTheme,
        onInvertImgLogo = _ref.onInvertImgLogo,
        merchantLogoUrl = _ref.merchantLogoUrl;

    var headColor = isGradientEffectEnable && selectedTheme === 'CUSTOM' ? 'background-image: linear-gradient(to bottom, ' + gradientColor.headerGradientsColors[0] + ', ' + gradientColor.headerGradientsColors[1] + '); color: ' + themeColor.HEADERTEXT + ';' : 'background: ' + themeColor.HEADERPANEL + '; color: ' + themeColor.HEADERTEXT + ';';
    var buttonbgColor = isGradientEffectEnable && selectedTheme === 'CUSTOM' ? 'background-image: linear-gradient(to top, ' + gradientColor.buttonGradientsColors[0] + ', ' + gradientColor.buttonGradientsColors[1] + '); color: ' + themeColor.PAYBUTTONTEXT + ';' : 'background: ' + themeColor.PAYBUTTONBG + '; color: ' + themeColor.PAYBUTTONTEXT + ';';
    return Object(preact_min["h"])(
      'div',
      { className: web_style_default.a.default + ' ' + web_style_default.a['tab-content'] },
      Object(preact_min["h"])(
        'div',
        { className: '' + web_style_default.a['webtheme-wrapper'] },
        Object(preact_min["h"])(
          'p',
          { className: '' + web_style_default.a.tabcircle },
          Object(preact_min["h"])('span', { className: '' + web_style_default.a.circle }),
          Object(preact_min["h"])('span', { className: '' + web_style_default.a.circle }),
          Object(preact_min["h"])('span', { className: '' + web_style_default.a.circle })
        ),
        Object(preact_min["h"])(
          'div',
          { className: '' + web_style_default.a['webtheme-inner'] },
          Object(preact_min["h"])(
            'div',
            {
              className: '' + web_style_default.a['web-wrap'],
              style: 'background: ' + themeColor.BODYBG + '; color: ' + themeColor.BODYTEXT
            },
            Object(preact_min["h"])(
              'div',
              { className: web_style_default.a.header + ' header-bg', style: headColor },
              Object(preact_min["h"])(
                'div',
                { className: '' + web_style_default.a['header-top'] },
                Object(preact_min["h"])(
                  'div',
                  { className: '' + web_style_default.a['cross-wrap'] },
                  Object(preact_min["h"])('span', {
                    className: web_style_default.a.cross + ' ' + web_style_default.a['cross-line1'],
                    style: 'background: ' + themeColor.HEADERTEXT + ';'
                  }),
                  Object(preact_min["h"])('span', {
                    className: web_style_default.a.cross + ' ' + web_style_default.a['cross-line2'],
                    style: 'background: ' + themeColor.HEADERTEXT + ';'
                  })
                ),
                Object(preact_min["h"])('img', {
                  className: '' + web_style_default.a['ptm-head-logo'],
                  src: common["a" /* default */].getHeaderLogoUrl(onInvertImgLogo, themeColor),
                  alt: ''
                })
              ),
              Object(preact_min["h"])(
                'div',
                { className: web_style_default.a['header-bottom'] + ' pos-r' },
                Object(preact_min["h"])(
                  'div',
                  { className: web_style_default.a.subheading + ' header-color' },
                  Object(preact_min["h"])(
                    'div',
                    { className: '' + web_style_default.a['mer-name'], style: 'color: ' + themeColor.HEADERTEXT },
                    'AJIO Online Shopping'
                  )
                ),
                Object(preact_min["h"])(
                  'div',
                  { className: web_style_default.a['mer-logo'] + ' pos-a' },
                  Object(preact_min["h"])('img', {
                    className: '' + web_style_default.a['brand-logo'],
                    src: merchantLogoUrl && merchantLogoUrl !== '' ? merchantLogoUrl : common["a" /* default */].getStaticPath() + '/assets/images/merc-default.svg',
                    alt: 'merchant logo'
                  })
                )
              )
            ),
            Object(preact_min["h"])(
              'div',
              {
                className: '' + web_style_default.a['m-content'],
                style: 'background: ' + themeColor.BODYBG + '; color: ' + themeColor.BODYTEXT
              },
              Object(preact_min["h"])(
                'div',
                { className: '' + web_style_default.a['select-txt'], style: 'color: ' + themeColor.BODYTEXT },
                'Select an option to pay',
                Object(preact_min["h"])(
                  'div',
                  { className: web_style_default.a.amount + ' right amount-color pos-r', style: 'color: ' + themeColor.BODYTEXT },
                  '\u20B95,876'
                )
              ),
              Object(preact_min["h"])(
                'div',
                { className: web_style_default.a.wallet + ' w100', style: 'border-color:' + themeColor.BORDER },
                Object(preact_min["h"])(
                  'h5',
                  { className: '' + web_style_default.a['choose-txt'], style: 'color: ' + themeColor.BODYTEXT },
                  'Paytm Featured'
                ),
                Object(preact_min["h"])(
                  'div',
                  { className: '' + web_style_default.a['wallet-inner'] },
                  Object(preact_min["h"])(
                    'div',
                    {
                      className: web_style_default.a.check + ' left',
                      style: 'background: ' + themeColor.PAYBUTTONBG + '; color: ' + themeColor.PAYBUTTONTEXT
                    },
                    Object(preact_min["h"])('span', { className: '' + web_style_default.a.sign1, style: 'background: ' + themeColor.PAYBUTTONTEXT }),
                    Object(preact_min["h"])('span', { className: '' + web_style_default.a.sign2, style: 'background: ' + themeColor.PAYBUTTONTEXT })
                  ),
                  Object(preact_min["h"])(
                    'div',
                    { className: web_style_default.a['check-txt'] + ' left' },
                    Object(preact_min["h"])(
                      'h6',
                      { className: '' + web_style_default.a['wallet-txt'] },
                      'Paytm Balance'
                    ),
                    Object(preact_min["h"])(
                      'p',
                      { className: '' + web_style_default.a['wallet-para'], style: 'color: ' + themeColor.BODYTEXT },
                      'Available Balance \u20B912,000'
                    ),
                    Object(preact_min["h"])('img', {
                      className: '' + web_style_default.a['sc-img'],
                      src: common["a" /* default */].getStaticPath() + '/assets/images/pb-icon-new.svg',
                      alt: ''
                    }),
                    Object(preact_min["h"])(
                      'div',
                      { style: buttonbgColor, className: '' + web_style_default.a.payBtn },
                      Object(preact_min["h"])('img', {
                        className: web_style_default.a.payBtnimg + ' pos-r',
                        src: common["a" /* default */].getStaticPath() + '/assets/images/lock.png',
                        alt: ''
                      }),
                      'Pay \u20B95,876'
                    )
                  )
                )
              ),
              Object(preact_min["h"])(
                'div',
                { className: '' + web_style_default.a['pay-list-wrap'], style: 'border-color:' + themeColor.BORDER },
                Object(preact_min["h"])(
                  'h5',
                  { className: '' + web_style_default.a['choose-txt'], style: 'color: ' + themeColor.BODYTEXT },
                  'Saved Cards'
                ),
                Object(preact_min["h"])(
                  'ul',
                  { className: '' + web_style_default.a['pay-list'] },
                  Object(preact_min["h"])(
                    'li',
                    null,
                    Object(preact_min["h"])('span', { className: '' + web_style_default.a['radio-circle'], style: 'border-color:' + themeColor.BODYTEXT + ';' }),
                    Object(preact_min["h"])(
                      'h5',
                      null,
                      'HDFC Credit Card',
                      Object(preact_min["h"])('img', {
                        className: '' + web_style_default.a.cardtype,
                        src: common["a" /* default */].getStaticPath() + '/assets/images/master.svg'
                      })
                    ),
                    Object(preact_min["h"])(
                      'p',
                      { style: 'color:' + themeColor.BODYTEXT + ';' },
                      ' XXXX 2021'
                    ),
                    Object(preact_min["h"])('img', {
                      className: '' + web_style_default.a['sc-img'],
                      src: common["a" /* default */].getStaticPath() + '/assets/images/hdfc-logo-new.png',
                      alt: ''
                    }),
                    Object(preact_min["h"])('div', { className: web_style_default.a['border-div'] + ' pos-a', style: 'background:' + themeColor.BORDER })
                  ),
                  Object(preact_min["h"])(
                    'li',
                    null,
                    Object(preact_min["h"])('span', { className: '' + web_style_default.a['radio-circle'], style: 'border-color:' + themeColor.BODYTEXT + ';' }),
                    Object(preact_min["h"])(
                      'h5',
                      null,
                      'Axis Credit Card',
                      Object(preact_min["h"])('img', { className: '' + web_style_default.a.cardtype, src: common["a" /* default */].getStaticPath() + '/assets/images/visa.svg' })
                    ),
                    Object(preact_min["h"])(
                      'p',
                      { style: 'color:' + themeColor.BODYTEXT + ';' },
                      'XXXX 8781'
                    ),
                    Object(preact_min["h"])('img', {
                      className: '' + web_style_default.a['sc-img'],
                      src: common["a" /* default */].getStaticPath() + '/assets/images/axis-logo-new.png',
                      alt: ''
                    }),
                    Object(preact_min["h"])('div', { className: web_style_default.a['border-div'] + ' pos-a', style: 'background:' + themeColor.BORDER })
                  )
                )
              )
            ),
            Object(preact_min["h"])(
              'div',
              {
                className: '' + web_style_default.a['grid-content'],
                style: 'background: ' + themeColor.BODYBG + '; color: ' + themeColor.BODYTEXT
              },
              Object(preact_min["h"])(
                'div',
                { className: '' + web_style_default.a['grid-wrap'], style: 'border-color:' + themeColor.BORDER },
                Object(preact_min["h"])(
                  'div',
                  { className: '' + web_style_default.a['grid-inner'] },
                  merchantPayModes && merchantPayModes.length > 0 && Object(preact_min["h"])(
                    'h5',
                    { className: '' + web_style_default.a['select-txt'], style: 'color: ' + themeColor.BODYTEXT },
                    'New Payment Option'
                  ),
                  merchantPayModes && merchantPayModes.map(function (paymodeObj) {
                    if (paymodeObj.type == constants["n" /* default */].LOGIN) {
                      return null;
                    }
                    var paymodeName = paymodeObj.name;
                    if (paymodeObj.type == 'CARD') {
                      paymodeName = constants["n" /* default */].CARD_NAME;
                    }
                    if (paymodeObj.type == 'UPI') {
                      paymodeName = constants["n" /* default */].UPI;
                    }
                    return Object(preact_min["h"])(
                      'div',
                      { className: '' + web_style_default.a.grid, style: 'border-color:' + themeColor.BORDER },
                      Object(preact_min["h"])(
                        'div',
                        { className: web_style_default.a['pay-method'] + ' pos-r' },
                        Object(preact_min["h"])('img', {
                          className: '' + web_style_default.a['grid-img'],
                          src: common["a" /* default */].getStaticPath() + '/assets/images/' + ((constants["m" /* THEME_CONSTANTS */].DARK == themeColor.NAME ? paymodeObj.type + '.dark' : paymodeObj.type) + '.svg')
                        }),
                        Object(preact_min["h"])(
                          'span',
                          null,
                          paymodeName
                        )
                      )
                    );
                  })
                )
              )
            ),
            isPaytmBrandingDisplay && Object(preact_min["h"])(
              'div',
              {
                className: '' + web_style_default.a['m-footer']
                // style={`background: ${themeColor.BODYBG}; color: ${themeColor.BODYTEXT}`}
              },
              Object(preact_min["h"])('img', { className: '' + web_style_default.a.secure, src: common["a" /* default */].getStaticPath() + '/assets/images/secure.png' }),
              '100% Secure Payments Powered by Paytm'
            )
          )
        )
      )
    );
  };

  return Web;
}(preact_min["Component"]);

/* harmony default export */ var web = (Object(preact["connect"])('merchantPayModes, timestamp, isPaytmBrandingDisplay, isGradientEffectEnable,onInvertImgLogo', null)(web_Web));
// EXTERNAL MODULE: ./checkout/components/jscheckout/style.css
var jscheckout_style = __webpack_require__("7+MJ");
var jscheckout_style_default = /*#__PURE__*/__webpack_require__.n(jscheckout_style);

// CONCATENATED MODULE: ./checkout/components/jscheckout/index.js


function jscheckout__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function jscheckout__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function jscheckout__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var jscheckout_JSCheckout = function (_Component) {
  jscheckout__inherits(JSCheckout, _Component);

  function JSCheckout(props) {
    jscheckout__classCallCheck(this, JSCheckout);

    var _this = jscheckout__possibleConstructorReturn(this, _Component.call(this, props));

    _this.onPreviewToggle = function (label, value) {
      if (_this.props && _this.props.onPreviewToggle) {
        common["a" /* default */].log('onPreviewChange', label);
        _this.props.onPreviewToggle(value);
      }
    };

    return _this;
  }

  JSCheckout.prototype.render = function render(_ref) {
    var isMobilePreviewSelected = _ref.isMobilePreviewSelected,
        selected = _ref.selected;

    var merchantLogoUrl = selected.merchant && selected.merchant.merchantLogoUrl ? selected.merchant.merchantLogoUrl : null;

    return Object(preact_min["h"])(
      'section',
      null,
      Object(preact_min["h"])(
        'div',
        { className: '' + jscheckout_style_default.a['view-tab'] },
        Object(preact_min["h"])(
          'ul',
          { className: '' + jscheckout_style_default.a['view-list'] },
          Object(preact_min["h"])(
            'li',
            {
              className: jscheckout_style_default.a['view-item'] + ' ' + jscheckout_style_default.a[!isMobilePreviewSelected ? 'active' : ''],
              onClick: this.onPreviewToggle.bind(this, 'Web', false)
            },
            Object(i18n["b" /* locale */])('checkout.web')
          ),
          Object(preact_min["h"])(
            'li',
            {
              className: jscheckout_style_default.a['view-item'] + ' ' + jscheckout_style_default.a[isMobilePreviewSelected ? 'active' : ''],
              onClick: this.onPreviewToggle.bind(this, 'Mobile', true)
            },
            Object(i18n["b" /* locale */])('checkout.mobile')
          )
        )
      ),
      !isMobilePreviewSelected && selected.web && Object(preact_min["h"])(web, { themeColor: selected.web, gradientColor: selected.gradient, selectedTheme: selected.web.NAME, merchantLogoUrl: merchantLogoUrl }),
      isMobilePreviewSelected && selected.mobile && Object(preact_min["h"])(mobile, { themeColor: selected.mobile, gradientColor: selected.gradient, selectedTheme: selected.mobile.NAME, merchantLogoUrl: merchantLogoUrl })
    );
  };

  return JSCheckout;
}(preact_min["Component"]);

/* harmony default export */ var jscheckout = (Object(preact["connect"])('isMobilePreviewSelected, selected', theme_checkout["b" /* onChange */])(jscheckout_JSCheckout));
// EXTERNAL MODULE: ./checkout/components/redirection/mobile/style.css
var redirection_mobile_style = __webpack_require__("o0Qn");
var redirection_mobile_style_default = /*#__PURE__*/__webpack_require__.n(redirection_mobile_style);

// CONCATENATED MODULE: ./checkout/components/redirection/mobile/index.js


function redirection_mobile__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function redirection_mobile__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function redirection_mobile__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var mobile__ref2 = Object(preact_min["h"])(
  'h5',
  null,
  'HDFC Credit Card'
);

var mobile__ref3 = Object(preact_min["h"])(
  'h5',
  null,
  'Axis Credit Card'
);

var redirection_mobile_Mobile = function (_Component) {
  redirection_mobile__inherits(Mobile, _Component);

  function Mobile(props) {
    redirection_mobile__classCallCheck(this, Mobile);

    return redirection_mobile__possibleConstructorReturn(this, _Component.call(this, props));
  }

  Mobile.prototype.render = function render(_ref) {
    var themeColor = _ref.themeColor,
        merchantPayModes = _ref.merchantPayModes,
        isPaytmBrandingDisplay = _ref.isPaytmBrandingDisplay,
        onInvertImgLogo = _ref.onInvertImgLogo;

    return Object(preact_min["h"])(
      'div',
      {
        className: redirection_mobile_style_default.a.default + ' ' + redirection_mobile_style_default.a['tab-content'] + ' ' + (themeColor.NAME == constants["m" /* THEME_CONSTANTS */].DARK ? 'dark-theme' : '')
      },
      Object(preact_min["h"])(
        'div',
        { className: redirection_mobile_style_default.a['mobile-wrap'] + ' pos-r', style: 'background: ' + themeColor.BODYBG + ';' },
        Object(preact_min["h"])(
          'div',
          {
            className: '' + redirection_mobile_style_default.a['m-header'],
            style: 'background: ' + themeColor.HEADERPANEL + '; color: ' + themeColor.HEADERTEXT
          },
          Object(preact_min["h"])(
            'div',
            { className: '' + redirection_mobile_style_default.a.backSection },
            Object(preact_min["h"])('span', { style: 'border-color: ' + themeColor.HEADERTEXT, className: '' + redirection_mobile_style_default.a.arrow }),
            Object(preact_min["h"])('span', { className: '' + redirection_mobile_style_default.a.back, style: 'background: ' + themeColor.HEADERTEXT + ';' }),
            Object(preact_min["h"])('img', {
              className: '' + redirection_mobile_style_default.a['ptm-head-logo'],
              src: common["a" /* default */].getHeaderLogoUrl(onInvertImgLogo, themeColor),
              alt: ''
            })
          ),
          Object(preact_min["h"])(
            'div',
            { className: redirection_mobile_style_default.a.subheading + ' header-color' },
            Object(preact_min["h"])(
              'div',
              { className: '' + redirection_mobile_style_default.a['mer-name'], style: 'color: ' + themeColor.HEADERTEXT },
              'AJIO Online Shopping'
            )
          ),
          Object(preact_min["h"])(
            'div',
            { className: redirection_mobile_style_default.a['mer-logo'] + ' pos-a' },
            Object(preact_min["h"])('img', {
              className: '' + redirection_mobile_style_default.a['brand-logo'],
              src: common["a" /* default */].getStaticPath() + '/assets/images/merc-default.svg',
              alt: 'merchant logo'
            })
          )
        ),
        Object(preact_min["h"])(
          'div',
          {
            className: '' + redirection_mobile_style_default.a['m-content'],
            style: 'background: ' + themeColor.BODYBG + '; color: ' + themeColor.BODYTEXT
          },
          Object(preact_min["h"])(
            'div',
            { className: '' + redirection_mobile_style_default.a['select-txt'], style: 'color: ' + themeColor.BODYTEXT },
            'Select an option to pay',
            Object(preact_min["h"])(
              'div',
              { className: redirection_mobile_style_default.a.amount + ' right amount-color pos-r', style: 'color: ' + themeColor.BODYTEXT },
              '\u20B95,876'
            )
          ),
          Object(preact_min["h"])(
            'div',
            { className: redirection_mobile_style_default.a.wallet + ' w100', style: 'border-color:' + themeColor.BORDER },
            Object(preact_min["h"])(
              'h5',
              { className: '' + redirection_mobile_style_default.a['choose-txt'], style: 'color: ' + themeColor.BODYTEXT },
              'Paytm Featured'
            ),
            Object(preact_min["h"])(
              'div',
              { className: '' + redirection_mobile_style_default.a['wallet-inner'] },
              Object(preact_min["h"])(
                'div',
                {
                  className: redirection_mobile_style_default.a.check + ' left',
                  style: 'background: ' + themeColor.PAYBUTTONBG + '; color: ' + themeColor.PAYBUTTONTEXT
                },
                Object(preact_min["h"])('span', { className: '' + redirection_mobile_style_default.a.sign1, style: 'background: ' + themeColor.PAYBUTTONTEXT }),
                Object(preact_min["h"])('span', { className: '' + redirection_mobile_style_default.a.sign2, style: 'background: ' + themeColor.PAYBUTTONTEXT })
              ),
              Object(preact_min["h"])(
                'div',
                { className: redirection_mobile_style_default.a['check-txt'] + ' left' },
                Object(preact_min["h"])(
                  'h6',
                  { className: '' + redirection_mobile_style_default.a['wallet-txt'] },
                  'Paytm Balance'
                ),
                Object(preact_min["h"])(
                  'p',
                  { className: '' + redirection_mobile_style_default.a['wallet-para'], style: 'color: ' + themeColor.BODYTEXT },
                  'Available Balance \u20B912,000'
                ),
                Object(preact_min["h"])('img', {
                  className: '' + redirection_mobile_style_default.a['sc-img'],
                  src: common["a" /* default */].getStaticPath() + '/assets/images/pb-icon-new.svg',
                  alt: ''
                }),
                Object(preact_min["h"])(
                  'div',
                  {
                    className: '' + redirection_mobile_style_default.a.payBtn,
                    style: 'background: ' + themeColor.PAYBUTTONBG + '; color: ' + themeColor.PAYBUTTONTEXT
                  },
                  Object(preact_min["h"])('img', {
                    className: redirection_mobile_style_default.a.payBtnimg + ' pos-r',
                    src: common["a" /* default */].getStaticPath() + '/assets/images/lock.png',
                    alt: ''
                  }),
                  'Pay \u20B95,876'
                )
              )
            )
          ),
          Object(preact_min["h"])(
            'div',
            { className: '' + redirection_mobile_style_default.a['pay-list-wrap'], style: 'border-color:' + themeColor.BORDER },
            Object(preact_min["h"])(
              'h5',
              { className: '' + redirection_mobile_style_default.a['choose-txt'], style: 'color: ' + themeColor.BODYTEXT },
              'Saved Cards'
            ),
            Object(preact_min["h"])(
              'ul',
              { className: '' + redirection_mobile_style_default.a['pay-list'] },
              Object(preact_min["h"])(
                'li',
                null,
                Object(preact_min["h"])('span', { className: '' + redirection_mobile_style_default.a['radio-circle'], style: 'border-color:' + themeColor.BODYTEXT + ';' }),
                mobile__ref2,
                Object(preact_min["h"])(
                  'p',
                  { style: 'color:' + themeColor.BODYTEXT + ';' },
                  'MASTER \u2022\u2022\u2022\u2022 2021',
                  ' ',
                  Object(preact_min["h"])('img', { className: '' + redirection_mobile_style_default.a.cardtype, src: common["a" /* default */].getStaticPath() + '/assets/images/master.svg' })
                ),
                Object(preact_min["h"])('img', {
                  className: '' + redirection_mobile_style_default.a['sc-img'],
                  src: common["a" /* default */].getStaticPath() + '/assets/images/hdfc-logo-new.png',
                  alt: ''
                }),
                Object(preact_min["h"])('div', { className: redirection_mobile_style_default.a['border-div'] + ' pos-a', style: 'background:' + themeColor.BORDER })
              ),
              Object(preact_min["h"])(
                'li',
                null,
                Object(preact_min["h"])('span', { className: '' + redirection_mobile_style_default.a['radio-circle'], style: 'border-color:' + themeColor.BODYTEXT + ';' }),
                mobile__ref3,
                Object(preact_min["h"])(
                  'p',
                  { style: 'color:' + themeColor.BODYTEXT + ';' },
                  'VISA \u2022\u2022\u2022\u2022 8781',
                  ' ',
                  Object(preact_min["h"])('img', { className: '' + redirection_mobile_style_default.a.cardtype, src: common["a" /* default */].getStaticPath() + '/assets/images/visa.svg' })
                ),
                Object(preact_min["h"])('img', {
                  className: '' + redirection_mobile_style_default.a['sc-img'],
                  src: common["a" /* default */].getStaticPath() + '/assets/images/axis-logo-new.png',
                  alt: ''
                }),
                Object(preact_min["h"])('div', { className: redirection_mobile_style_default.a['border-div'] + ' pos-a', style: 'background:' + themeColor.BORDER })
              )
            )
          ),
          Object(preact_min["h"])(
            'div',
            { className: '' + redirection_mobile_style_default.a['grid-wrap'], style: 'border-color:' + themeColor.BORDER },
            merchantPayModes && merchantPayModes.length > 0 && Object(preact_min["h"])(
              'h5',
              { className: '' + redirection_mobile_style_default.a['choose-txt'], style: 'color: ' + themeColor.BODYTEXT },
              'New Payment Option'
            ),
            merchantPayModes && merchantPayModes.map(function (paymodeObj) {
              if (paymodeObj.type == constants["n" /* default */].LOGIN) {
                return null;
              }
              var paymodeName = paymodeObj.name;
              if (paymodeObj.type == 'CARD') {
                paymodeName = constants["n" /* default */].CARD_NAME;
              }
              if (paymodeObj.type == 'UPI') {
                paymodeName = constants["n" /* default */].UPI;
              }
              return Object(preact_min["h"])(
                'div',
                { className: '' + redirection_mobile_style_default.a.grid, style: 'border-color:' + themeColor.BORDER },
                Object(preact_min["h"])(
                  'div',
                  { className: redirection_mobile_style_default.a['pay-method'] + ' pos-r' },
                  Object(preact_min["h"])('img', {
                    className: '' + redirection_mobile_style_default.a['grid-img'],
                    src: common["a" /* default */].getStaticPath() + '/assets/images/' + ((constants["m" /* THEME_CONSTANTS */].DARK == themeColor.NAME ? paymodeObj.type + '.dark' : paymodeObj.type) + '.svg')
                  }),
                  Object(preact_min["h"])(
                    'span',
                    null,
                    paymodeName
                  )
                )
              );
            })
          )
        ),
        isPaytmBrandingDisplay && Object(preact_min["h"])(
          'div',
          {
            className: '' + redirection_mobile_style_default.a['m-footer']
            // style={`background: ${themeColor.BODYBG}; color: ${themeColor.BODYTEXT}`}
          },
          Object(preact_min["h"])('img', { className: '' + redirection_mobile_style_default.a.secure, src: common["a" /* default */].getStaticPath() + '/assets/images/secure.png' }),
          ' 100% Secure Payments Powered by Paytm'
        )
      )
    );
  };

  return Mobile;
}(preact_min["Component"]);

/* harmony default export */ var redirection_mobile = (Object(preact["connect"])('merchantPayModes, timestamp, isPaytmBrandingDisplay,onInvertImgLogo', null)(redirection_mobile_Mobile));
// EXTERNAL MODULE: ./checkout/components/redirection/web/style.css
var redirection_web_style = __webpack_require__("YDPc");
var redirection_web_style_default = /*#__PURE__*/__webpack_require__.n(redirection_web_style);

// CONCATENATED MODULE: ./checkout/components/redirection/web/index.js


function redirection_web__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function redirection_web__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function redirection_web__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var web__ref2 = Object(preact_min["h"])(
  'h5',
  null,
  'HDFC Credit Card'
);

var web__ref3 = Object(preact_min["h"])(
  'h5',
  null,
  'Axis Credit Card'
);

var redirection_web_Web = function (_Component) {
  redirection_web__inherits(Web, _Component);

  function Web() {
    redirection_web__classCallCheck(this, Web);

    return redirection_web__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Web.prototype.render = function render(_ref) {
    var themeColor = _ref.themeColor,
        merchantPayModes = _ref.merchantPayModes,
        isPaytmBrandingDisplay = _ref.isPaytmBrandingDisplay,
        onInvertImgLogo = _ref.onInvertImgLogo;

    return Object(preact_min["h"])(
      'div',
      { className: redirection_web_style_default.a.default + ' ' + redirection_web_style_default.a['tab-content'] },
      Object(preact_min["h"])(
        'div',
        { className: '' + redirection_web_style_default.a['webtheme-wrapper'] },
        Object(preact_min["h"])(
          'p',
          { className: '' + redirection_web_style_default.a.tabcircle },
          Object(preact_min["h"])('span', { className: '' + redirection_web_style_default.a.circle }),
          Object(preact_min["h"])('span', { className: '' + redirection_web_style_default.a.circle }),
          Object(preact_min["h"])('span', { className: '' + redirection_web_style_default.a.circle })
        ),
        Object(preact_min["h"])(
          'div',
          { className: redirection_web_style_default.a['webtheme-inner'] + ' text-center' },
          Object(preact_min["h"])(
            'div',
            { className: redirection_web_style_default.a['web-wrap'] + ' pos-r text-left' },
            Object(preact_min["h"])(
              'div',
              {
                className: '' + redirection_web_style_default.a['m-header'],
                style: 'background: ' + themeColor.HEADERPANEL + '; color: ' + themeColor.HEADERTEXT
              },
              Object(preact_min["h"])(
                'div',
                { className: '' + redirection_web_style_default.a.backSection },
                Object(preact_min["h"])('span', { style: 'border-color: ' + themeColor.HEADERTEXT, className: '' + redirection_web_style_default.a.arrow }),
                Object(preact_min["h"])('span', { className: '' + redirection_web_style_default.a.back, style: 'background: ' + themeColor.HEADERTEXT + ';' }),
                Object(preact_min["h"])('img', {
                  className: '' + redirection_web_style_default.a['ptm-head-logo'],
                  src: common["a" /* default */].getHeaderLogoUrl(onInvertImgLogo, themeColor),
                  alt: ''
                })
              ),
              Object(preact_min["h"])(
                'div',
                { className: redirection_web_style_default.a.subheading + ' header-color' },
                Object(preact_min["h"])(
                  'div',
                  { className: '' + redirection_web_style_default.a['mer-name'], style: 'color: ' + themeColor.HEADERTEXT },
                  'AJIO Online Shopping'
                )
              ),
              Object(preact_min["h"])(
                'div',
                { className: redirection_web_style_default.a['mer-logo'] + ' pos-a' },
                Object(preact_min["h"])('img', {
                  className: '' + redirection_web_style_default.a['brand-logo'],
                  src: common["a" /* default */].getStaticPath() + '/assets/images/merc-default.svg',
                  alt: 'merchant logo'
                })
              )
            ),
            Object(preact_min["h"])(
              'div',
              {
                className: '' + redirection_web_style_default.a['m-content'],
                style: 'background: ' + themeColor.BODYBG + '; color: ' + themeColor.BODYTEXT
              },
              Object(preact_min["h"])(
                'div',
                { className: '' + redirection_web_style_default.a['select-txt'], style: 'color: ' + themeColor.BODYTEXT },
                'Select an option to pay',
                Object(preact_min["h"])(
                  'div',
                  { className: redirection_web_style_default.a.amount + ' right amount-color pos-r', style: 'color: ' + themeColor.BODYTEXT },
                  '\u20B95,876'
                )
              ),
              Object(preact_min["h"])(
                'div',
                { className: redirection_web_style_default.a.wallet + ' w100', style: 'border-color:' + themeColor.BORDER },
                Object(preact_min["h"])(
                  'h5',
                  { className: '' + redirection_web_style_default.a['choose-txt'], style: 'color: ' + themeColor.BODYTEXT },
                  'Paytm Featured'
                ),
                Object(preact_min["h"])(
                  'div',
                  { className: '' + redirection_web_style_default.a['wallet-inner'] },
                  Object(preact_min["h"])(
                    'div',
                    {
                      className: redirection_web_style_default.a.check + ' left',
                      style: 'background: ' + themeColor.PAYBUTTONBG + '; color: ' + themeColor.PAYBUTTONTEXT
                    },
                    Object(preact_min["h"])('span', { className: '' + redirection_web_style_default.a.sign1, style: 'background: ' + themeColor.PAYBUTTONTEXT }),
                    Object(preact_min["h"])('span', { className: '' + redirection_web_style_default.a.sign2, style: 'background: ' + themeColor.PAYBUTTONTEXT })
                  ),
                  Object(preact_min["h"])(
                    'div',
                    { className: redirection_web_style_default.a['check-txt'] + ' left' },
                    Object(preact_min["h"])(
                      'h6',
                      { className: '' + redirection_web_style_default.a['wallet-txt'] },
                      'Paytm Balance'
                    ),
                    Object(preact_min["h"])(
                      'p',
                      { className: '' + redirection_web_style_default.a['wallet-para'], style: 'color: ' + themeColor.BODYTEXT },
                      'Available Balance \u20B912,000'
                    ),
                    Object(preact_min["h"])('img', {
                      className: '' + redirection_web_style_default.a['sc-img'],
                      src: common["a" /* default */].getStaticPath() + '/assets/images/pb-icon-new.svg',
                      alt: ''
                    }),
                    Object(preact_min["h"])(
                      'div',
                      {
                        className: '' + redirection_web_style_default.a.payBtn,
                        style: 'background: ' + themeColor.PAYBUTTONBG + '; color: ' + themeColor.PAYBUTTONTEXT
                      },
                      Object(preact_min["h"])('img', {
                        className: redirection_web_style_default.a.payBtnimg + ' pos-r',
                        src: common["a" /* default */].getStaticPath() + '/assets/images/lock.png',
                        alt: ''
                      }),
                      'Pay \u20B95,876'
                    )
                  )
                )
              ),
              Object(preact_min["h"])(
                'div',
                { className: '' + redirection_web_style_default.a['pay-list-wrap'], style: 'border-color:' + themeColor.BORDER },
                Object(preact_min["h"])(
                  'h5',
                  { className: '' + redirection_web_style_default.a['choose-txt'], style: 'color: ' + themeColor.BODYTEXT },
                  'Saved Cards'
                ),
                Object(preact_min["h"])(
                  'ul',
                  { className: '' + redirection_web_style_default.a['pay-list'] },
                  Object(preact_min["h"])(
                    'li',
                    null,
                    Object(preact_min["h"])('span', { className: '' + redirection_web_style_default.a['radio-circle'], style: 'border-color:' + themeColor.BODYTEXT + ';' }),
                    web__ref2,
                    Object(preact_min["h"])(
                      'p',
                      { style: 'color:' + themeColor.BODYTEXT + ';' },
                      'MASTER \u2022\u2022\u2022\u2022 2021',
                      ' ',
                      Object(preact_min["h"])('img', {
                        className: '' + redirection_web_style_default.a.cardtype,
                        src: common["a" /* default */].getStaticPath() + '/assets/images/master.svg'
                      })
                    ),
                    Object(preact_min["h"])('img', {
                      className: '' + redirection_web_style_default.a['sc-img'],
                      src: common["a" /* default */].getStaticPath() + '/assets/images/hdfc-logo-new.png',
                      alt: ''
                    }),
                    Object(preact_min["h"])('div', { className: redirection_web_style_default.a['border-div'] + ' pos-a', style: 'background:' + themeColor.BORDER })
                  ),
                  Object(preact_min["h"])(
                    'li',
                    null,
                    Object(preact_min["h"])('span', { className: '' + redirection_web_style_default.a['radio-circle'], style: 'border-color:' + themeColor.BODYTEXT + ';' }),
                    web__ref3,
                    Object(preact_min["h"])(
                      'p',
                      { style: 'color:' + themeColor.BODYTEXT + ';' },
                      'VISA \u2022\u2022\u2022\u2022 8781',
                      ' ',
                      Object(preact_min["h"])('img', { className: '' + redirection_web_style_default.a.cardtype, src: common["a" /* default */].getStaticPath() + '/assets/images/visa.svg' })
                    ),
                    Object(preact_min["h"])('img', {
                      className: '' + redirection_web_style_default.a['sc-img'],
                      src: common["a" /* default */].getStaticPath() + '/assets/images/axis-logo-new.png',
                      alt: ''
                    }),
                    Object(preact_min["h"])('div', { className: redirection_web_style_default.a['border-div'] + ' pos-a', style: 'background:' + themeColor.BORDER })
                  )
                )
              ),
              Object(preact_min["h"])(
                'div',
                { className: '' + redirection_web_style_default.a['grid-wrap'], style: 'border-color:' + themeColor.BORDER },
                merchantPayModes && merchantPayModes.length > 0 && Object(preact_min["h"])(
                  'h5',
                  { className: '' + redirection_web_style_default.a['choose-txt'], style: 'color: ' + themeColor.BODYTEXT },
                  'New Payment Option'
                ),
                merchantPayModes && merchantPayModes.map(function (paymodeObj) {
                  var paymodeName = paymodeObj.name;
                  if (paymodeObj.type == 'CARD') {
                    paymodeName = constants["n" /* default */].CARD_NAME;
                  }
                  if (paymodeObj.type == 'UPI') {
                    paymodeName = constants["n" /* default */].UPI;
                  }
                  return Object(preact_min["h"])(
                    'div',
                    { className: '' + redirection_web_style_default.a.grid, style: 'border-color:' + themeColor.BORDER },
                    Object(preact_min["h"])(
                      'div',
                      { className: redirection_web_style_default.a['pay-method'] + ' pos-r' },
                      Object(preact_min["h"])('img', {
                        className: '' + redirection_web_style_default.a['grid-img'],
                        src: common["a" /* default */].getStaticPath() + '/assets/images/' + ((constants["m" /* THEME_CONSTANTS */].DARK == themeColor.NAME ? paymodeObj.type + '.dark' : paymodeObj.type) + '.svg')
                      }),
                      Object(preact_min["h"])(
                        'span',
                        null,
                        paymodeName
                      )
                    )
                  );
                })
              )
            ),
            isPaytmBrandingDisplay && Object(preact_min["h"])(
              'div',
              {
                className: '' + redirection_web_style_default.a['m-footer']
                // style={`background: ${themeColor.BODYBG}; color: ${themeColor.BODYTEXT}`}
              },
              Object(preact_min["h"])('img', { className: '' + redirection_web_style_default.a.secure, src: common["a" /* default */].getStaticPath() + '/assets/images/secure.png' }),
              ' 100% Secure Payments Powered by Paytm'
            )
          )
        )
      )
    );
  };

  return Web;
}(preact_min["Component"]);

/* harmony default export */ var redirection_web = (Object(preact["connect"])('merchantPayModes, timestamp, isPaytmBrandingDisplay,onInvertImgLogo', null)(redirection_web_Web));
// EXTERNAL MODULE: ./checkout/components/redirection/style.css
var redirection_style = __webpack_require__("GAtr");
var redirection_style_default = /*#__PURE__*/__webpack_require__.n(redirection_style);

// CONCATENATED MODULE: ./checkout/components/redirection/index.js


function redirection__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function redirection__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function redirection__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var redirection_Redirection = function (_Component) {
  redirection__inherits(Redirection, _Component);

  function Redirection(props) {
    redirection__classCallCheck(this, Redirection);

    var _this = redirection__possibleConstructorReturn(this, _Component.call(this, props));

    _this.onPreviewToggle = function (label, value) {
      if (_this.props && _this.props.onPreviewToggle) {
        common["a" /* default */].log('onPreviewChange', label);
        _this.props.onPreviewToggle(value);
      }
    };

    return _this;
  }

  Redirection.prototype.render = function render(_ref) {
    var isMobilePreviewSelected = _ref.isMobilePreviewSelected,
        selected = _ref.selected;

    return Object(preact_min["h"])(
      'section',
      null,
      Object(preact_min["h"])(
        'div',
        { className: '' + redirection_style_default.a['view-tab'] },
        Object(preact_min["h"])(
          'ul',
          { className: '' + redirection_style_default.a['view-list'] },
          Object(preact_min["h"])(
            'li',
            {
              className: redirection_style_default.a['view-item'] + ' ' + redirection_style_default.a[!isMobilePreviewSelected ? 'active' : ''],
              onClick: this.onPreviewToggle.bind(this, 'Web', false)
            },
            'Web'
          ),
          Object(preact_min["h"])(
            'li',
            {
              className: redirection_style_default.a['view-item'] + ' ' + redirection_style_default.a[isMobilePreviewSelected ? 'active' : ''],
              onClick: this.onPreviewToggle.bind(this, 'Mobile', true)
            },
            'Mobile'
          )
        )
      ),
      !isMobilePreviewSelected && selected.web && Object(preact_min["h"])(redirection_web, { themeColor: selected.web }),
      isMobilePreviewSelected && selected.mobile && Object(preact_min["h"])(redirection_mobile, { themeColor: selected.mobile })
    );
  };

  return Redirection;
}(preact_min["Component"]);

/* harmony default export */ var redirection = (Object(preact["connect"])('isMobilePreviewSelected, selected', theme_checkout["b" /* onChange */])(redirection_Redirection));
// CONCATENATED MODULE: ./checkout/components/preview/index.js


function preview__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function preview__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function preview__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var preview__ref2 = Object(preact_min["h"])(jscheckout, null);

var preview_Preview = function (_Component) {
  preview__inherits(Preview, _Component);

  function Preview(props) {
    preview__classCallCheck(this, Preview);

    var _this = preview__possibleConstructorReturn(this, _Component.call(this, props));

    _this.onPreviewTabChange = function (label, value) {
      if (_this.props && _this.props.onPreviewTabChange) {
        common["a" /* default */].log('onPreviewTabChange', label);
        _this.props.onPreviewTabChange(value);
      }
    };

    return _this;
  }

  Preview.prototype.render = function render(_ref) {
    var isRedirectionTabSelected = _ref.isRedirectionTabSelected,
        isThematicFeatureUsed = _ref.isThematicFeatureUsed;

    return Object(preact_min["h"])(
      'div',
      { 'class': 'right-content left' },
      Object(preact_min["h"])(
        'p',
        { 'class': 'preview-info uppercase metalic-blue' },
        Object(i18n["b" /* locale */])('checkout.preview')
      ),
      Object(preact_min["h"])(
        'div',
        { 'class': 'tab-area' },
        Object(preact_min["h"])(
          'ul',
          { 'class': 'tab-list' },
          Object(preact_min["h"])(
            'li',
            {
              className: (!isRedirectionTabSelected ? 'active-mode' : '') + ' ',
              onClick: this.onPreviewTabChange.bind(this, Object(i18n["b" /* locale */])('checkout.title'), false)
            },
            Object(i18n["b" /* locale */])('checkout.checkout.tab')
          )
        ),
        !isRedirectionTabSelected && preview__ref2
      )
    );
  };

  return Preview;
}(preact_min["Component"]);

/* harmony default export */ var preview = (Object(preact["connect"])('isRedirectionTabSelected, isThematicFeatureUsed', theme_checkout["b" /* onChange */])(preview_Preview));
// CONCATENATED MODULE: ./checkout/components/async/codeintegration/index.js

		

		function codeintegration_load(cb) {
			__webpack_require__.e/* require.ensure */(3).then((function(require) {
				cb(__webpack_require__("B3iM"));
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var codeintegration = (async_default()(codeintegration_load));
	
// EXTERNAL MODULE: ./checkout/components/introduction/style.css
var introduction_style = __webpack_require__("0M3z");
var introduction_style_default = /*#__PURE__*/__webpack_require__.n(introduction_style);

// CONCATENATED MODULE: ./checkout/components/introduction/index.js


function introduction__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function introduction__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function introduction__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var introduction__ref = Object(preact_min["h"])(
  'li',
  null,
  'No redirection'
);

var introduction__ref2 = Object(preact_min["h"])(
  'li',
  null,
  'Integration with minimal code'
);

var introduction__ref3 = Object(preact_min["h"])(
  'li',
  null,
  'Enhanced success rates'
);

var introduction__ref4 = Object(preact_min["h"])(
  'li',
  null,
  'Personalized payments experience for users'
);

var introduction__ref5 = Object(preact_min["h"])(
  'li',
  null,
  'Enhanced brand display with custom UI'
);

var _ref6 = Object(preact_min["h"])(
  'li',
  null,
  'Biggest repository of ~200 million saved cards'
);

var _ref7 = Object(preact_min["h"])(
  'li',
  null,
  'Auto update on addition of payment options'
);

var _ref8 = Object(preact_min["h"])(
  'h4',
  null,
  'Step 3'
);

var introduction_Introduction = function (_Component) {
  introduction__inherits(Introduction, _Component);

  function Introduction(props) {
    introduction__classCallCheck(this, Introduction);

    var _this = introduction__possibleConstructorReturn(this, _Component.call(this, props));

    _this.getStartedClick = _this.getStartedClick.bind(_this);
    return _this;
  }

  Introduction.prototype.componentDidMount = function componentDidMount() {
    common["a" /* default */].log('onLoad', 'Introduction Page');
  };

  Introduction.prototype.getStartedClick = function getStartedClick() {
    common["a" /* default */].log('onClick', 'Get Started');
    if (this.props && this.props.onKeyValueChange) {
      api["a" /* default */].updateCheckoutPreference({ prefName: 'isIntroductionPageVisible', prefValue: 'Y' }).then(function () {
        //
      }).catch(function () {
        //
      });
      this.props.onKeyValueChange('isIntroductionPageVisible', false);
    }
  };

  Introduction.prototype.render = function render() {
    return Object(preact_min["h"])(
      'div',
      { className: 'wrapper' },
      Object(preact_min["h"])(
        'div',
        { className: '' + introduction_style_default.a.introBox },
        Object(preact_min["h"])(
          'div',
          { className: introduction_style_default.a.introLeft + ' left' },
          Object(preact_min["h"])(
            'h2',
            { className: 'main-heading ' + introduction_style_default.a['intro-heading'] },
            Object(i18n["b" /* locale */])('checkout.title')
          ),
          Object(preact_min["h"])(
            'p',
            { className: introduction_style_default.a.subtext + ' metalic-blue' },
            'Redirection less payment flow, providing a seamless experience that can be easily integrated by just dropping a prebuilt code customized for you'
          ),
          Object(preact_min["h"])(
            'div',
            { className: '' + introduction_style_default.a['benefits-heading'] },
            Object(preact_min["h"])('img', { className: '' + introduction_style_default.a.ribbon, src: common["a" /* default */].getStaticPath() + '/assets/images/ribbon.svg', alt: '' }),
            ' ',
            'Benefits of ',
            Object(i18n["b" /* locale */])('checkout.title')
          ),
          Object(preact_min["h"])(
            'ul',
            { className: '' + introduction_style_default.a['intro-list'] },
            introduction__ref,
            introduction__ref2,
            introduction__ref3,
            introduction__ref4,
            introduction__ref5,
            _ref6,
            _ref7
          ),
          Object(preact_min["h"])(
            'div',
            { className: '' + introduction_style_default.a['cta-wrap'] },
            Object(preact_min["h"])(
              'button',
              { className: 'btn btn-primary ' + introduction_style_default.a['cta-btn'], onClick: this.getStartedClick },
              'Get Started'
            )
          )
        ),
        Object(preact_min["h"])(
          'div',
          { className: introduction_style_default.a.introRight + ' right' },
          Object(preact_min["h"])(
            'video',
            { width: '640', height: '328', controls: true },
            Object(preact_min["h"])('source', { src: common["a" /* default */].getStaticPath() + '/assets/video/JS-checkout.mp4', type: 'video/mp4' }),
            Object(preact_min["h"])('source', { src: common["a" /* default */].getStaticPath() + '/assets/video/JS-checkout.ogv', type: 'video/ogg' }),
            Object(preact_min["h"])('source', { src: common["a" /* default */].getStaticPath() + '/assets/video/JS-checkout.webm', type: 'video/webm' }),
            'Your browser does not support the video tag.'
          )
        )
      ),
      Object(preact_min["h"])(
        'div',
        { className: '' + introduction_style_default.a['payment-step-info'] },
        Object(preact_min["h"])(
          'h2',
          { className: 'text-center ' + introduction_style_default.a['payment-heading'] },
          'Be payments ready within an hour'
        ),
        Object(preact_min["h"])(
          'p',
          { className: 'text-center ' + introduction_style_default.a['payment-para'] + ' metalic-blue' },
          'All you need to do is complete payment page setup by following 3 simple steps'
        ),
        Object(preact_min["h"])(
          'div',
          { className: '' + introduction_style_default.a['step-row'] },
          Object(preact_min["h"])(
            'div',
            { className: '' + introduction_style_default.a['step-wrap'] },
            Object(preact_min["h"])(
              'h4',
              null,
              'Step 1',
              ' ',
              Object(preact_min["h"])('img', {
                className: '' + introduction_style_default.a['arrow-icon'],
                src: common["a" /* default */].getStaticPath() + '/assets/images/ic-arrow-back.svg',
                alt: ''
              })
            ),
            Object(preact_min["h"])(
              'p',
              { className: 'metalic-blue' },
              'Easily customize your checkout page design as per your theme and requirements'
            ),
            Object(preact_min["h"])('img', { src: common["a" /* default */].getStaticPath() + '/assets/images/step1.png', alt: '' }),
            Object(preact_min["h"])('div', { className: '' + introduction_style_default.a['content-wrap'] })
          ),
          Object(preact_min["h"])(
            'div',
            { className: '' + introduction_style_default.a['step-wrap'] },
            Object(preact_min["h"])(
              'h4',
              null,
              'Step 2',
              ' ',
              Object(preact_min["h"])('img', {
                className: '' + introduction_style_default.a['arrow-icon'],
                src: common["a" /* default */].getStaticPath() + '/assets/images/ic-arrow-back.svg',
                alt: ''
              }),
              ' '
            ),
            Object(preact_min["h"])(
              'p',
              { className: 'metalic-blue' },
              'Copy paste single line JS code (customized for you by Paytm) into your script'
            ),
            Object(preact_min["h"])('img', {
              className: '' + introduction_style_default.a['content-wrap'],
              src: common["a" /* default */].getStaticPath() + '/assets/images/step2.png',
              alt: ''
            }),
            Object(preact_min["h"])('div', { className: '' + introduction_style_default.a['content-wrap'] })
          ),
          Object(preact_min["h"])(
            'div',
            { className: '' + introduction_style_default.a['step-wrap'] },
            _ref8,
            Object(preact_min["h"])(
              'p',
              { className: 'metalic-blue' },
              'Test checkout process in staging environment and gain access to production API keys for going LIVE'
            ),
            Object(preact_min["h"])('img', { src: common["a" /* default */].getStaticPath() + '/assets/images/step3.png', alt: '' }),
            Object(preact_min["h"])('div', { className: '' + introduction_style_default.a['content-wrap'] })
          )
        ),
        Object(preact_min["h"])(
          'div',
          { className: introduction_style_default.a['btm-info'] + ' text-center' },
          Object(preact_min["h"])(
            'p',
            null,
            Object(preact_min["h"])(
              'a',
              {
                target: '_blank',
                rel: 'noopener noreferrer',
                href: 'https://developer.paytm.com/docs/blink-checkout/',
                className: 'primary'
              },
              'Learn more'
            ),
            ' ',
            'about ',
            Object(i18n["b" /* locale */])('checkout.title')
          ),
          Object(preact_min["h"])(
            'button',
            { 'class': 'btn btn-primary save', onClick: this.getStartedClick },
            'Get Started'
          )
        )
      )
    );
  };

  return Introduction;
}(preact_min["Component"]);

/* harmony default export */ var introduction = (Object(preact["connect"])('isIntroductionPageVisible', theme_checkout["b" /* onChange */])(introduction_Introduction));
// EXTERNAL MODULE: ./checkout/components/error/style.css
var error_style = __webpack_require__("x75c");
var error_style_default = /*#__PURE__*/__webpack_require__.n(error_style);

// CONCATENATED MODULE: ./checkout/components/error/index.js


function error__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function error__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function error__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var error_Error = function (_Component) {
  error__inherits(Error, _Component);

  function Error(props) {
    error__classCallCheck(this, Error);

    var _this = error__possibleConstructorReturn(this, _Component.call(this, props));

    _this.retry = _this.retry.bind(_this);
    _this.state = {
      errorMSG: props.appData && props.appData.errorMSG || 'Oops! Something went wrong'
    };
    return _this;
  }

  Error.prototype.retry = function retry() {
    if (this.props && this.props.appData) {
      common["a" /* default */].log('onRetryClick', 'Retry Button');
      Object(postMessage["a" /* postMessageOnParentWindow */])(this.props.appData);
    }
  };

  Error.prototype.render = function render(_ref, _ref2) {
    var appData = _ref.appData;
    var errorMSG = _ref2.errorMSG;

    return Object(preact_min["h"])(
      'div',
      { 'class': 'wrapper' },
      Object(preact_min["h"])(
        'h2',
        { 'class': 'main-heading heading-trim' },
        Object(i18n["b" /* locale */])('checkout.title')
      ),
      Object(preact_min["h"])(
        'div',
        { className: '' + error_style_default.a['error-page-wrap'] },
        Object(preact_min["h"])('img', {
          className: '' + error_style_default.a['error-img'],
          src: common["a" /* default */].getStaticPath() + '/assets/images/not-found.svg',
          alt: ''
        }),
        Object(preact_min["h"])(
          'h2',
          { className: '' + error_style_default.a['error-heading'] },
          appData && appData.body && appData.body.resultInfo && appData.body.resultInfo.resultMsg || errorMSG
        ),
        appData && appData.body && appData.body.resultInfo && appData.body.resultInfo.resultCode == '449' && Object(preact_min["h"])(
          'button',
          { className: error_style_default.a['retry-btn'] + ' btn btn-primary', onClick: this.retry },
          'Retry'
        )
      )
    );
  };

  return Error;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./checkout/components/transparent-button/style.css
var transparent_button_style = __webpack_require__("+y/E");
var transparent_button_style_default = /*#__PURE__*/__webpack_require__.n(transparent_button_style);

// CONCATENATED MODULE: ./checkout/components/transparent-button/index.js


function transparent_button__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function transparent_button__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function transparent_button__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var transparent_button_Button = function (_Component) {
  transparent_button__inherits(Button, _Component);

  function Button() {
    transparent_button__classCallCheck(this, Button);

    return transparent_button__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Button.prototype.render = function render(_ref) {
    var onButtonClick = _ref.onButtonClick,
        name = _ref.name,
        image = _ref.image,
        codespace = _ref.codespace;

    return Object(preact_min["h"])(
      'button',
      { 'class': 'btn ' + transparent_button_style_default.a['btn-secondary'], onClick: onButtonClick },
      image && Object(preact_min["h"])('img', { src: image }),
      codespace,
      Object(preact_min["h"])(
        'span',
        null,
        name
      )
    );
  };

  return Button;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./checkout/components/common.js


function common__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function common__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function common__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var common__ref2 = Object(preact_min["h"])(steps, null);

var common__ref3 = Object(preact_min["h"])(
  'div',
  { 'class': 'theme-content' },
  Object(preact_min["h"])(themesection, null),
  Object(preact_min["h"])(preview, null)
);

var common__ref4 = Object(preact_min["h"])(codeintegration, null);

var common__ref5 = Object(preact_min["h"])(introduction, null);

var common_Common = function (_Component) {
  common__inherits(Common, _Component);

  function Common(props) {
    common__classCallCheck(this, Common);

    return common__possibleConstructorReturn(this, _Component.call(this, props));
  }

  Common.prototype.updateLabelValue = function updateLabelValue(key) {
    if (this.props && this.props.onKeyValueChange) {
      common["a" /* default */].log('onClick', key);

      api["a" /* default */].updateCheckoutPreference({ prefName: key, prefValue: 'N' }).then(function () {
        //
      }).catch(function () {
        //
      });
      this.props.onKeyValueChange(key, true);

      if (key == 'isIntroductionPageVisible') {
        this.props.onKeyValueChange('isGenerateCodeStepEnabled', false);
      }
    }
  };

  Common.prototype.render = function render(_ref) {
    var isJSCheckoutIntegrated = _ref.isJSCheckoutIntegrated,
        isGenerateCodeStepEnabled = _ref.isGenerateCodeStepEnabled,
        isIntroductionPageVisible = _ref.isIntroductionPageVisible,
        isError = _ref.isError,
        APP_DATA = _ref.APP_DATA;

    return Object(preact_min["h"])(
      'section',
      null,
      !isError && !isIntroductionPageVisible && Object(preact_min["h"])(
        'div',
        { 'class': 'wrapper' },
        Object(preact_min["h"])(
          'div',
          null,
          Object(preact_min["h"])(
            'h2',
            { 'class': 'main-heading heading-trim' },
            Object(i18n["b" /* locale */])('checkout.title')
          ),
          (!isIntroductionPageVisible || !isJSCheckoutIntegrated) && Object(preact_min["h"])(
            'div',
            { 'class': 'btn-box' },
            !isJSCheckoutIntegrated && Object(preact_min["h"])(transparent_button_Button, {
              codespace: '</>',
              name: 'Complete JS Integration',
              onButtonClick: this.updateLabelValue.bind(this, 'isJSCheckoutIntegrated')
            }),
            !isIntroductionPageVisible && Object(preact_min["h"])(transparent_button_Button, {
              image: common["a" /* default */].getStaticPath() + '/assets/images/ic-lightbulb-outline.svg',
              name: 'Need help? Take a tour',
              onButtonClick: this.updateLabelValue.bind(this, 'isIntroductionPageVisible')
            })
          )
        ),
        isJSCheckoutIntegrated && common__ref2,
        !isGenerateCodeStepEnabled && common__ref3,
        isGenerateCodeStepEnabled && common__ref4
      ),
      isError && Object(preact_min["h"])(error_Error, { appData: APP_DATA }),
      !isError && isIntroductionPageVisible && common__ref5
    );
  };

  return Common;
}(preact_min["Component"]);

/* harmony default export */ var components_common = (Object(preact["connect"])('isGenerateCodeStepEnabled, isIntroductionPageVisible, isError, isJSCheckoutIntegrated', theme_checkout["b" /* onChange */])(common_Common));
// CONCATENATED MODULE: ./checkout/components/app.js


function app__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function app__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function app__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function app__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* Start -  Use this till locale resolver not implemented on backend */
/* End - Use this till locale resolver not implemented on backend */











i18n["a" /* i18nUtils */].load(en);

var app_App = function (_Component) {
  app__inherits(App, _Component);

  function App(props) {
    app__classCallCheck(this, App);

    // window.APP_DATA = { "body": { "restStatus": "SUCCESS", "resultInfo": { "resultCode": "00000", "resultStatus": "S", "messaage": "Success" }, "mid": "AliPay17495354925718", "themePreferenceInfos": { "REDIRECTION": { "mobile": { "HEADERPANEL": "#3293ab", "HEADERTEXT": "#000000", "PAYBUTTONBG": "#00b9f5", "PAYBUTTONTEXT": "#FFFFFF", "BODYBG": "#FFFFFF", "BODYTEXT": "#1D252D", "BOTTOMBG": "#F3F7F8", "LABEL": "Custom theme", "NAME": "CUSTOM", "IMAGE": "custom", "isSelected": true }, "web": { "HEADERPANEL": "#3293ab", "HEADERTEXT": "#000000", "PAYBUTTONBG": "#00b9f5", "PAYBUTTONTEXT": "#FFFFFF", "BODYBG": "#FFFFFF", "BODYTEXT": "#1D252D", "BOTTOMBG": "#F3F7F8", "LABEL": "Custom theme", "NAME": "CUSTOM", "IMAGE": "custom", "isSelected": true } }, "CHECKOUT": { "mobile": { "HEADERPANEL": "#3293ab", "HEADERTEXT": "#000000", "PAYBUTTONBG": "#00b9f5", "PAYBUTTONTEXT": "#FFFFFF", "BODYBG": "#FFFFFF", "BODYTEXT": "#1D252D", "BOTTOMBG": "#F3F7F8", "LABEL": "Custom theme", "NAME": "CUSTOM", "IMAGE": "custom", "isSelected": true }, "web": { "HEADERPANEL": "#3293ab", "HEADERTEXT": "#000000", "PAYBUTTONBG": "#00b9f5", "PAYBUTTONTEXT": "#FFFFFF", "BODYBG": "#FFFFFF", "BODYTEXT": "#1D252D", "BOTTOMBG": "#F3F7F8", "LABEL": "Custom theme", "NAME": "CUSTOM", "IMAGE": "custom", "isSelected": true } } } } }
    // window.APP_DATA = {"body":{"resultInfo":{"resultStatus":"S","resultCode":"0000","resultMsg":"Success"},"themePreferenceInfos":{"REDIRECTION":{"mobile":{"HEADERPANEL":"#F3F7F8","HEADERTEXT":"#000000","PAYBUTTONBG":"#00b9f5","PAYBUTTONTEXT":"#FFFFFF","BODYBG":"#FFFFFF","BODYTEXT":"#1D252D","BOTTOMBG":"#F3F7F8","LABEL":"Light theme","NAME":"LIGHT","IMAGE":"light","isSelected":true},"web":{"HEADERPANEL":"#F3F7F8","HEADERTEXT":"#000000","PAYBUTTONBG":"#00b9f5","PAYBUTTONTEXT":"#FFFFFF","BODYBG":"#FFFFFF","BODYTEXT":"#1D252D","BOTTOMBG":"#F3F7F8","LABEL":"Light theme","NAME":"LIGHT","IMAGE":"light","isSelected":true},"merchant":{"hidePaytmBranding":false},"payMode":{"order":[{"name":"BHIM UPI","type":"UPI","id":"120100000004072099267"},{"name":"EMI","type":"EMI","id":"120100000004072099267"},{"name":"Net Banking","type":"NB","id":"120100000004072099267"},{"name":"Debit/Credit Card","type":"CARD","id":"120100000004067800261"}]}},"CHECKOUT":{"root":"","style":{"bodyBackgroundColor":"#FFFFFF","bodyColor":"#1D252D","themeBackgroundColor":"#00b9f5","themeColor":"#FFFFFF","headerBackgroundColor":"#F3F7F8","headerColor":"#000000","errorColor":"","successColor":""},"jsFile":"","data":{"orderId":"","token":"","tokenType":"SSO","mid":"","userDetail":{"mobileNumber":121212,"name":""}},"merchant":{"name":"","logo":"","redirect":true,"callbackUrl":"","hidePaytmBranding":false,"payMode":[{"name":"BHIM UPI","type":"UPI","id":"120100000004072099267"},{"name":"Debit/Credit Card","type":"CARD","id":"120100000004067800261"}]},"mapClientMessage":{},"labels":{},"payMode":{"labels":{},"filter":{"include":[],"exclude":[]},"order":[{"name":"BHIM UPI","type":"UPI","id":"120100000004072099267"},{"name":"Debit/Credit Card","type":"CARD","id":"120100000004067800261"}]},"handler":{}},"isJSCheckoutIntegrated":true},"token":"eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJtaWQiOiJhenRnQXo0OTM5MTY4MDc2NDc0MCIsInVpZCI6ImF6dGdBejQ5MzkxNjgwNzY0NzQwIiwiY2xpZW50SWQiOiJjbGllbnQxMjM0NSIsImlhdCI6MTU3OTA5NzY5NiwiZXhwIjoxNTc5MTA5Njk2fQ.m3vwOxWtoLPcke6ucV2553tZrcQobTZTXXCtuJVfA5eQk-4Dxvmg3mke_zarLBvA2ebymq5Re7bB8WN47_pv1g","mid":"aztgAz49391680764740","merchantPreferenceInfos":{"PG_AUTOLOGIN_ENABLED":"N","THEMATIC_FEATURE_USED":"Y","PG_SECURE_FOOTER_ENABLED":null,"IS_JSCHECKOUT_USED":"","IS_JSCHECKOUT_CODE_INTEGRATED":"N"},"merchantPaymodesPreferenceOrder":{"CARD":{"payMethod":"CARD","recordId":"120100000004067800261","serviceInstId":"HDFC","serviceInstName":"HDFC Bank","displayName":"Debit / Credit Card","isUsed":true},"UPI":{"payMethod":"UPI","recordId":"120100000004072099267","serviceInstId":"ICICI","serviceInstName":"ICICI Bank","displayName":"BHIM UPI","isUsed":true},"EMI":{"payMethod":"EMI","recordId":"120100000004067800261","serviceInstId":"HDFC","serviceInstName":"HDFC Bank","displayName":"Debit / Credit Card","isUsed":true},"NB":{"payMethod":"NB","recordId":"120100000004067800261","serviceInstId":"HDFC","serviceInstName":"HDFC Bank","displayName":"Debit / Credit Card","isUsed":true}}},"selected":{"mobile":{"HEADERPANEL":"#F3F7F8","HEADERTEXT":"#000000","PAYBUTTONBG":"#00b9f5","PAYBUTTONTEXT":"#FFFFFF","BODYBG":"#FFFFFF","BODYTEXT":"#1D252D","BOTTOMBG":"#F3F7F8","LABEL":"Light theme","NAME":"LIGHT","IMAGE":"light","isSelected":true},"web":{"HEADERPANEL":"#F3F7F8","HEADERTEXT":"#000000","PAYBUTTONBG":"#00b9f5","PAYBUTTONTEXT":"#FFFFFF","BODYBG":"#FFFFFF","BODYTEXT":"#1D252D","BOTTOMBG":"#F3F7F8","LABEL":"Light theme","NAME":"LIGHT","IMAGE":"light","isSelected":true},"merchant":{"hidePaytmBranding":false},"payMode":{"order":[{"name":"BHIM UPI","type":"UPI","id":"120100000004072099267"},{"name":"Debit/Credit Card","type":"CARD","id":"120100000004067800261"}]}},"CHECKOUT_THEME":{"root":"","style":{"bodyBackgroundColor":"#FFFFFF","bodyColor":"#1D252D","themeBackgroundColor":"#00b9f5","themeColor":"#FFFFFF","headerBackgroundColor":"#F3F7F8","headerColor":"#000000","errorColor":"","successColor":""},"jsFile":"","data":{"orderId":"","token":"","tokenType":"SSO","mid":"","userDetail":{"mobileNumber":121212,"name":""}},"merchant":{"name":"","logo":"","redirect":true,"callbackUrl":"","hidePaytmBranding":false,"payMode":[{"name":"BHIM UPI","type":"UPI","id":"120100000004072099267"},{"name":"Debit/Credit Card","type":"CARD","id":"120100000004067800261"}]},"mapClientMessage":{},"labels":{},"payMode":{"labels":{},"filter":{"include":[],"exclude":[]},"order":[{"name":"BHIM UPI","type":"UPI","id":"120100000004072099267"},{"name":"Debit/Credit Card","type":"CARD","id":"120100000004067800261"}]},"handler":{}},"token":"eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJtaWQiOiJhenRnQXo0OTM5MTY4MDc2NDc0MCIsInVpZCI6ImF6dGdBejQ5MzkxNjgwNzY0NzQwIiwiY2xpZW50SWQiOiJjbGllbnQxMjM0NSIsImlhdCI6MTU3OTA5NzY5NiwiZXhwIjoxNTc5MTA5Njk2fQ.m3vwOxWtoLPcke6ucV2553tZrcQobTZTXXCtuJVfA5eQk-4Dxvmg3mke_zarLBvA2ebymq5Re7bB8WN47_pv1g","isPaytmBrandingDisplay":true,"isAutoLoginSupported":false,"isThematicFeatureUsed":true,"isIntroductionPageVisible":false,"isJSCheckoutIntegrated":false,"merchantPayModes":[{"name":"BHIM UPI","type":"UPI","id":"120100000004072099267"},{"name":"EMI","type":"EMI","id":"120100000004072099267"},{"name":"Debit/Credit Card","type":"CARD","id":"120100000004067800261"}],"MobileTheme":{"LIGHTTHEME":{"HEADERPANEL":"#F3F7F8","HEADERTEXT":"#000000","PAYBUTTONBG":"#00b9f5","PAYBUTTONTEXT":"#FFFFFF","BODYBG":"#FFFFFF","BODYTEXT":"#1D252D","BOTTOMBG":"#F3F7F8","LABEL":"Light theme","NAME":"LIGHT","IMAGE":"light","isSelected":true},"DARKTHEME":{"HEADERPANEL":"#0d1528","HEADERTEXT":"#FFFFFF","PAYBUTTONBG":"#00b9f5","PAYBUTTONTEXT":"#FFFFFF","BODYBG":"#000a1e","BODYTEXT":"#FFFFFF","BOTTOMBG":"#000000","LABEL":"Dark theme","NAME":"DARK","IMAGE":"dark","isSelected":false},"CUSTOMTHEME":{"HEADERPANEL":"#F3F7F8","HEADERTEXT":"#000000","PAYBUTTONBG":"#00b9f5","PAYBUTTONTEXT":"#FFFFFF","BODYBG":"#FFFFFF","BODYTEXT":"#1D252D","BOTTOMBG":"#F3F7F8","LABEL":"Custom theme","NAME":"CUSTOM","IMAGE":"custom","isSelected":false}},"WebTheme":{"LIGHTTHEME":{"HEADERPANEL":"#F3F7F8","HEADERTEXT":"#000000","PAYBUTTONBG":"#00b9f5","PAYBUTTONTEXT":"#FFFFFF","BODYBG":"#FFFFFF","BODYTEXT":"#1D252D","BOTTOMBG":"#F3F7F8","LABEL":"Light theme","NAME":"LIGHT","IMAGE":"light","isSelected":true},"DARKTHEME":{"HEADERPANEL":"#0d1528","HEADERTEXT":"#FFFFFF","PAYBUTTONBG":"#00b9f5","PAYBUTTONTEXT":"#FFFFFF","BODYBG":"#000a1e","BODYTEXT":"#FFFFFF","BOTTOMBG":"#000000","LABEL":"Dark theme","NAME":"DARK","IMAGE":"dark","isSelected":false},"CUSTOMTHEME":{"HEADERPANEL":"#F3F7F8","HEADERTEXT":"#000000","PAYBUTTONBG":"#00b9f5","PAYBUTTONTEXT":"#FFFFFF","BODYBG":"#FFFFFF","BODYTEXT":"#1D252D","BOTTOMBG":"#F3F7F8","LABEL":"Custom theme","NAME":"CUSTOM","IMAGE":"custom","isSelected":false}},"customBar":[{"NAME":"Header panel color","KEY":"HEADERPANEL"},{"NAME":"Header text color","KEY":"HEADERTEXT"},{"NAME":"Pay button color","KEY":"PAYBUTTONBG"},{"NAME":"Pay button text color","KEY":"PAYBUTTONTEXT"},{"NAME":"Body text color","KEY":"BODYTEXT"}],"isMobilePreviewSelected":true,"timestamp":1579097700483,"isRedirectionTabSelected":true,"isGenerateCodeStepEnabled":false}
    // window.APP_DATA = {"head":{"version":"v1","responseTimestamp":1580720861146},"body":{"resultInfo":{"resultStatus":"S","resultCode":"0000","resultMsg":"Success"},"themePreferenceInfos":{"REDIRECTION":{"mobile":{"HEADERPANEL":"#74b0be","HEADERTEXT":"#000000","PAYBUTTONBG":"#00b9f5","PAYBUTTONTEXT":"#FFFFFF","BODYBG":"#FFFFFF","BODYTEXT":"#1D252D","BOTTOMBG":"#F3F7F8","LABEL":"Custom theme","NAME":"CUSTOM","IMAGE":"custom","isSelected":true},"web":{"HEADERPANEL":"#74b0be","HEADERTEXT":"#000000","PAYBUTTONBG":"#00b9f5","PAYBUTTONTEXT":"#FFFFFF","BODYBG":"#FFFFFF","BODYTEXT":"#1D252D","BOTTOMBG":"#F3F7F8","LABEL":"Custom theme","NAME":"CUSTOM","IMAGE":"custom","isSelected":true}},"CHECKOUT":{"mobile":{"HEADERPANEL":"#74b0be","HEADERTEXT":"#000000","PAYBUTTONBG":"#00b9f5","PAYBUTTONTEXT":"#FFFFFF","BODYBG":"#FFFFFF","BODYTEXT":"#1D252D","BOTTOMBG":"#F3F7F8","LABEL":"Custom theme","NAME":"CUSTOM","IMAGE":"custom","isSelected":true},"web":{"HEADERPANEL":"#74b0be","HEADERTEXT":"#000000","PAYBUTTONBG":"#00b9f5","PAYBUTTONTEXT":"#FFFFFF","BODYBG":"#FFFFFF","BODYTEXT":"#1D252D","BOTTOMBG":"#F3F7F8","LABEL":"Custom theme","NAME":"CUSTOM","IMAGE":"custom","isSelected":true}}},"token":"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJ1aWQiOiIxMDAwNjY0NDg4IiwibWlkIjoicG14SEJCMzM5MTY0MzM1MzIyMjIiLCJleHAiOjE1ODA3MjI2NjAsImlhdCI6MTU4MDcyMDg2MH0.EqBdS9xDFjZ7g77FdpMsdjmIoPHjP7QjJbQdANRxwaACvE-rcTuZaAefddgCFma8chKNnYU2CEjjcl6CtqJr2g","mid":"pmxHBB33916433532222","merchantPreferenceInfos":{"PG_AUTOLOGIN_ENABLED":"N","THEMATIC_FEATURE_USED":null,"PG_SECURE_FOOTER_ENABLED":null,"IS_JSCHECKOUT_USED":null,"IS_JSCHECKOUT_CODE_INTEGRATED":null},"merchantPaymodesPreferenceOrder":{"NET_BANKING":{"payMethod":"NET_BANKING","recordId":"120100000003972194281","serviceInstId":"PPBL","serviceInstName":"Paytm Payments Bank","displayName":"Net Banking"},"UPI":{"payMethod":"UPI","recordId":"120100000003970370281","serviceInstId":"ICICI","serviceInstName":"ICICI Bank","displayName":"BHIM UPI"}}},"selected":{"mobile":{"HEADERPANEL":"#74b0be","HEADERTEXT":"#000000","PAYBUTTONBG":"#00b9f5","PAYBUTTONTEXT":"#FFFFFF","BODYBG":"#FFFFFF","BODYTEXT":"#1D252D","BOTTOMBG":"#F3F7F8","LABEL":"Custom theme","NAME":"CUSTOM","IMAGE":"custom","isSelected":true},"web":{"HEADERPANEL":"#74b0be","HEADERTEXT":"#000000","PAYBUTTONBG":"#00b9f5","PAYBUTTONTEXT":"#FFFFFF","BODYBG":"#FFFFFF","BODYTEXT":"#1D252D","BOTTOMBG":"#F3F7F8","LABEL":"Custom theme","NAME":"CUSTOM","IMAGE":"custom","isSelected":true}},"CHECKOUT_THEME":{"mobile":{"HEADERPANEL":"#74b0be","HEADERTEXT":"#000000","PAYBUTTONBG":"#00b9f5","PAYBUTTONTEXT":"#FFFFFF","BODYBG":"#FFFFFF","BODYTEXT":"#1D252D","BOTTOMBG":"#F3F7F8","LABEL":"Custom theme","NAME":"CUSTOM","IMAGE":"custom","isSelected":true},"web":{"HEADERPANEL":"#74b0be","HEADERTEXT":"#000000","PAYBUTTONBG":"#00b9f5","PAYBUTTONTEXT":"#FFFFFF","BODYBG":"#FFFFFF","BODYTEXT":"#1D252D","BOTTOMBG":"#F3F7F8","LABEL":"Custom theme","NAME":"CUSTOM","IMAGE":"custom","isSelected":true}},"token":"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJ1aWQiOiIxMDAwNjY0NDg4IiwibWlkIjoicG14SEJCMzM5MTY0MzM1MzIyMjIiLCJleHAiOjE1ODA3MjI2NjAsImlhdCI6MTU4MDcyMDg2MH0.EqBdS9xDFjZ7g77FdpMsdjmIoPHjP7QjJbQdANRxwaACvE-rcTuZaAefddgCFma8chKNnYU2CEjjcl6CtqJr2g","isPaytmBrandingDisplay":true,"isAutoLoginSupported":false,"isThematicFeatureUsed":false,"isIntroductionPageVisible":true,"isJSCheckoutIntegrated":true,"merchantPayModes":[{"name":"Paytm","type":"PAYTM","id":1},{"name":"Net Banking","type":"NET_BANKING","id":"120100000003972194281"},{"name":"BHIM UPI","type":"UPI","id":"120100000003970370281"}],"MobileTheme":{"LIGHTTHEME":{"HEADERPANEL":"#F3F7F8","HEADERTEXT":"#000000","PAYBUTTONBG":"#00b9f5","PAYBUTTONTEXT":"#FFFFFF","BODYBG":"#FFFFFF","BODYTEXT":"#1D252D","BOTTOMBG":"#F3F7F8","LABEL":"Light theme","NAME":"LIGHT","IMAGE":"light","isSelected":true},"DARKTHEME":{"HEADERPANEL":"#0d1528","HEADERTEXT":"#FFFFFF","PAYBUTTONBG":"#00b9f5","PAYBUTTONTEXT":"#FFFFFF","BODYBG":"#000a1e","BODYTEXT":"#FFFFFF","BOTTOMBG":"#000000","LABEL":"Dark theme","NAME":"DARK","IMAGE":"dark","isSelected":false},"CUSTOMTHEME":{"HEADERPANEL":"#74b0be","HEADERTEXT":"#000000","PAYBUTTONBG":"#00b9f5","PAYBUTTONTEXT":"#FFFFFF","BODYBG":"#FFFFFF","BODYTEXT":"#1D252D","BOTTOMBG":"#F3F7F8","LABEL":"Custom theme","NAME":"CUSTOM","IMAGE":"custom","isSelected":true}},"WebTheme":{"LIGHTTHEME":{"HEADERPANEL":"#F3F7F8","HEADERTEXT":"#000000","PAYBUTTONBG":"#00b9f5","PAYBUTTONTEXT":"#FFFFFF","BODYBG":"#FFFFFF","BODYTEXT":"#1D252D","BOTTOMBG":"#F3F7F8","LABEL":"Light theme","NAME":"LIGHT","IMAGE":"light","isSelected":true},"DARKTHEME":{"HEADERPANEL":"#0d1528","HEADERTEXT":"#FFFFFF","PAYBUTTONBG":"#00b9f5","PAYBUTTONTEXT":"#FFFFFF","BODYBG":"#000a1e","BODYTEXT":"#FFFFFF","BOTTOMBG":"#000000","LABEL":"Dark theme","NAME":"DARK","IMAGE":"dark","isSelected":false},"CUSTOMTHEME":{"HEADERPANEL":"#74b0be","HEADERTEXT":"#000000","PAYBUTTONBG":"#00b9f5","PAYBUTTONTEXT":"#FFFFFF","BODYBG":"#FFFFFF","BODYTEXT":"#1D252D","BOTTOMBG":"#F3F7F8","LABEL":"Custom theme","NAME":"CUSTOM","IMAGE":"custom","isSelected":true}},"customBar":[{"NAME":"Header Panel","KEY":"HEADERPANEL","CODE":"#74b0be"},{"NAME":"Header Text","KEY":"HEADERTEXT","CODE":"#000000"},{"NAME":"Pay Button","KEY":"PAYBUTTONBG","CODE":"#00b9f5"},{"NAME":"Pay Button Text","KEY":"PAYBUTTONTEXT","CODE":"#FFFFFF"},{"NAME":"Body Text","KEY":"BODYTEXT","CODE":"#1D252D"}],"isMobilePreviewSelected":false,"timestamp":1580720867218,"isRedirectionTabSelected":true}
    var _this = app__possibleConstructorReturn(this, _Component.call(this, props));

    var initialStoreValue = Object(cache["get"])('SERVER_APP_DATA') || window && window.APP_DATA || {};
    var APP_DATA = initialStoreValue;
    var isError = !(initialStoreValue && initialStoreValue.body && initialStoreValue.body.themePreferenceInfos && initialStoreValue.body.themePreferenceInfos.REDIRECTION && initialStoreValue.body.themePreferenceInfos.CHECKOUT && initialStoreValue.body.resultInfo && initialStoreValue.body.resultInfo.resultStatus == 'S');
    var store = unistore_es(common["a" /* default */].checkoutParse(initialStoreValue));
    _this.state = { store: store, isError: isError, APP_DATA: APP_DATA };
    return _this;
  }

  App.prototype.componentDidMount = function componentDidMount() {
    common["a" /* default */].log('onLoad', 'Loaded');

    var _state = this.state,
        APP_DATA = _state.APP_DATA,
        isError = _state.isError;


    common["a" /* default */].log('onLoad', 'APP_DATA', { APP_DATA: APP_DATA, ERROR: isError });

    // UMP Event logging purpose
    if (!Object(cache["get"])('SERVER_APP_DATA')) {
      var errorStatusCode = '000'; // Success
      var postMessageObj = this.state.APP_DATA;
      var _isError = this.state.isError;


      if (_isError) {
        if (postMessageObj && postMessageObj.body && postMessageObj.body.resultInfo) {
          if (postMessageObj.body.resultInfo.resultCode == '449') {
            errorStatusCode = '002'; // Retry
          } else {
            errorStatusCode = '001'; // Other Error
          }
        } else {
          errorStatusCode = '001'; // Other Error
        }
      }

      if (postMessageObj && postMessageObj.body && postMessageObj.body.resultInfo) {
        postMessageObj.body.resultInfo.resultCode = errorStatusCode;
      } else {
        postMessageObj = {
          body: { resultInfo: { resultCode: errorStatusCode } }
        };
      }
      Object(postMessage["a" /* postMessageOnParentWindow */])(postMessageObj); // Execute only for client side
    }
  };

  App.prototype.render = function render(_ref, _ref2) {
    var store = _ref2.store,
        isError = _ref2.isError,
        APP_DATA = _ref2.APP_DATA;

    app__objectDestructuringEmpty(_ref);

    return Object(preact_min["h"])(
      preact["Provider"],
      { store: store },
      Object(preact_min["h"])(
        'div',
        { id: 'app' },
        Object(preact_min["h"])(components_common, { APP_DATA: APP_DATA, isError: isError })
      )
    );
  };

  return App;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./index.checkout.js






var index_checkout_getProps = function getProps() {
  var history = createBrowserHistory_default()();
  return { history: history };
};
var index_checkout_props = index_checkout_getProps();
var index_checkout_Entry = function Entry() {
  return Object(preact_min["h"])(app_App, index_checkout_props);
};

/* harmony default export */ var index_checkout = __webpack_exports__["default"] = (index_checkout_Entry);

/***/ }),

/***/ "KM04":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e(e, t) {
    var n,
        o,
        r,
        i,
        l = W;for (i = arguments.length; i-- > 2;) {
      P.push(arguments[i]);
    }t && null != t.children && (P.length || P.push(t.children), delete t.children);while (P.length) {
      if ((o = P.pop()) && void 0 !== o.pop) for (i = o.length; i--;) {
        P.push(o[i]);
      } else "boolean" == typeof o && (o = null), (r = "function" != typeof e) && (null == o ? o = "" : "number" == typeof o ? o += "" : "string" != typeof o && (r = !1)), r && n ? l[l.length - 1] += o : l === W ? l = [o] : l.push(o), n = r;
    }var a = new T();return a.nodeName = e, a.children = l, a.attributes = null == t ? void 0 : t, a.key = null == t ? void 0 : t.key, void 0 !== M.vnode && M.vnode(a), a;
  }function t(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function n(e, t) {
    e && ("function" == typeof e ? e(t) : e.current = t);
  }function o(n, o) {
    return e(n.nodeName, t(t({}, n.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : n.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == V.push(e) && (M.debounceRendering || D)(i);
  }function i() {
    var e;while (e = V.pop()) {
      e.__d && x(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var n = t({}, e.attributes);n.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === n[r] && (n[r] = o[r]);
    }return n;
  }function c(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function s(e, t, o, r, i) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n(o, null), n(r, e);else if ("class" !== t || i) {
      if ("style" === t) {
        if (r && "string" != typeof r && "string" != typeof o || (e.style.cssText = r || ""), r && "object" == typeof r) {
          if ("string" != typeof o) for (var l in o) {
            l in r || (e.style[l] = "");
          }for (var l in r) {
            e.style[l] = "number" == typeof r[l] && !1 === E.test(l) ? r[l] + "px" : r[l];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) r && (e.innerHTML = r.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var a = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), r ? o || e.addEventListener(t, _, a) : e.removeEventListener(t, _, a), (e.__l || (e.__l = {}))[t] = r;
      } else if ("list" !== t && "type" !== t && !i && t in e) {
        try {
          e[t] = null == r ? "" : r;
        } catch (e) {}null != r && !1 !== r || "spellcheck" == t || e.removeAttribute(t);
      } else {
        var u = i && t !== (t = t.replace(/^xlink:?/, ""));null == r || !1 === r ? u ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof r && (u ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), r) : e.setAttribute(t, r));
      }
    } else e.className = r || "";
  }function _(e) {
    return this.__l[e.type](M.event && M.event(e) || e);
  }function f() {
    var e;while (e = A.shift()) {
      M.afterMount && M.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function d(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, B = null != e && !("__preactattr_" in e));var l = h(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (B = !1, i || f()), l;
  }function h(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return N(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = c(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0);
    }var p = i.firstChild,
        s = i.__preactattr_,
        _ = t.children;if (null == s) {
      s = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        s[f[d].name] = f[d].value;
      }
    }return !B && _ && 1 === _.length && "string" == typeof _[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != _[0] && (p.nodeValue = _[0]) : (_ && _.length || null != p) && m(i, _, n, o, B || null != s.dangerouslySetInnerHTML), y(i, t.attributes, s), R = l, i;
  }function m(e, t, n, o, r) {
    var i,
        a,
        u,
        c,
        s,
        _ = e.childNodes,
        f = [],
        d = {},
        m = 0,
        b = 0,
        y = _.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = _[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (m++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      c = t[C], s = null;var k = c.key;if (null != k) m && void 0 !== d[k] && (s = d[k], d[k] = void 0, m--);else if (b < g) for (i = b; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], c, r)) {
          s = a, f[i] = void 0, i === g - 1 && g--, i === b && b++;break;
        }
      }s = h(s, c, n, o), u = _[C], s && s !== e && s !== u && (null == u ? e.appendChild(s) : s === u.nextSibling ? p(u) : e.insertBefore(s, u));
    }if (m) for (var C in d) {
      void 0 !== d[C] && v(d[C], !1);
    }while (b <= g) {
      void 0 !== (s = f[g--]) && v(s, !1);
    }
  }function v(e, t) {
    var o = e._component;o ? k(o) : (null != e.__preactattr_ && n(e.__preactattr_.ref, null), !1 !== t && null != e.__preactattr_ || p(e), b(e));
  }function b(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;v(e, !0), e = t;
    }
  }function y(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || s(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || s(e, o, n[o], n[o] = t[o], R);
    }
  }function g(e, t, n) {
    var o,
        r = F.length;e.prototype && e.prototype.render ? (o = new e(t, n), U.call(o, t, n)) : (o = new U(t, n), o.constructor = e, o.render = w);while (r--) {
      if (F[r].constructor === e) return o.__b = F[r].__b, F.splice(r, 1), o;
    }return o;
  }function w(e, t, n) {
    return this.constructor(e, n);
  }function C(e, t, o, i, l) {
    e.__x || (e.__x = !0, e.__r = t.ref, e.__k = t.key, delete t.ref, delete t.key, void 0 === e.constructor.getDerivedStateFromProps && (!e.base || l ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, i)), i && i !== e.context && (e.__c || (e.__c = e.context), e.context = i), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== o && (1 !== o && !1 === M.syncComponentUpdates && e.base ? r(e) : x(e, 1, l)), n(e.__r, e));
  }function x(e, n, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          c = e.props,
          p = e.state,
          s = e.context,
          _ = e.__p || c,
          h = e.__s || p,
          m = e.__c || s,
          b = e.base,
          y = e.__b,
          w = b || y,
          N = e._component,
          U = !1,
          S = m;if (e.constructor.getDerivedStateFromProps && (p = t(t({}, p), e.constructor.getDerivedStateFromProps(c, p)), e.state = p), b && (e.props = _, e.state = h, e.context = m, 2 !== n && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(c, p, s) ? U = !0 : e.componentWillUpdate && e.componentWillUpdate(c, p, s), e.props = c, e.state = p, e.context = s), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !U) {
        i = e.render(c, p, s), e.getChildContext && (s = t(t({}, s), e.getChildContext())), b && e.getSnapshotBeforeUpdate && (S = e.getSnapshotBeforeUpdate(_, h));var L,
            T,
            P = i && i.nodeName;if ("function" == typeof P) {
          var W = u(i);l = N, l && l.constructor === P && W.key == l.__k ? C(l, W, 1, s, !1) : (L = l, e._component = l = g(P, W, s), l.__b = l.__b || y, l.__u = e, C(l, W, 0, s, !1), x(l, 1, o, !0)), T = l.base;
        } else a = w, L = N, L && (a = e._component = null), (w || 1 === n) && (a && (a._component = null), T = d(a, i, s, o || !b, w && w.parentNode, !0));if (w && T !== w && l !== N) {
          var D = w.parentNode;D && T !== D && (D.replaceChild(T, w), L || (w._component = null, v(w, !1)));
        }if (L && k(L), e.base = T, T && !r) {
          var E = e,
              V = e;while (V = V.__u) {
            (E = V).base = T;
          }T._component = E, T._componentConstructor = E.constructor;
        }
      }!b || o ? A.push(e) : U || (e.componentDidUpdate && e.componentDidUpdate(_, h, S), M.afterUpdate && M.afterUpdate(e));while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || f();
    }
  }function N(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        c = a,
        p = u(t);while (r && !c && (r = r.__u)) {
      c = r.constructor === t.nodeName;
    }return r && c && (!o || r._component) ? (C(r, p, 3, n, o), e = r.base) : (i && !a && (k(i), e = l = null), r = g(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), C(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, v(l, !1))), e;
  }function k(e) {
    M.beforeUnmount && M.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var o = e._component;o ? k(o) : t && (null != t.__preactattr_ && n(t.__preactattr_.ref, null), e.__b = t, p(t), F.push(e), b(t)), n(e.__r, null);
  }function U(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {}, this.__h = [];
  }function S(e, t, n) {
    return d(n, e, {}, !1, t, !1);
  }function L() {
    return {};
  }var T = function T() {},
      M = {},
      P = [],
      W = [],
      D = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      E = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      V = [],
      A = [],
      H = 0,
      R = !1,
      B = !1,
      F = [];t(U.prototype, { setState: function setState(e, n) {
      this.__s || (this.__s = this.state), this.state = t(t({}, this.state), "function" == typeof e ? e(this.state, this.props) : e), n && this.__h.push(n), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && this.__h.push(e), x(this, 2);
    }, render: function render() {} });var j = { h: e, createElement: e, cloneElement: o, createRef: L, Component: U, render: S, rerender: i, options: M }; true ? module.exports = j : self.preact = j;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "LnyB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return i18nUtils; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locale; });
/* unused harmony export I18N */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_common__ = __webpack_require__("2UA+");


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var I18NUtils = function () {
  function I18NUtils() {
    _classCallCheck(this, I18NUtils);

    this.i18n = {};
  }

  I18NUtils.prototype.getKey = function getKey(key) {
    if (__WEBPACK_IMPORTED_MODULE_1__common_common__["a" /* default */].isNullOrUndefined(key)) return '';
    var msg = key.split(/\.(.+)/);
    /*
    if(!this.i18n[msg[0]]){
      //do async handling
      this.loadBundle(msg[0]);
    }
    */
    var a = this.i18n[msg[0]];
    return a && a[msg[1]] || !1;
  };

  /*
  loadBundle(module){
    //fetch call to load a lang pack. below a sample call
    this.i18n[module]={title:'नमस्ते'};
  }
  */


  I18NUtils.prototype.load = function load(data) {
    this.i18n = data;
  };

  return I18NUtils;
}();

var i18nUtils = new I18NUtils();
var locale = i18nUtils.getKey.bind(i18nUtils);
var I18N = function I18N(_ref) {
  var code = _ref.code,
      tag = _ref.tag,
      children = _ref.children;

  var val = i18nUtils.getKey(code) || children;
  if (tag === false) {
    return val;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'span',
    null,
    val
  );
};

/***/ }),

/***/ "Lssw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export compareDate */
/* unused harmony export formatDate */
/* unused harmony export toDate */
/* unused harmony export isNumber */
/* unused harmony export checkFixedAmountTypeEditCase */
/* unused harmony export isFunction */
/* unused harmony export isNull */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return lightenDarkenColor; });
/* unused harmony export convertOpacityToHex */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_constants__ = __webpack_require__("hafV");


// Takes two strings as input, format is dd-mm-yyyy
// returns true if d1 is smaller than or equal to d2
var compareDate = function compareDate(d1, d2) {
  var parts = d1.split('/');
  d1 = Number(parts[2] + parts[1] + parts[0]);
  parts = d2.split('/');
  d2 = Number(parts[2] + parts[1] + parts[0]);
  return d1 <= d2;
};

var formatDate = function formatDate(format, date) {
  var formattedDate = '';
  if (format && date) {
    switch (format) {
      case 'DD/MM/YYYY':
        formattedDate = dateInDDMMYYYY(date);
        break;
    }
  }
  return formattedDate;
};

var toDate = function toDate(dateStr) {
  if (dateStr) {
    var parts = dateStr.split(__WEBPACK_IMPORTED_MODULE_0__utils_constants__["n" /* default */].DATE_ORDINAL);
    return new Date(parts[2], parts[1] - 1, parts[0]);
  }
  return false;
};

var dateInDDMMYYYY = function dateInDDMMYYYY(date) {
  date = new Date(date);
  var dd = date.getDate();
  var mm = date.getMonth() + 1; // January is 0!

  var yyyy = date.getFullYear();
  if (dd < 10) {
    dd = '0' + dd;
  }
  if (mm < 10) {
    mm = '0' + mm;
  }
  return dd + '/' + mm + '/' + yyyy;
};

var isNumber = function isNumber(e) {
  if (!e) return false;
  if (typeof e !== 'object' && /^\d+$/.test(e)) return true;

  var digit = String.fromCharCode(e.which);
  if (e.key !== undefined) {
    digit = e.key;
  }
  // any other character than digit
  if (!/^\d+$/.test(digit)) {
    // allow backspace, tab and right/left arrow
    if (e.which !== 8 && e.which !== 9 && e.which !== 37 && e.which !== 39) {
      return false;
    }
  }
  return true;
};

// To check amount type in edit case i.e. for fixed & flexible amount
var checkFixedAmountTypeEditCase = function checkFixedAmountTypeEditCase(constraints) {
  return !!(constraints && constraints.value);
};
var isFunction = function isFunction(method) {
  if (typeof method === 'function') {
    return true;
  }
  return false;
};

/**
 * Null or undefined check on value
 * @param {any} value - can be of any type
 * @return {Boolean} - result of value is null or undefined
 * */
var isNull = function isNull(value) {
  return value === null || value === undefined;
};

/**
 * Get property value from nested object
 *
 * @param {Object} obj - object to perform property lookup
 * @param {String} path - the path at which lookup is performed
 * @param {*} defaultValue (optional) -  default value to be reurned if property not found
 * @returns {*} - returns the property value if found else returns dafaultValue
 */
var get = function get(obj, path, defaultValue) {
  var result = String.prototype.split.call(path, /[,[\].]+?/).filter(Boolean).reduce(function (res, key) {
    return res !== null && res !== undefined ? res[key] : res;
  }, obj);
  return result === undefined || result === obj ? defaultValue : result;
};

/**
 * Generate new lighter or darker color code
 * https://css-tricks.com/snippets/javascript/lighten-darken-color/
 * @param {string} col - hash code color
 * @param {boolean} isLighten - need to convert in lighter or darker
 */
var lightenDarkenColor = function lightenDarkenColor(col) {
  var isLighten = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var usePound = false;
  var amt = isLighten ? 40 : -20;

  if (col[0] == '#') {
    col = col.slice(1);
    usePound = true;
  }

  var num = parseInt(col, 16);

  var r = (num >> 16) + amt;

  if (r > 255) r = 255;else if (r < 0) r = 0;

  var b = (num >> 8 & 0x00ff) + amt;

  if (b > 255) b = 255;else if (b < 0) b = 0;

  var g = (num & 0x0000ff) + amt;

  if (g > 255) g = 255;else if (g < 0) g = 0;

  return (usePound ? '#' : '') + (g | b << 8 | r << 16).toString(16);
};

/**
 * Convert the opacity value to Hexa Decimal
 * @param {Objec} colorObj - Color Object
 */
var convertOpacityToHex = function convertOpacityToHex(colorObj) {
  var a = '';
  if (colorObj && colorObj.rgb && colorObj.rgb.hasOwnProperty('a') && colorObj.rgb.a != 1) {
    a = Math.floor(colorObj.rgb.a * 255).toString(16);
    if (a.length === 1) {
      a = '0' + a;
    }
  }
  return a;
};

/***/ }),

/***/ "SUer":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Button = function (_Component) {
  _inherits(Button, _Component);

  function Button(props) {
    _classCallCheck(this, Button);

    return _possibleConstructorReturn(this, _Component.call(this, props));
  }

  Button.prototype.render = function render(_ref) {
    var onButtonClick = _ref.onButtonClick,
        isDisabled = _ref.isDisabled,
        name = _ref.name;

    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      "button",
      { "class": "btn btn-primary save", onClick: onButtonClick, disabled: isDisabled || false },
      name
    );
  };

  return Button;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "TCRV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tab-content":"_Uew7","mer-name":"_thBh","ptm-head-logo":"_CnZf","sc-img":"_10EI","ptm-logo":"_3eqr","grid-wrap":"_bYsy","grid-inner":"_163d","select-txt":"_1L81","grid":"_129N","pay-method":"_3CT1","grid-img":"_1E3n","webtheme-wrapper":"_15zs","webtheme-inner":"_yWJI","tabcircle":"_2XlJ","circle":"_2CRZ","web-wrap":"_2gPW","m-header":"_1ASm","amount-txt":"_aTiz","amount-para":"_1hGx","amount":"_WvD3","m-content":"_2TZf","choose-txt":"_3tfN","pay-mode-wrap":"_3za4","pay-list-wrap":"_5LYM","pay-list":"_18x3","border-div":"_2b03","radio-circle":"_wKxr","m-footer":"_2LUU","dark-border":"_2rRI","secure":"_3-eu","default":"_2FRg","header":"_E2si","header-top":"_1b7J","head-select":"_194h","header-bottom":"_2tvw","logo-amount":"_3U_V","mer-logo":"_1zMr","brand-logo":"_1y6V","subheading":"_3FNI","cross-wrap":"_3pyA","cross":"_3mvr","cross-line1":"_2-4U","cross-line2":"_32Gy","payBtnWrap":"_1Ch7","payBtn":"_3Kl2","payBtnimg":"_1482","user-bg":"_-b_J","cardtype":"_3Ak1","wallet":"_3YZV","wallet-inner":"_Sblk","check":"_19rJ","sign1":"_1j2y","sign2":"_1tAG","check-txt":"_1mGm","w100":"_1yDR","wallet-txt":"_rZwt","wallet-para":"_1tGP","grid-content":"_2Sih"};

/***/ }),

/***/ "WsRd":
/***/ (function(module, exports) {

var _cache = {};

var _get = function _get(key) {
  return _cache[key];
};

var _set = function _set(key, value) {
  _cache[key] = value;
};

var _reset = function _reset() {
  _cache = {};
};

module.exports = {
  get: _get,
  set: _set,
  clear: _reset
};

/***/ }),

/***/ "XeJm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./common/cache.js
var cache = __webpack_require__("WsRd");
var cache_default = /*#__PURE__*/__webpack_require__.n(cache);

// EXTERNAL MODULE: ./common/postMessage.js
var postMessage = __webpack_require__("em/f");

// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__("hafV");

// EXTERNAL MODULE: ./common/common.js + 2 modules
var common = __webpack_require__("2UA+");

// CONCATENATED MODULE: ./utils/http.js





var http_payload = function payload(data, head) {
  data.mid = Object(cache["get"])(constants["n" /* default */].MID);
  var defaultHead = {
    version: 'v1',
    requestTimestamp: new Date().getTime(),
    token: Object(cache["get"])(constants["n" /* default */].TOKEN)
  };
  return {
    head: head || defaultHead,
    body: data
  };
};
var http_post = function post(url, data, head) {
  var postOnUMP = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  data = http_payload(data, head);
  common["a" /* default */].log('preAPICall', url, { data: data });
  return fetch(url, {
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    credentials: 'same-origin',
    body: JSON.stringify(data)
  }).then(function (response) {
    return response.json();
  }).then(function (data) {
    if (data && data.body) {
      return new Promise(function (res, rej) {
        if (data.body.resultInfo.resultStatus === 'S') {
          try {
            common["a" /* default */].log('postAPICall', 'Success', { url: url, data: data });
            if (postOnUMP) {
              Object(postMessage["a" /* postMessageOnParentWindow */])(data);
            }
          } catch (err) {
            //
          }
          res(data);
        } else {
          common["a" /* default */].log('postAPICall', 'Failure', { url: url, data: data });
          rej(data);
        }
      });
    }
    common["a" /* default */].log('postAPICall', 'Failure', { url: url, data: data });
    return Promise.reject(data);
  }).catch(function (error) {
    try {
      common["a" /* default */].log('postAPICall', 'Failure', { url: url, error: error });
      if (postOnUMP) {
        Object(postMessage["a" /* postMessageOnParentWindow */])(error);
      }
    } catch (err) {
      //
    }
    return Promise.reject(error.body);
  });
};

var http_postWithMultipartFormData = function postWithMultipartFormData(url, file) {
  var postOnUMP = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  common["a" /* default */].log('preAPICall', url, { file: file });

  var formData = new FormData();
  formData.append('file', file);

  return fetch(url, {
    method: 'POST',
    headers: {},
    credentials: 'same-origin',
    body: formData
  }).then(function (response) {
    return response.json();
  }).then(function (data) {
    if (data && data.body) {
      return new Promise(function (res, rej) {
        if (data.body.resultInfo.resultStatus === 'S') {
          try {
            common["a" /* default */].log('postAPICall', 'Success', { url: url, data: data });
            if (postOnUMP) {
              Object(postMessage["a" /* postMessageOnParentWindow */])(data);
            }
          } catch (err) {
            //
          }
          res(data);
        } else {
          common["a" /* default */].log('postAPICall', 'Failure', { url: url, data: data });
          rej(data);
        }
      });
    }
    common["a" /* default */].log('postAPICall', 'Failure', { url: url, data: data });
    return Promise.reject(data);
  }).catch(function (error) {
    try {
      common["a" /* default */].log('postAPICall', 'Failure', { url: url, error: error });
      if (postOnUMP) {
        Object(postMessage["a" /* postMessageOnParentWindow */])(error);
      }
    } catch (err) {
      //
    }
    return Promise.reject(error.body);
  });
};
// CONCATENATED MODULE: ./common/api.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var api_API = function () {
  function API() {
    _classCallCheck(this, API);
  }

  API.prototype.onSaveSetting = function onSaveSetting(selectedObj) {
    var CHECKOUT = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var isPaytmBrandingDisplay = arguments[2];
    var isAutoLoginSupported = arguments[3];
    var isCustomPaymodeSelected = arguments[4];
    var reOrderedPaymodes = arguments[5];
    var isGradientEffectEnable = arguments[6];
    var isParentThemeOverwriteEnabled = arguments[7];
    var onInvertImgLogo = arguments[8];

    var paytmLogo = onInvertImgLogo ? 'WHITE-LOGO' : 'BLUE-LOGO';
    var mid = Object(cache["get"])(constants["n" /* default */].MID);
    var url = Object(cache["get"])(constants["n" /* default */].SAVEURL) + '/' + mid;
    var isLightTheme = !!(!selectedObj || selectedObj.mobile.NAME == 'LIGHT');
    isLightTheme ? paytmLogo = 'BLUE-LOGO' : selectedObj.mobile.NAME == 'DARK' ? paytmLogo = 'WHITE-LOGO' : '';
    var checkoutObj = {};
    _extends(checkoutObj, constants["d" /* DEFAULT_CHECKOUT_CONFIG */], CHECKOUT);
    selectedObj.gradient = selectedObj.mobile.NAME === 'CUSTOM' && isGradientEffectEnable ? selectedObj.gradient : constants["e" /* DEFAULT_GRADIENT_COLOR */];

    if (!selectedObj.merchant) {
      selectedObj.merchant = {};
    }
    if (!selectedObj.payMode) {
      selectedObj.payMode = {};
    }

    /**
      No need to save the color value for Light theme for checkout js, because Light theme is 
      different for checkout and redirection flow
    */
    checkoutObj.style.bodyBackgroundColor = isLightTheme ? '' : selectedObj.mobile.BODYBG;
    checkoutObj.style.bodyColor = isLightTheme ? '' : selectedObj.mobile.BODYTEXT;
    checkoutObj.style.themeBackgroundColor = isLightTheme ? '' : selectedObj.mobile.PAYBUTTONBG;
    checkoutObj.style.themeColor = isLightTheme ? '' : selectedObj.mobile.PAYBUTTONTEXT;
    checkoutObj.style.headerBackgroundColor = isLightTheme ? '' : selectedObj.mobile.HEADERPANEL;
    checkoutObj.style.headerColor = isLightTheme ? '' : selectedObj.mobile.HEADERTEXT;
    checkoutObj.style.borderColor = isLightTheme ? '' : selectedObj.mobile.BORDER;
    checkoutObj.style.gradient = selectedObj.gradient;
    checkoutObj.style.label = selectedObj.mobile.LABEL;
    checkoutObj.style.name = selectedObj.mobile.NAME;

    checkoutObj.merchant.hidePaytmBranding = !isPaytmBrandingDisplay;
    checkoutObj.payMode.order = reOrderedPaymodes;
    selectedObj.merchant.hidePaytmBranding = !isPaytmBrandingDisplay;
    selectedObj.payMode.order = reOrderedPaymodes;

    if (selectedObj && selectedObj.mobile && selectedObj.web) {
      selectedObj.mobile.BOTTOMBG = selectedObj.mobile.HEADERPANEL;
      selectedObj.web.BOTTOMBG = selectedObj.web.HEADERPANEL;
    }

    if (selectedObj.merchant.merchantLogoFile) {
      delete selectedObj.merchant.merchantLogoFile;
    }
    if (selectedObj.merchant.merchantLogoUrl) {
      delete selectedObj.merchant.merchantLogoUrl;
    }

    var dataObj = {
      themePreferenceInfos: {
        REDIRECTION: selectedObj,
        CHECKOUT: checkoutObj,
        isCustomPaymodeSelected: isCustomPaymodeSelected,
        isGradientEffectEnable: isGradientEffectEnable,
        isParentThemeOverwriteEnabled: isParentThemeOverwriteEnabled,
        paytmLogo: paytmLogo
      },
      merchantPreferenceInfos: {
        isPaytmBrandingDisplay: isPaytmBrandingDisplay,
        isAutoLoginSupported: isAutoLoginSupported
      }
    };
    return http_post(url, dataObj);
  };

  API.prototype.onSaveUpdate = function onSaveUpdate(payload) {
    var url = '' + constants["n" /* default */].saveUpdateUrl;
    return http_post(url, payload, '', false);
  };

  API.prototype.onDeleteField = function onDeleteField(payload) {
    var url = '' + constants["n" /* default */].deleteField;
    return http_post(url, payload, '', false);
  };

  API.prototype.templateFields = function templateFields(payload) {
    var url = constants["n" /* default */].fetchTemplateFieldsForPreview + '/' + payload.templateId;
    return http_post(url, payload);
  };

  API.prototype.updateCheckoutPreference = function updateCheckoutPreference(payload) {
    var mid = Object(cache["get"])(constants["n" /* default */].MID);
    var url = constants["n" /* default */].updatePreference + '/' + mid;
    return http_post(url, { preference: payload });
  };

  API.prototype.onButtonSaveUpdate = function onButtonSaveUpdate(payload) {
    var url = '' + constants["n" /* default */]['saveUpdateButtonApi'];
    return http_post(url, payload);
  };

  API.prototype.fetchLinks = function fetchLinks(payload) {
    var url = constants["n" /* default */].FETCH_LINKS;
    return http_post(url, payload);
  };

  API.prototype.updateLinks = function updateLinks(payload) {
    var url = constants["n" /* default */].UPDATE_LINKS;
    return http_post(url, payload, '', false);
  };

  API.prototype.onSaveMerchantLogo = function onSaveMerchantLogo(logoFile) {
    var mid = Object(cache["get"])(constants["n" /* default */].MID);
    var url = Object(cache["get"])(constants["n" /* default */].SAVEURL) + '/merchantlogo/' + mid;
    return http_postWithMultipartFormData(url, logoFile);
  };

  return API;
}();

/* harmony default export */ var api = __webpack_exports__["a"] = (new api_API());

/***/ }),

/***/ "YDPc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tab-content":"_1LAl","webtheme-wrapper":"_1fJl","webtheme-inner":"_1V8B","tabcircle":"_2FZk","circle":"_1bLC","subheading":"_LlwU","mer-name":"_21_Y","choose-txt":"_1tNQ","web-wrap":"_fNC7","m-header":"_3Eva","amount-txt":"_2SVY","amount-para":"_3pXB","amount":"_17ND","m-content":"_1Ad6","select-txt":"_3q4W","sc-img":"_20IA","wallet":"_JB2-","grid-wrap":"_1WEv","grid":"_3oRU","pay-method":"_1ab9","wallet-inner":"_29oB","grid-img":"_1Xoh","check":"_3Odw","sign1":"_uUia","sign2":"_8SR5","check-txt":"_19qj","w100":"_4WWV","wallet-txt":"_3TiQ","wallet-para":"_ev46","pay-btn":"_3tJE","pay-mode-wrap":"_3RwY","pay-list-wrap":"_jawu","pay-list":"_iAxC","border-div":"_JPYS","radio-circle":"_jcH7","m-footer":"_w4Rq","dark-border":"_3zvR","secure":"_3Pd4","default":"_26in","backSection":"_3dR8","arrow":"_1lzO","back":"_2oOn","user-bg":"_2kd-","ptm-head-logo":"_3v00","payBtnWrap":"_3WhV","payBtn":"_3R8c","payBtnimg":"_1W2P","mer-logo":"_R83w","brand-logo":"_1CUs","cardtype":"_jIBj"};

/***/ }),

/***/ "ZShz":
/***/ (function(module, exports, __webpack_require__) {

!function (n, t) {
   true ? t(exports, __webpack_require__("KM04")) : "function" == typeof define && define.amd ? define(["exports", "preact"], t) : t((n = n || self).preactContext = {}, n.preact);
}(this, function (n, t) {
  "use strict";
  var _i = function i(n, t) {
    return (_i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (n, t) {
      n.__proto__ = t;
    } || function (n, t) {
      for (var i in t) {
        t.hasOwnProperty(i) && (n[i] = t[i]);
      }
    })(n, t);
  };function r(n, t) {
    function r() {
      this.constructor = n;
    }_i(n, t), n.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r());
  }var e = { register: function register(n) {
      console.warn("Consumer used without a Provider");
    }, unregister: function unregister(n) {}, val: function val(n) {} };function u(n) {
    var t = n.children;return { child: 1 === t.length ? t[0] : null, children: t };
  }function o(n) {
    return u(n).child || "render" in n && n.render;
  }var c = 1073741823,
      f = function f() {
    return c;
  },
      s = 0;function a(n, i) {
    var a = "_preactContextProvider-" + s++;return { Provider: function (n) {
        function e(t) {
          var r = n.call(this, t) || this;return r.t = function (n, t) {
            var i = [],
                r = n,
                e = function e(n) {
              return 0 | t(r, n);
            };return { register: function register(n) {
                i.push(n), n(r, e(r));
              }, unregister: function unregister(n) {
                i = i.filter(function (t) {
                  return t !== n;
                });
              }, val: function val(n) {
                if (void 0 === n || n == r) return r;var t = e(n);return r = n, i.forEach(function (i) {
                  return i(n, t);
                }), r;
              } };
          }(t.value, i || f), r;
        }return r(e, n), e.prototype.getChildContext = function () {
          var n;return (n = {})[a] = this.t, n;
        }, e.prototype.componentDidUpdate = function () {
          this.t.val(this.props.value);
        }, e.prototype.render = function () {
          var n = u(this.props),
              i = n.child,
              r = n.children;return i || t.h("span", null, r);
        }, e;
      }(t.Component), Consumer: function (t) {
        function i(i, r) {
          var e = t.call(this, i, r) || this;return e.i = function (n, t) {
            var i = e.props.unstable_observedBits,
                r = void 0 === i || null === i ? c : i;0 != ((r |= 0) & t) && e.setState({ value: n });
          }, e.state = { value: e.u().val() || n }, e;
        }return r(i, t), i.prototype.componentDidMount = function () {
          this.u().register(this.i);
        }, i.prototype.shouldComponentUpdate = function (n, t) {
          return this.state.value !== t.value || o(this.props) !== o(n);
        }, i.prototype.componentWillUnmount = function () {
          this.u().unregister(this.i);
        }, i.prototype.componentDidUpdate = function (n, t, i) {
          var r = i[a];r !== this.context[a] && ((r || e).unregister(this.i), this.componentDidMount());
        }, i.prototype.render = function () {
          var n = "render" in this.props && this.props.render,
              t = o(this.props);if (n && n !== t && console.warn("Both children and a render function are defined. Children will be used"), "function" == typeof t) return t(this.state.value);console.warn("Consumer is expecting a function as one and only child but didn't find any");
        }, i.prototype.u = function () {
          return this.context[a] || e;
        }, i;
      }(t.Component) };
  }var h = a;n.default = a, n.createContext = h, Object.defineProperty(n, "__esModule", { value: !0 });
});

/***/ }),

/***/ "cs3a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
    require('preact/devtools');
} else if (true && 'serviceWorker' in navigator && location.protocol === 'https:') {
    navigator.serviceWorker.register(__webpack_require__.p + 'sw.js');
}

var interopDefault = function interopDefault(m) {
    return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JKLE"));

if (typeof app === 'function') {
    var root = document.body.firstElementChild;

    var init = function init() {
        var app = interopDefault(__webpack_require__("JKLE"));
        root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
    };

    if (false) module.hot.accept('preact-cli-entrypoint', init);
    init();
}

/***/ }),

/***/ "dDmy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"drag-card":"_mlwq","drag-txt":"_1M23","dash":"_3TPe"};

/***/ }),

/***/ "eW0v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "version", function() { return version; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOM", function() { return DOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Children", function() { return Children; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hydrate", function() { return render$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createClass", function() { return createClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPortal", function() { return createPortal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createFactory", function() { return createFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElement", function() { return createElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneElement", function() { return cloneElement$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isValidElement", function() { return isValidElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findDOMNode", function() { return findDOMNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unmountComponentAtNode", function() { return unmountComponentAtNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Component", function() { return Component$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PureComponent", function() { return PureComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unstable_renderSubtreeIntoContainer", function() { return renderSubtreeIntoContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unstable_batchedUpdates", function() { return unstable_batchedUpdates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return extend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("5D9O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "PropTypes", function() { return __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_preact__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_1_preact__, "createRef")) __webpack_require__.d(__webpack_exports__, "createRef", function() { return __WEBPACK_IMPORTED_MODULE_1_preact__["createRef"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_context__ = __webpack_require__("ZShz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_preact_context__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_2_preact_context__, "createContext")) __webpack_require__.d(__webpack_exports__, "createContext", function() { return __WEBPACK_IMPORTED_MODULE_2_preact_context__["createContext"]; });







var version = '15.1.0'; // trick libraries to think we are react

var ELEMENTS = 'a abbr address area article aside audio b base bdi bdo big blockquote body br button canvas caption cite code col colgroup data datalist dd del details dfn dialog div dl dt em embed fieldset figcaption figure footer form h1 h2 h3 h4 h5 h6 head header hgroup hr html i iframe img input ins kbd keygen label legend li link main map mark menu menuitem meta meter nav noscript object ol optgroup option output p param picture pre progress q rp rt ruby s samp script section select small source span strong style sub summary sup table tbody td textarea tfoot th thead time title tr track u ul var video wbr circle clipPath defs ellipse g image line linearGradient mask path pattern polygon polyline radialGradient rect stop svg text tspan'.split(' ');

var REACT_ELEMENT_TYPE = typeof Symbol !== 'undefined' && Symbol.for && Symbol.for('react.element') || 0xeac7;

var COMPONENT_WRAPPER_KEY = typeof Symbol !== 'undefined' && Symbol.for ? Symbol.for('__preactCompatWrapper') : '__preactCompatWrapper';

// don't autobind these methods since they already have guaranteed context.
var AUTOBIND_BLACKLIST = {
	constructor: 1,
	render: 1,
	shouldComponentUpdate: 1,
	componentWillReceiveProps: 1,
	componentWillUpdate: 1,
	componentDidUpdate: 1,
	componentWillMount: 1,
	componentDidMount: 1,
	componentWillUnmount: 1,
	componentDidUnmount: 1
};

var CAMEL_PROPS = /^(?:accent|alignment|arabic|baseline|cap|clip|color|fill|flood|font|glyph|horiz|marker|overline|paint|stop|strikethrough|stroke|text|underline|unicode|units|v|vector|vert|word|writing|x)[A-Z]/;

var BYPASS_HOOK = {};

/*global process*/
var DEV = false;
try {
	DEV = "production" !== 'production';
} catch (e) {}

// a component that renders nothing. Used to replace components for unmountComponentAtNode.
function EmptyComponent() {
	return null;
}

// make react think we're react.
var VNode = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])('a', null).constructor;
VNode.prototype.$$typeof = REACT_ELEMENT_TYPE;
VNode.prototype.preactCompatUpgraded = false;
VNode.prototype.preactCompatNormalized = false;

Object.defineProperty(VNode.prototype, 'type', {
	get: function get() {
		return this.nodeName;
	},
	set: function set(v) {
		this.nodeName = v;
	},
	configurable: true
});

Object.defineProperty(VNode.prototype, 'props', {
	get: function get() {
		return this.attributes;
	},
	set: function set(v) {
		this.attributes = v;
	},
	configurable: true
});

var oldEventHook = __WEBPACK_IMPORTED_MODULE_1_preact__["options"].event;
__WEBPACK_IMPORTED_MODULE_1_preact__["options"].event = function (e) {
	if (oldEventHook) {
		e = oldEventHook(e);
	}
	e.persist = Object;
	e.nativeEvent = e;
	return e;
};

var oldVnodeHook = __WEBPACK_IMPORTED_MODULE_1_preact__["options"].vnode;
__WEBPACK_IMPORTED_MODULE_1_preact__["options"].vnode = function (vnode) {
	if (!vnode.preactCompatUpgraded) {
		vnode.preactCompatUpgraded = true;

		var tag = vnode.nodeName,
		    attrs = vnode.attributes = vnode.attributes == null ? {} : extend({}, vnode.attributes);

		if (typeof tag === 'function') {
			if (tag[COMPONENT_WRAPPER_KEY] === true || tag.prototype && 'isReactComponent' in tag.prototype) {
				if (vnode.children && String(vnode.children) === '') {
					vnode.children = undefined;
				}
				if (vnode.children) {
					attrs.children = vnode.children;
				}

				if (!vnode.preactCompatNormalized) {
					normalizeVNode(vnode);
				}
				handleComponentVNode(vnode);
			}
		} else {
			if (vnode.children && String(vnode.children) === '') {
				vnode.children = undefined;
			}
			if (vnode.children) {
				attrs.children = vnode.children;
			}

			if (attrs.defaultValue) {
				if (!attrs.value && attrs.value !== 0) {
					attrs.value = attrs.defaultValue;
				}
				delete attrs.defaultValue;
			}

			handleElementVNode(vnode, attrs);
		}
	}

	if (oldVnodeHook) {
		oldVnodeHook(vnode);
	}
};

function handleComponentVNode(vnode) {
	var tag = vnode.nodeName,
	    a = vnode.attributes;

	vnode.attributes = {};
	if (tag.defaultProps) {
		extend(vnode.attributes, tag.defaultProps);
	}
	if (a) {
		extend(vnode.attributes, a);
	}
}

function handleElementVNode(vnode, a) {
	var shouldSanitize, attrs, i;
	if (a) {
		for (i in a) {
			if (shouldSanitize = CAMEL_PROPS.test(i)) {
				break;
			}
		}
		if (shouldSanitize) {
			attrs = vnode.attributes = {};
			for (i in a) {
				if (a.hasOwnProperty(i)) {
					attrs[CAMEL_PROPS.test(i) ? i.replace(/([A-Z0-9])/, '-$1').toLowerCase() : i] = a[i];
				}
			}
		}
	}
}

// proxy render() since React returns a Component reference.
function render$1(vnode, parent, callback) {
	var prev = parent && parent._preactCompatRendered && parent._preactCompatRendered.base;

	// ignore impossible previous renders
	if (prev && prev.parentNode !== parent) {
		prev = null;
	}

	// default to first Element child
	if (!prev && parent) {
		prev = parent.firstElementChild;
	}

	// remove unaffected siblings
	for (var i = parent.childNodes.length; i--;) {
		if (parent.childNodes[i] !== prev) {
			parent.removeChild(parent.childNodes[i]);
		}
	}

	var out = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["render"])(vnode, parent, prev);
	if (parent) {
		parent._preactCompatRendered = out && (out._component || { base: out });
	}
	if (typeof callback === 'function') {
		callback();
	}
	return out && out._component || out;
}

var ContextProvider = function ContextProvider() {};

ContextProvider.prototype.getChildContext = function () {
	return this.props.context;
};
ContextProvider.prototype.render = function (props) {
	return props.children[0];
};

function renderSubtreeIntoContainer(parentComponent, vnode, container, callback) {
	var wrap = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(ContextProvider, { context: parentComponent.context }, vnode);
	var renderContainer = render$1(wrap, container);
	var component = renderContainer._component || renderContainer.base;
	if (callback) {
		callback.call(component, renderContainer);
	}
	return component;
}

function Portal(props) {
	renderSubtreeIntoContainer(this, props.vnode, props.container);
}

function createPortal(vnode, container) {
	return Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(Portal, { vnode: vnode, container: container });
}

function unmountComponentAtNode(container) {
	var existing = container._preactCompatRendered && container._preactCompatRendered.base;
	if (existing && existing.parentNode === container) {
		Object(__WEBPACK_IMPORTED_MODULE_1_preact__["render"])(Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(EmptyComponent), container, existing);
		return true;
	}
	return false;
}

var ARR = [];

// This API is completely unnecessary for Preact, so it's basically passthrough.
var Children = {
	map: function map(children, fn, ctx) {
		if (children == null) {
			return null;
		}
		children = Children.toArray(children);
		if (ctx && ctx !== children) {
			fn = fn.bind(ctx);
		}
		return children.map(fn);
	},
	forEach: function forEach(children, fn, ctx) {
		if (children == null) {
			return null;
		}
		children = Children.toArray(children);
		if (ctx && ctx !== children) {
			fn = fn.bind(ctx);
		}
		children.forEach(fn);
	},
	count: function count(children) {
		return children && children.length || 0;
	},
	only: function only(children) {
		children = Children.toArray(children);
		if (children.length !== 1) {
			throw new Error('Children.only() expects only one child.');
		}
		return children[0];
	},
	toArray: function toArray(children) {
		if (children == null) {
			return [];
		}
		return ARR.concat(children);
	}
};

/** Track current render() component for ref assignment */
var currentComponent;

function createFactory(type) {
	return createElement.bind(null, type);
}

var DOM = {};
for (var i = ELEMENTS.length; i--;) {
	DOM[ELEMENTS[i]] = createFactory(ELEMENTS[i]);
}

function upgradeToVNodes(arr, offset) {
	for (var i = offset || 0; i < arr.length; i++) {
		var obj = arr[i];
		if (Array.isArray(obj)) {
			upgradeToVNodes(obj);
		} else if (obj && typeof obj === 'object' && !isValidElement(obj) && (obj.props && obj.type || obj.attributes && obj.nodeName || obj.children)) {
			arr[i] = createElement(obj.type || obj.nodeName, obj.props || obj.attributes, obj.children);
		}
	}
}

function isStatelessComponent(c) {
	return typeof c === 'function' && !(c.prototype && c.prototype.render);
}

// wraps stateless functional components in a PropTypes validator
function wrapStatelessComponent(WrappedComponent) {
	return createClass({
		displayName: WrappedComponent.displayName || WrappedComponent.name,
		render: function render() {
			return WrappedComponent(this.props, this.context);
		}
	});
}

function statelessComponentHook(Ctor) {
	var Wrapped = Ctor[COMPONENT_WRAPPER_KEY];
	if (Wrapped) {
		return Wrapped === true ? Ctor : Wrapped;
	}

	Wrapped = wrapStatelessComponent(Ctor);

	Object.defineProperty(Wrapped, COMPONENT_WRAPPER_KEY, { configurable: true, value: true });
	Wrapped.displayName = Ctor.displayName;
	Wrapped.propTypes = Ctor.propTypes;
	Wrapped.defaultProps = Ctor.defaultProps;

	Object.defineProperty(Ctor, COMPONENT_WRAPPER_KEY, { configurable: true, value: Wrapped });

	return Wrapped;
}

function createElement() {
	var args = [],
	    len = arguments.length;
	while (len--) {
		args[len] = arguments[len];
	}upgradeToVNodes(args, 2);
	return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["h"].apply(void 0, args));
}

function normalizeVNode(vnode) {
	vnode.preactCompatNormalized = true;

	applyClassName(vnode);

	if (isStatelessComponent(vnode.nodeName)) {
		vnode.nodeName = statelessComponentHook(vnode.nodeName);
	}

	var ref = vnode.attributes.ref,
	    type = ref && typeof ref;
	if (currentComponent && (type === 'string' || type === 'number')) {
		vnode.attributes.ref = createStringRefProxy(ref, currentComponent);
	}

	applyEventNormalization(vnode);

	return vnode;
}

function cloneElement$1(element, props) {
	var children = [],
	    len = arguments.length - 2;
	while (len-- > 0) {
		children[len] = arguments[len + 2];
	}if (!isValidElement(element)) {
		return element;
	}
	var elementProps = element.attributes || element.props;
	var node = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(element.nodeName || element.type, extend({}, elementProps), element.children || elementProps && elementProps.children);
	// Only provide the 3rd argument if needed.
	// Arguments 3+ overwrite element.children in preactCloneElement
	var cloneArgs = [node, props];
	if (children && children.length) {
		cloneArgs.push(children);
	} else if (props && props.children) {
		cloneArgs.push(props.children);
	}
	return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["cloneElement"].apply(void 0, cloneArgs));
}

function isValidElement(element) {
	return element && (element instanceof VNode || element.$$typeof === REACT_ELEMENT_TYPE);
}

function createStringRefProxy(name, component) {
	return component._refProxies[name] || (component._refProxies[name] = function (resolved) {
		if (component && component.refs) {
			component.refs[name] = resolved;
			if (resolved === null) {
				delete component._refProxies[name];
				component = null;
			}
		}
	});
}

function applyEventNormalization(ref) {
	var nodeName = ref.nodeName;
	var attributes = ref.attributes;

	if (!attributes || typeof nodeName !== 'string') {
		return;
	}
	var props = {};
	for (var i in attributes) {
		props[i.toLowerCase()] = i;
	}
	if (props.ondoubleclick) {
		attributes.ondblclick = attributes[props.ondoubleclick];
		delete attributes[props.ondoubleclick];
	}
	// for *textual inputs* (incl textarea), normalize `onChange` -> `onInput`:
	if (props.onchange && (nodeName === 'textarea' || nodeName.toLowerCase() === 'input' && !/^fil|che|rad/i.test(attributes.type))) {
		var normalized = props.oninput || 'oninput';
		if (!attributes[normalized]) {
			attributes[normalized] = multihook([attributes[normalized], attributes[props.onchange]]);
			delete attributes[props.onchange];
		}
	}
}

function applyClassName(vnode) {
	var a = vnode.attributes || (vnode.attributes = {});
	classNameDescriptor.enumerable = 'className' in a;
	if (a.className) {
		a.class = a.className;
	}
	Object.defineProperty(a, 'className', classNameDescriptor);
}

var classNameDescriptor = {
	configurable: true,
	get: function get() {
		return this.class;
	},
	set: function set(v) {
		this.class = v;
	}
};

function extend(base, props) {
	var arguments$1 = arguments;

	for (var i = 1, obj = void 0; i < arguments.length; i++) {
		if (obj = arguments$1[i]) {
			for (var key in obj) {
				if (obj.hasOwnProperty(key)) {
					base[key] = obj[key];
				}
			}
		}
	}
	return base;
}

function shallowDiffers(a, b) {
	for (var i in a) {
		if (!(i in b)) {
			return true;
		}
	}
	for (var i$1 in b) {
		if (a[i$1] !== b[i$1]) {
			return true;
		}
	}
	return false;
}

function findDOMNode(component) {
	return component && (component.base || component.nodeType === 1 && component) || null;
}

function F() {}

function createClass(obj) {
	function cl(props, context) {
		bindAll(this);
		Component$1.call(this, props, context, BYPASS_HOOK);
		newComponentHook.call(this, props, context);
	}

	obj = extend({ constructor: cl }, obj);

	// We need to apply mixins here so that getDefaultProps is correctly mixed
	if (obj.mixins) {
		applyMixins(obj, collateMixins(obj.mixins));
	}
	if (obj.statics) {
		extend(cl, obj.statics);
	}
	if (obj.propTypes) {
		cl.propTypes = obj.propTypes;
	}
	if (obj.defaultProps) {
		cl.defaultProps = obj.defaultProps;
	}
	if (obj.getDefaultProps) {
		cl.defaultProps = obj.getDefaultProps.call(cl);
	}

	F.prototype = Component$1.prototype;
	cl.prototype = extend(new F(), obj);

	cl.displayName = obj.displayName || 'Component';

	return cl;
}

// Flatten an Array of mixins to a map of method name to mixin implementations
function collateMixins(mixins) {
	var keyed = {};
	for (var i = 0; i < mixins.length; i++) {
		var mixin = mixins[i];
		for (var key in mixin) {
			if (mixin.hasOwnProperty(key) && typeof mixin[key] === 'function') {
				(keyed[key] || (keyed[key] = [])).push(mixin[key]);
			}
		}
	}
	return keyed;
}

// apply a mapping of Arrays of mixin methods to a component prototype
function applyMixins(proto, mixins) {
	for (var key in mixins) {
		if (mixins.hasOwnProperty(key)) {
			proto[key] = multihook(mixins[key].concat(proto[key] || ARR), key === 'getDefaultProps' || key === 'getInitialState' || key === 'getChildContext');
		}
	}
}

function bindAll(ctx) {
	for (var i in ctx) {
		var v = ctx[i];
		if (typeof v === 'function' && !v.__bound && !AUTOBIND_BLACKLIST.hasOwnProperty(i)) {
			(ctx[i] = v.bind(ctx)).__bound = true;
		}
	}
}

function callMethod(ctx, m, args) {
	if (typeof m === 'string') {
		m = ctx.constructor.prototype[m];
	}
	if (typeof m === 'function') {
		return m.apply(ctx, args);
	}
}

function multihook(hooks, skipDuplicates) {
	return function () {
		var arguments$1 = arguments;
		var this$1 = this;

		var ret;
		for (var i = 0; i < hooks.length; i++) {
			var r = callMethod(this$1, hooks[i], arguments$1);

			if (skipDuplicates && r != null) {
				if (!ret) {
					ret = {};
				}
				for (var key in r) {
					if (r.hasOwnProperty(key)) {
						ret[key] = r[key];
					}
				}
			} else if (typeof r !== 'undefined') {
				ret = r;
			}
		}
		return ret;
	};
}

function newComponentHook(props, context) {
	propsHook.call(this, props, context);
	this.componentWillReceiveProps = multihook([propsHook, this.componentWillReceiveProps || 'componentWillReceiveProps']);
	this.render = multihook([propsHook, beforeRender, this.render || 'render', afterRender]);
}

function propsHook(props, context) {
	if (!props) {
		return;
	}

	// React annoyingly special-cases single children, and some react components are ridiculously strict about this.
	var c = props.children;
	if (c && Array.isArray(c) && c.length === 1 && (typeof c[0] === 'string' || typeof c[0] === 'function' || c[0] instanceof VNode)) {
		props.children = c[0];

		// but its totally still going to be an Array.
		if (props.children && typeof props.children === 'object') {
			props.children.length = 1;
			props.children[0] = props.children;
		}
	}

	// add proptype checking
	if (DEV) {
		var ctor = typeof this === 'function' ? this : this.constructor,
		    propTypes = this.propTypes || ctor.propTypes;
		var displayName = this.displayName || ctor.name;

		if (propTypes) {
			__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.checkPropTypes(propTypes, props, 'prop', displayName);
		}
	}
}

function beforeRender(props) {
	currentComponent = this;
}

function afterRender() {
	if (currentComponent === this) {
		currentComponent = null;
	}
}

function Component$1(props, context, opts) {
	__WEBPACK_IMPORTED_MODULE_1_preact__["Component"].call(this, props, context);
	this.state = this.getInitialState ? this.getInitialState() : {};
	this.refs = {};
	this._refProxies = {};
	if (opts !== BYPASS_HOOK) {
		newComponentHook.call(this, props, context);
	}
}
extend(Component$1.prototype = new __WEBPACK_IMPORTED_MODULE_1_preact__["Component"](), {
	constructor: Component$1,

	isReactComponent: {},

	replaceState: function replaceState(state, callback) {
		var this$1 = this;

		this.setState(state, callback);
		for (var i in this$1.state) {
			if (!(i in state)) {
				delete this$1.state[i];
			}
		}
	},

	getDOMNode: function getDOMNode() {
		return this.base;
	},

	isMounted: function isMounted() {
		return !!this.base;
	}
});

function PureComponent(props, context) {
	Component$1.call(this, props, context);
}
F.prototype = Component$1.prototype;
PureComponent.prototype = new F();
PureComponent.prototype.isPureReactComponent = true;
PureComponent.prototype.shouldComponentUpdate = function (props, state) {
	return shallowDiffers(this.props, props) || shallowDiffers(this.state, state);
};

function unstable_batchedUpdates(callback) {
	callback();
}

var index = {
	version: version,
	DOM: DOM,
	PropTypes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a,
	Children: Children,
	render: render$1,
	hydrate: render$1,
	createClass: createClass,
	createContext: __WEBPACK_IMPORTED_MODULE_2_preact_context__["createContext"],
	createPortal: createPortal,
	createFactory: createFactory,
	createElement: createElement,
	cloneElement: cloneElement$1,
	createRef: __WEBPACK_IMPORTED_MODULE_1_preact__["createRef"],
	isValidElement: isValidElement,
	findDOMNode: findDOMNode,
	unmountComponentAtNode: unmountComponentAtNode,
	Component: Component$1,
	PureComponent: PureComponent,
	unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer,
	unstable_batchedUpdates: unstable_batchedUpdates,
	__spread: extend
};

/* harmony default export */ __webpack_exports__["default"] = (index);

//# sourceMappingURL=preact-compat.es.js.map

/***/ }),

/***/ "em/f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return postMessageOnParentWindow; });
/* unused harmony export postScrollHeight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__("2UA+");


var IFrameOrigin = __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].getIframeOrigin();
var isWindowDefined = __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].isWindowDefined;

var DEFAULTERROR = {
  resultStatus: 'F',
  resultCode: '500',
  resultMsg: 'Something went wrong...'
};

var postMessageCall = function postMessageCall(info) {
  try {
    isWindowDefined && window && window.parent && window.parent.postMessage && window.parent.postMessage(info, IFrameOrigin);
    __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].log('POST_MESSAGE', 'success', { info: info });
  } catch (err) {
    __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].log('POST_MESSAGE', 'error', { err: err });
  }
};

var postMessageOnParentWindow = function postMessageOnParentWindow(response) {
  if (response && response.hasOwnProperty('body') && response.body && response.body.hasOwnProperty('resultInfo') && response.body.resultInfo) {
    postMessageCall(response.body.resultInfo);
  } else if (!response || !response.body || !response.body.resultInfo) {
    postMessageCall(DEFAULTERROR);
  }
};

/**
 * post the scroll height to `UMP`
 */

var postScrollHeight = function postScrollHeight() {
  if (isWindowDefined && document && document.getElementById) {
    var app = document.getElementById('app');
    try {
      var postMessageObj = {
        body: { resultInfo: { resultCode: '005', height: app.scrollHeight } }
      };
      // 005 code is used to pass the scrollHeight to UMP
      postMessageOnParentWindow(postMessageObj);
    } catch (err) {
      //
    }
  }
};

/***/ }),

/***/ "fgEf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"stage-wrap":"_3Pxa","steps":"_2cTB","succ-icon":"_2Esu","steps-txt":"_1AQl","steps-subtxt":"_3bhr","active":"_Hpjc","prev-active":"_2zO2","cursor":"_2C1W"};

/***/ }),

/***/ "hafV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return THEME_CONSTANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LIGHTTHEME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DARKTHEME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CUSTOMTHEME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CUSTOMBAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DEFULTPAYMODES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DEFAULT_GRADIENT_COLOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DEFAULT_CHECKOUT_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SmallButtonSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return MediumButtonSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return LargeButtonSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return QuickButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DonateButton; });
/* unused harmony export customButton */
var _constant = {};
var BASE_URL = '';

if (typeof window !== 'undefined') {
  if (true) {
    BASE_URL = "https://securegw-stage.paytm.in";
  }
}

BASE_URL += '/merchantpgpui';

_constant.saveUpdateUrl = BASE_URL + '/forms/update';
_constant.saveUpdateButtonApi = BASE_URL + '/paymentbutton/update';
_constant.deleteField = BASE_URL + '/forms/delete';
_constant.fetchTemplateFieldsForPreview = BASE_URL + '/previews';
_constant.saveThemePreferences = BASE_URL + '/theme';
_constant.saveCheckoutPreferences = BASE_URL + '/checkout';
_constant.updatePreference = BASE_URL + '/checkout/merchants';
_constant.FETCH_LINKS = BASE_URL + '/link/fetch';
_constant.UPDATE_LINKS = BASE_URL + '/link/update';
_constant.PGP = 'merchantpgpui';
_constant.THEME = 'theme';
_constant.FORM = 'form';
_constant.PREVIEW = 'preview';
_constant.BUILD = 'build';
_constant.MPASS_URL = 'https] =//mas-log.paas.paytm.com/loggw/dwcookieLogGet.do';
_constant.linkUrl = 'https] =//business.paytm.com/payment-link';
_constant.invoiceUrl = 'https] =//business.paytm.com';

_constant.BASE_URL = BASE_URL;

_constant.CUSTOM = 'Custom';
_constant.FIELD_TYPE = 'Field Type';

_constant.EDIT_FIELD = 'editFld';
_constant.RENDER_ARRAY_INDEX = 'renderArrIndx';
_constant.GIVEN_ARRAY_INDEX = 'givenArrIndx';
_constant.CUSTOM_DESC = 'Create custom field';
_constant.TEXT = 'Text';
_constant.NUMBER = 'Numeric';
_constant.DROPDOWN = 'Dropdown';
_constant.DATE = 'Date';
_constant.CUSTOM_AMOUNT = 'UserAmount';
_constant.CUSTOM_AMOUNT_MERCHANT = 'Amount';
_constant.CUSTOM_AMOUNT_FLEXIBLE = 'FlexibleAmount';
_constant.CUSTOM_AMOUNT_QUANTATIVE = 'QuantityAmount';
_constant.placeHolder = 'Select/Create Field';
_constant.Description = 'linkDescription';
_constant['Template Name'] = 'templateName';
_constant.ISCUSTOMERROR = 'isCustomError';
_constant.NOOPTIONERROR = 'noOptionError';
_constant.DISABLEADDOPNBTN = 'disableAddOpnBtn';
_constant.DATE_ORDINAL = '/';
_constant.MAX_DATE = 'Max Date';
_constant.MIN_DATE = 'Min Date';
_constant.ADD_FIELD_VALUE = 'addFieldValue';
_constant.MANDATORY_VALIDATION = 'isMandatoryValidation';
_constant.FIXED = 'Fixed amount';
_constant.QUANTITY = 'Add product or service';
_constant.FLEXIBLE = 'Customer chooses amount';
_constant.SHOR_TEXT = 'Short Text';
_constant.LONG_TEXT = 'Long Text';
_constant.FIXED_LENGTH = 'Fixed Length';
_constant.CARD_NAME = 'Debit, Credit Cards';
_constant.NB = 'NB';
_constant.UPI = 'UPI';
_constant.EMI = 'EMI';
_constant.CARD = 'CARD';
// preview constants
_constant.MID = 'MID';
_constant.TOKEN = 'TOKEN';
_constant.UNIQUEID = 'UNIQUEID';
_constant.H_ORIENTATION = 'H';
_constant.V_ORIENTATION = 'V';
_constant.CUSTOM_TEXT = 'Text';
_constant.CUSTOM_NUMBER = 'Numeric';
_constant.CUSTOM_DROPDOWN = 'Dropdown';
_constant.CUSTOM_DATE = 'Date';
_constant.PAYTM = 'PAYTM';
_constant.LOGIN = 'LOGIN';
_constant.SAVEURL = 'SAVEURL';
_constant.NONE = 'NONE';
_constant['DEFAULT_PAYMENT_BUTTON_COLOR_CODE'] = '#00b9f5';
_constant['DEFAULT_PAYMENT_BUTTON_FONT_COLOR_CODE'] = '#ffffff';
_constant['DEFAULT_PAYMENT_BUTTON_TITLE'] = 'Pay Now';
_constant.BLUE_LOGO = 'BLUE-LOGO';

_constant.CUSTOMFIELDS = {
  // name:'',
  // type: '',
  constraints: null
};

_constant.EDITFLD_OBJ = {
  name: '',
  type: '',
  hint: '',
  helpText: '',
  mandatory: '',
  constraints: '',
  orientation: 'H',
  size: '100'
};
_constant.TEXT_MIN_CHAR = 3;
_constant.TEXT_MAX_CHAR = 200;
_constant.SHORT_TEXT_MAX_CHAR = 30;
_constant.AMOUNT_MIN_VALUE = 0;
_constant.AMOUNT_MAX_VALUE = 100000000;
_constant.HELP_TEXT_MIN_CHAR = 3;
_constant.HELP_TEXT_MAX_CHAR = 50;
_constant.OPTION_NAME_MAX_CHAR = 30;
_constant.FIELD_NAME_MAX_CHAR = 30;
_constant.ALLOWED_MAX_FIELDS = 20;
_constant.TEMPLATE_NAME_MAX_CHAR = 100;
_constant['URL_MAX_CHAR'] = 500;
_constant['INFO_MAX_CHAR'] = 140;

_constant['MID'] = 'mid';
_constant['TOKEN'] = 'token';
_constant['BUTTON'] = 'button';
_constant['BUTTON_TYPES'] = { "quick": "Quick-Pay", "donate": "Donate", "custom": "Custom" };
_constant['INPUT_FIELD_LABEL'] = 'Field Label';
_constant['URL'] = 'URL';
_constant['URL_REGEX'] = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;
_constant['BUTTON_SCREEN'] = 'BUTTON_DETAILS';
_constant['CUSTOM_SCREEN'] = 'CUSTOM_SCREEN';
_constant['DONATE_SCREEN'] = 'DONATE_SCREEN';
_constant['REVIEW_SCREEN'] = 'REVIEW_SCREEN';
_constant['BUTTON_ID'] = 'BUTTON_ID';
//Input placeholder names
_constant['INPUT_FIELD_NAME'] = 'Field Name';
_constant['MIN_DATE'] = 'Min Date';
_constant['MAX_DATE'] = 'Max Date';
_constant['INPUT_AMOUNT'] = 'Amount';
_constant['INPUT_HELP_TEXT'] = 'Help text';
_constant['CUSTOM_TYPE'] = 'Custom Type';
_constant['INPUT_AMOUNT_MIN_QUNATITY'] = 'Min Quantity';
_constant['INPUT_AMOUNT_MAX_QUNATITY'] = 'Max Quantity';
_constant['RIGHT_ARROW'] = 'Rigth Arrow';
_constant['Left_ARROW'] = 'Left Arrow';
_constant['INPUT_TEMPLATE_NAME'] = 'Template Name';
_constant['INPUT_TEMPLATE_DESCRIPTION'] = 'Description';
_constant['UMP_SUCCESS_CODE'] = '004';
_constant['UMP_SUCCESS_UPDATE_CODE'] = '009';
_constant['UMP_FAIL_CODE'] = '003';
_constant['UMP_PAGE_LOAD_CODE'] = '001';
_constant.ACTIVE = "ACTIVE";
_constant.INACTIVE = "INIT";
_constant.SUBS_MIN_AMOUNT = 1;
_constant.ONDEMAND = 'ONDEMAND';
_constant.YMD_FORMAT = 'YYYY/MM/DD';
_constant.DMY_FORMAT = 'MM/DD/YYYY';
_constant.AMOUNT_FIXED = 'FIX';
_constant.AMOUNT_VARIABLE = 'VARIABLE';
_constant.INPUT_HELP_TEXT_PLACEHOLER = 'Enter help text';
_constant.INPUT_FIELD_NAME_PLACEHOLER = 'Enter Field name';
_constant.QUANTITY_FIELD_NAME_PLACEHOLER = 'Per unit cost';

var THEME_CONSTANTS = {
  HEADERPANEL: 'headerPanel',
  HEADERTEXT: 'headerText',
  PAYBUTTONBG: 'payButtonBG',
  PAYBUTTONTEXT: 'payButtonText',
  BODYBG: 'bodyBG',
  BODYTEXT: 'bodyText',
  LIGHT: 'LIGHT',
  DARK: 'DARK',
  CUSTOM: 'CUSTOM',
  GENERICERROR: 'Something went wrong...'
};

var LIGHTTHEME = {
  HEADERPANEL: '#F3F7F8',
  HEADERTEXT: '#506d85',
  PAYBUTTONBG: '#00b9f5',
  PAYBUTTONTEXT: '#FFFFFF',
  BODYBG: '#FFFFFF',
  BODYTEXT: '#1D252D',
  BOTTOMBG: '#F3F7F8',
  BORDER: '#F3F7F8',
  LABEL: 'Light theme',
  NAME: 'LIGHT',
  IMAGE: 'light',
  isSelected: true
};

var DARKTHEME = {
  HEADERPANEL: '#0d1528',
  HEADERTEXT: '#FFFFFF',
  PAYBUTTONBG: '#00b9f5',
  PAYBUTTONTEXT: '#FFFFFF',
  BODYBG: '#000a1e',
  BODYTEXT: '#FFFFFF',
  BOTTOMBG: '#000000',
  BORDER: '#0d1528',
  LABEL: 'Dark theme',
  NAME: 'DARK',
  IMAGE: 'dark',
  isSelected: false
};

var CUSTOMTHEME = {
  HEADERPANEL: '#F3F7F8',
  HEADERTEXT: '#000000',
  PAYBUTTONBG: '#00b9f5',
  PAYBUTTONTEXT: '#FFFFFF',
  BODYBG: '#FFFFFF',
  BODYTEXT: '#1D252D',
  BOTTOMBG: '#F3F7F8',
  BORDER: '#F3F7F8',
  LABEL: 'Custom theme',
  NAME: 'CUSTOM',
  IMAGE: 'custom',
  isSelected: false
};

var CUSTOMBAR = [{
  NAME: 'Header Panel',
  KEY: 'HEADERPANEL'
}, {
  NAME: 'Header Text',
  KEY: 'HEADERTEXT'
}, {
  NAME: 'Pay Button',
  KEY: 'PAYBUTTONBG'
}, {
  NAME: 'Pay Button Text',
  KEY: 'PAYBUTTONTEXT'
},
// {
//     "NAME": "Body background color",
//     "KEY": "BODYBG"
// },
{
  NAME: 'Body Text',
  KEY: 'BODYTEXT',
  DESC: '(including separators and input boxes)'
}, {
  NAME: 'Border',
  KEY: 'BORDER'
}];

var DEFULTPAYMODES = [{ name: 'Paytm', type: 'LOGIN', id: 1 }, { id: 7, name: 'Credit / Debit Card', type: 'CARD' }, { id: 9, name: 'BHIM UPI', type: 'UPI' }, { id: 8, name: 'Net Banking', type: 'NB' }];

var DEFAULT_GRADIENT_COLOR = {
  degree: 0,
  direction: '',
  buttonGradientsColors: [],
  headerGradientsColors: []
};
var DEFAULT_CHECKOUT_CONFIG = {
  root: '',
  style: {
    bodyBackgroundColor: '',
    bodyColor: '',
    themeBackgroundColor: '',
    themeColor: '',
    headerBackgroundColor: '',
    headerColor: '',
    borderColor: '',
    errorColor: '',
    successColor: '',
    gradient: JSON.parse(JSON.stringify(DEFAULT_GRADIENT_COLOR))
  },
  jsFile: '',
  data: {
    orderId: '',
    token: '',
    tokenType: 'SSO',
    mid: '',
    userDetail: { mobileNumber: 121212, name: '' }
  },
  merchant: { name: '', logo: '', redirect: true, callbackUrl: '', hidePaytmBranding: false },
  mapClientMessage: {},
  labels: {},
  payMode: { labels: {}, filter: { include: [], exclude: [] }, order: [] },
  handler: {}
};

var SmallButtonSize = { type: "SMALL", name: "Small", font: "12px", height: "28px", lineHeight: "28px", padding: "0 23px" };
var MediumButtonSize = { type: "MEDIUM", name: "Medium", font: "14px", height: "48px", lineHeight: "48px", padding: "0 40px" };
var LargeButtonSize = { type: "LARGE", name: "Large", font: "16px", height: "56px", lineHeight: "56px", padding: "0 41px" };
var QuickButton = { type: "QUICK", name: "Quick-Pay Button" };
var DonateButton = { type: "DONATE", name: "Donate Button" };
var customButton = { type: "CUSTOM", name: "Custom Button" };

/* harmony default export */ __webpack_exports__["n"] = (_constant);

/***/ }),

/***/ "lcwS":
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function (useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if (item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function (modules, mediaQuery) {
		if (typeof modules === "string") modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for (var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if (typeof id === "number") alreadyImportedModules[id] = true;
		}
		for (i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if (mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if (mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */';
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}

/***/ }),

/***/ "o0Qn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tab-content":"_2wNo","mobile-wrap":"_2K4p","m-header":"_3Ypr","choose-txt":"_1kuL","amount-txt":"_1dAv","amount-para":"_20fp","amount":"_3Jdt","subheading":"_16M7","mer-name":"_23qt","ptm-head-logo":"_2XWI","m-content":"_nwGi","select-txt":"_2dTy","sc-img":"_3iEH","wallet":"_1oas","grid-wrap":"_Btln","grid":"_uN4I","pay-method":"_3ocd","wallet-inner":"_37lS","grid-img":"_-EDB","check":"_44ex","sign1":"_3BjX","sign2":"_1yGy","check-txt":"_3l50","w100":"_3k2H","wallet-txt":"_2MiE","wallet-para":"_1gDB","pay-btn":"_gWTt","pay-mode-wrap":"_3-HU","pay-list-wrap":"_1Sz-","pay-list":"_15c6","border-div":"_39Tm","radio-circle":"_1xKE","m-footer":"_38OZ","dark-border":"_2eVz","secure":"_1cdW","default":"_2lad","backSection":"_1HsB","arrow":"_21BX","back":"_2_id","user-bg":"_4NEN","payBtnWrap":"_1srZ","payBtn":"_1RF-","payBtnimg":"_3AYV","mer-logo":"_1c2F","brand-logo":"_3iWJ","cardtype":"_BqJI"};

/***/ }),

/***/ "o6ac":
/***/ (function(module, exports, __webpack_require__) {

var t = __webpack_require__("KM04");function n(t, n) {
  for (var r in n) {
    t[r] = n[r];
  }return t;
}function r(t) {
  this.getChildContext = function () {
    return { store: t.store };
  };
}r.prototype.render = function (t) {
  return t.children && t.children[0] || t.children;
}, exports.connect = function (r, e) {
  var o;return "function" != typeof r && ("string" == typeof (o = r || {}) && (o = o.split(/\s*,\s*/)), r = function r(t) {
    for (var n = {}, r = 0; r < o.length; r++) {
      n[o[r]] = t[o[r]];
    }return n;
  }), function (o) {
    function i(i, u) {
      var c = this,
          f = u.store,
          s = r(f ? f.getState() : {}, i),
          a = e ? function (t, n) {
        "function" == typeof t && (t = t(n));var r = {};for (var e in t) {
          r[e] = n.action(t[e]);
        }return r;
      }(e, f) : { store: f },
          p = function p() {
        var t = r(f ? f.getState() : {}, i);for (var n in t) {
          if (t[n] !== s[n]) return s = t, c.setState({});
        }for (var e in s) {
          if (!(e in t)) return s = t, c.setState({});
        }
      };this.componentWillReceiveProps = function (t) {
        i = t, p();
      }, this.componentDidMount = function () {
        f.subscribe(p);
      }, this.componentWillUnmount = function () {
        f.unsubscribe(p);
      }, this.render = function (r) {
        return t.h(o, n(n(n({}, a), r), s));
      };
    }return (i.prototype = new t.Component()).constructor = i;
  };
}, exports.Provider = r;
//# sourceMappingURL=preact.js.map

/***/ }),

/***/ "qtbF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"save":"_2KAX","notification":"_2vZS","note-txt":"__kSr"};

/***/ }),

/***/ "s8o+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"select-color":"_FviM"};

/***/ }),

/***/ "t+Vk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);

/***/ }),

/***/ "tZHd":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**!
 * Sortable
 * @author	RubaXa   <trash@rubaxa.org>
 * @license MIT
 */

(function sortableModule(factory) {
	"use strict";

	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module != "undefined" && typeof module.exports != "undefined") {
		module.exports = factory();
	} else {
		/* jshint sub:true */
		window["Sortable"] = factory();
	}
})(function sortableFactory() {
	"use strict";

	if (typeof window == "undefined" || !window.document) {
		return function sortableError() {
			throw new Error("Sortable.js requires a window with a document");
		};
	}

	var dragEl,
	    parentEl,
	    ghostEl,
	    cloneEl,
	    rootEl,
	    nextEl,
	    lastDownEl,
	    scrollEl,
	    scrollParentEl,
	    scrollCustomFn,
	    lastEl,
	    lastCSS,
	    lastParentCSS,
	    oldIndex,
	    newIndex,
	    activeGroup,
	    putSortable,
	    autoScroll = {},
	    tapEvt,
	    touchEvt,
	    moved,


	/** @const */
	R_SPACE = /\s+/g,
	    R_FLOAT = /left|right|inline/,
	    expando = 'Sortable' + new Date().getTime(),
	    win = window,
	    document = win.document,
	    parseInt = win.parseInt,
	    $ = win.jQuery || win.Zepto,
	    Polymer = win.Polymer,
	    captureMode = false,
	    supportDraggable = !!('draggable' in document.createElement('div')),
	    supportCssPointerEvents = function (el) {
		// false when IE11
		if (!!navigator.userAgent.match(/Trident.*rv[ :]?11\./)) {
			return false;
		}
		el = document.createElement('x');
		el.style.cssText = 'pointer-events:auto';
		return el.style.pointerEvents === 'auto';
	}(),
	    _silent = false,
	    abs = Math.abs,
	    min = Math.min,
	    savedInputChecked = [],
	    touchDragOverListeners = [],
	    _autoScroll = _throttle(function ( /**Event*/evt, /**Object*/options, /**HTMLElement*/rootEl) {
		// Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
		if (rootEl && options.scroll) {
			var _this = rootEl[expando],
			    el,
			    rect,
			    sens = options.scrollSensitivity,
			    speed = options.scrollSpeed,
			    x = evt.clientX,
			    y = evt.clientY,
			    winWidth = window.innerWidth,
			    winHeight = window.innerHeight,
			    vx,
			    vy,
			    scrollOffsetX,
			    scrollOffsetY;

			// Delect scrollEl
			if (scrollParentEl !== rootEl) {
				scrollEl = options.scroll;
				scrollParentEl = rootEl;
				scrollCustomFn = options.scrollFn;

				if (scrollEl === true) {
					scrollEl = rootEl;

					do {
						if (scrollEl.offsetWidth < scrollEl.scrollWidth || scrollEl.offsetHeight < scrollEl.scrollHeight) {
							break;
						}
						/* jshint boss:true */
					} while (scrollEl = scrollEl.parentNode);
				}
			}

			if (scrollEl) {
				el = scrollEl;
				rect = scrollEl.getBoundingClientRect();
				vx = (abs(rect.right - x) <= sens) - (abs(rect.left - x) <= sens);
				vy = (abs(rect.bottom - y) <= sens) - (abs(rect.top - y) <= sens);
			}

			if (!(vx || vy)) {
				vx = (winWidth - x <= sens) - (x <= sens);
				vy = (winHeight - y <= sens) - (y <= sens);

				/* jshint expr:true */
				(vx || vy) && (el = win);
			}

			if (autoScroll.vx !== vx || autoScroll.vy !== vy || autoScroll.el !== el) {
				autoScroll.el = el;
				autoScroll.vx = vx;
				autoScroll.vy = vy;

				clearInterval(autoScroll.pid);

				if (el) {
					autoScroll.pid = setInterval(function () {
						scrollOffsetY = vy ? vy * speed : 0;
						scrollOffsetX = vx ? vx * speed : 0;

						if ('function' === typeof scrollCustomFn) {
							return scrollCustomFn.call(_this, scrollOffsetX, scrollOffsetY, evt);
						}

						if (el === win) {
							win.scrollTo(win.pageXOffset + scrollOffsetX, win.pageYOffset + scrollOffsetY);
						} else {
							el.scrollTop += scrollOffsetY;
							el.scrollLeft += scrollOffsetX;
						}
					}, 24);
				}
			}
		}
	}, 30),
	    _prepareGroup = function _prepareGroup(options) {
		function toFn(value, pull) {
			if (value === void 0 || value === true) {
				value = group.name;
			}

			if (typeof value === 'function') {
				return value;
			} else {
				return function (to, from) {
					var fromGroup = from.options.group.name;

					return pull ? value : value && (value.join ? value.indexOf(fromGroup) > -1 : fromGroup == value);
				};
			}
		}

		var group = {};
		var originalGroup = options.group;

		if (!originalGroup || typeof originalGroup != 'object') {
			originalGroup = { name: originalGroup };
		}

		group.name = originalGroup.name;
		group.checkPull = toFn(originalGroup.pull, true);
		group.checkPut = toFn(originalGroup.put);
		group.revertClone = originalGroup.revertClone;

		options.group = group;
	};

	/**
  * @class  Sortable
  * @param  {HTMLElement}  el
  * @param  {Object}       [options]
  */
	function Sortable(el, options) {
		if (!(el && el.nodeType && el.nodeType === 1)) {
			throw 'Sortable: `el` must be HTMLElement, and not ' + {}.toString.call(el);
		}

		this.el = el; // root element
		this.options = options = _extend({}, options);

		// Export instance
		el[expando] = this;

		// Default options
		var defaults = {
			group: Math.random(),
			sort: true,
			disabled: false,
			store: null,
			handle: null,
			scroll: true,
			scrollSensitivity: 30,
			scrollSpeed: 10,
			draggable: /[uo]l/i.test(el.nodeName) ? 'li' : '>*',
			ghostClass: 'sortable-ghost',
			chosenClass: 'sortable-chosen',
			dragClass: 'sortable-drag',
			ignore: 'a, img',
			filter: null,
			preventOnFilter: true,
			animation: 0,
			setData: function setData(dataTransfer, dragEl) {
				dataTransfer.setData('Text', dragEl.textContent);
			},
			dropBubble: false,
			dragoverBubble: false,
			dataIdAttr: 'data-id',
			delay: 0,
			forceFallback: false,
			fallbackClass: 'sortable-fallback',
			fallbackOnBody: false,
			fallbackTolerance: 0,
			fallbackOffset: { x: 0, y: 0 }
		};

		// Set default options
		for (var name in defaults) {
			!(name in options) && (options[name] = defaults[name]);
		}

		_prepareGroup(options);

		// Bind all private methods
		for (var fn in this) {
			if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
				this[fn] = this[fn].bind(this);
			}
		}

		// Setup drag mode
		this.nativeDraggable = options.forceFallback ? false : supportDraggable;

		// Bind events
		_on(el, 'mousedown', this._onTapStart);
		_on(el, 'touchstart', this._onTapStart);
		_on(el, 'pointerdown', this._onTapStart);

		if (this.nativeDraggable) {
			_on(el, 'dragover', this);
			_on(el, 'dragenter', this);
		}

		touchDragOverListeners.push(this._onDragOver);

		// Restore sorting
		options.store && this.sort(options.store.get(this));
	}

	Sortable.prototype = /** @lends Sortable.prototype */{
		constructor: Sortable,

		_onTapStart: function _onTapStart( /** Event|TouchEvent */evt) {
			var _this = this,
			    el = this.el,
			    options = this.options,
			    preventOnFilter = options.preventOnFilter,
			    type = evt.type,
			    touch = evt.touches && evt.touches[0],
			    target = (touch || evt).target,
			    originalTarget = evt.target.shadowRoot && evt.path && evt.path[0] || target,
			    filter = options.filter,
			    startIndex;

			_saveInputCheckedState(el);

			// Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
			if (dragEl) {
				return;
			}

			if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
				return; // only left button or enabled
			}

			target = _closest(target, options.draggable, el);

			if (!target) {
				return;
			}

			if (lastDownEl === target) {
				// Ignoring duplicate `down`
				return;
			}

			// Get the index of the dragged element within its parent
			startIndex = _index(target, options.draggable);

			// Check filter
			if (typeof filter === 'function') {
				if (filter.call(this, evt, target, this)) {
					_dispatchEvent(_this, originalTarget, 'filter', target, el, startIndex);
					preventOnFilter && evt.preventDefault();
					return; // cancel dnd
				}
			} else if (filter) {
				filter = filter.split(',').some(function (criteria) {
					criteria = _closest(originalTarget, criteria.trim(), el);

					if (criteria) {
						_dispatchEvent(_this, criteria, 'filter', target, el, startIndex);
						return true;
					}
				});

				if (filter) {
					preventOnFilter && evt.preventDefault();
					return; // cancel dnd
				}
			}

			if (options.handle && !_closest(originalTarget, options.handle, el)) {
				return;
			}

			// Prepare `dragstart`
			this._prepareDragStart(evt, touch, target, startIndex);
		},

		_prepareDragStart: function _prepareDragStart( /** Event */evt, /** Touch */touch, /** HTMLElement */target, /** Number */startIndex) {
			var _this = this,
			    el = _this.el,
			    options = _this.options,
			    ownerDocument = el.ownerDocument,
			    dragStartFn;

			if (target && !dragEl && target.parentNode === el) {
				tapEvt = evt;

				rootEl = el;
				dragEl = target;
				parentEl = dragEl.parentNode;
				nextEl = dragEl.nextSibling;
				lastDownEl = target;
				activeGroup = options.group;
				oldIndex = startIndex;

				this._lastX = (touch || evt).clientX;
				this._lastY = (touch || evt).clientY;

				dragEl.style['will-change'] = 'transform';

				dragStartFn = function dragStartFn() {
					// Delayed drag has been triggered
					// we can re-enable the events: touchmove/mousemove
					_this._disableDelayedDrag();

					// Make the element draggable
					dragEl.draggable = _this.nativeDraggable;

					// Chosen item
					_toggleClass(dragEl, options.chosenClass, true);

					// Bind the events: dragstart/dragend
					_this._triggerDragStart(evt, touch);

					// Drag start event
					_dispatchEvent(_this, rootEl, 'choose', dragEl, rootEl, oldIndex);
				};

				// Disable "draggable"
				options.ignore.split(',').forEach(function (criteria) {
					_find(dragEl, criteria.trim(), _disableDraggable);
				});

				_on(ownerDocument, 'mouseup', _this._onDrop);
				_on(ownerDocument, 'touchend', _this._onDrop);
				_on(ownerDocument, 'touchcancel', _this._onDrop);
				_on(ownerDocument, 'pointercancel', _this._onDrop);
				_on(ownerDocument, 'selectstart', _this);

				if (options.delay) {
					// If the user moves the pointer or let go the click or touch
					// before the delay has been reached:
					// disable the delayed drag
					_on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
					_on(ownerDocument, 'touchend', _this._disableDelayedDrag);
					_on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
					_on(ownerDocument, 'mousemove', _this._disableDelayedDrag);
					_on(ownerDocument, 'touchmove', _this._disableDelayedDrag);
					_on(ownerDocument, 'pointermove', _this._disableDelayedDrag);

					_this._dragStartTimer = setTimeout(dragStartFn, options.delay);
				} else {
					dragStartFn();
				}
			}
		},

		_disableDelayedDrag: function _disableDelayedDrag() {
			var ownerDocument = this.el.ownerDocument;

			clearTimeout(this._dragStartTimer);
			_off(ownerDocument, 'mouseup', this._disableDelayedDrag);
			_off(ownerDocument, 'touchend', this._disableDelayedDrag);
			_off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
			_off(ownerDocument, 'mousemove', this._disableDelayedDrag);
			_off(ownerDocument, 'touchmove', this._disableDelayedDrag);
			_off(ownerDocument, 'pointermove', this._disableDelayedDrag);
		},

		_triggerDragStart: function _triggerDragStart( /** Event */evt, /** Touch */touch) {
			touch = touch || (evt.pointerType == 'touch' ? evt : null);

			if (touch) {
				// Touch device support
				tapEvt = {
					target: dragEl,
					clientX: touch.clientX,
					clientY: touch.clientY
				};

				this._onDragStart(tapEvt, 'touch');
			} else if (!this.nativeDraggable) {
				this._onDragStart(tapEvt, true);
			} else {
				_on(dragEl, 'dragend', this);
				_on(rootEl, 'dragstart', this._onDragStart);
			}

			try {
				if (document.selection) {
					// Timeout neccessary for IE9
					setTimeout(function () {
						document.selection.empty();
					});
				} else {
					window.getSelection().removeAllRanges();
				}
			} catch (err) {}
		},

		_dragStarted: function _dragStarted() {
			if (rootEl && dragEl) {
				var options = this.options;

				// Apply effect
				_toggleClass(dragEl, options.ghostClass, true);
				_toggleClass(dragEl, options.dragClass, false);

				Sortable.active = this;

				// Drag start event
				_dispatchEvent(this, rootEl, 'start', dragEl, rootEl, oldIndex);
			} else {
				this._nulling();
			}
		},

		_emulateDragOver: function _emulateDragOver() {
			if (touchEvt) {
				if (this._lastX === touchEvt.clientX && this._lastY === touchEvt.clientY) {
					return;
				}

				this._lastX = touchEvt.clientX;
				this._lastY = touchEvt.clientY;

				if (!supportCssPointerEvents) {
					_css(ghostEl, 'display', 'none');
				}

				var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY),
				    parent = target,
				    i = touchDragOverListeners.length;

				if (parent) {
					do {
						if (parent[expando]) {
							while (i--) {
								touchDragOverListeners[i]({
									clientX: touchEvt.clientX,
									clientY: touchEvt.clientY,
									target: target,
									rootEl: parent
								});
							}

							break;
						}

						target = parent; // store last element
					}
					/* jshint boss:true */
					while (parent = parent.parentNode);
				}

				if (!supportCssPointerEvents) {
					_css(ghostEl, 'display', '');
				}
			}
		},

		_onTouchMove: function _onTouchMove( /**TouchEvent*/evt) {
			if (tapEvt) {
				var options = this.options,
				    fallbackTolerance = options.fallbackTolerance,
				    fallbackOffset = options.fallbackOffset,
				    touch = evt.touches ? evt.touches[0] : evt,
				    dx = touch.clientX - tapEvt.clientX + fallbackOffset.x,
				    dy = touch.clientY - tapEvt.clientY + fallbackOffset.y,
				    translate3d = evt.touches ? 'translate3d(' + dx + 'px,' + dy + 'px,0)' : 'translate(' + dx + 'px,' + dy + 'px)';

				// only set the status to dragging, when we are actually dragging
				if (!Sortable.active) {
					if (fallbackTolerance && min(abs(touch.clientX - this._lastX), abs(touch.clientY - this._lastY)) < fallbackTolerance) {
						return;
					}

					this._dragStarted();
				}

				// as well as creating the ghost element on the document body
				this._appendGhost();

				moved = true;
				touchEvt = touch;

				_css(ghostEl, 'webkitTransform', translate3d);
				_css(ghostEl, 'mozTransform', translate3d);
				_css(ghostEl, 'msTransform', translate3d);
				_css(ghostEl, 'transform', translate3d);

				evt.preventDefault();
			}
		},

		_appendGhost: function _appendGhost() {
			if (!ghostEl) {
				var rect = dragEl.getBoundingClientRect(),
				    css = _css(dragEl),
				    options = this.options,
				    ghostRect;

				ghostEl = dragEl.cloneNode(true);

				_toggleClass(ghostEl, options.ghostClass, false);
				_toggleClass(ghostEl, options.fallbackClass, true);
				_toggleClass(ghostEl, options.dragClass, true);

				_css(ghostEl, 'top', rect.top - parseInt(css.marginTop, 10));
				_css(ghostEl, 'left', rect.left - parseInt(css.marginLeft, 10));
				_css(ghostEl, 'width', rect.width);
				_css(ghostEl, 'height', rect.height);
				_css(ghostEl, 'opacity', '0.8');
				_css(ghostEl, 'position', 'fixed');
				_css(ghostEl, 'zIndex', '100000');
				_css(ghostEl, 'pointerEvents', 'none');

				options.fallbackOnBody && document.body.appendChild(ghostEl) || rootEl.appendChild(ghostEl);

				// Fixing dimensions.
				ghostRect = ghostEl.getBoundingClientRect();
				_css(ghostEl, 'width', rect.width * 2 - ghostRect.width);
				_css(ghostEl, 'height', rect.height * 2 - ghostRect.height);
			}
		},

		_onDragStart: function _onDragStart( /**Event*/evt, /**boolean*/useFallback) {
			var dataTransfer = evt.dataTransfer,
			    options = this.options;

			this._offUpEvents();

			if (activeGroup.checkPull(this, this, dragEl, evt)) {
				cloneEl = _clone(dragEl);

				cloneEl.draggable = false;
				cloneEl.style['will-change'] = '';

				_css(cloneEl, 'display', 'none');
				_toggleClass(cloneEl, this.options.chosenClass, false);

				rootEl.insertBefore(cloneEl, dragEl);
				_dispatchEvent(this, rootEl, 'clone', dragEl);
			}

			_toggleClass(dragEl, options.dragClass, true);

			if (useFallback) {
				if (useFallback === 'touch') {
					// Bind touch events
					_on(document, 'touchmove', this._onTouchMove);
					_on(document, 'touchend', this._onDrop);
					_on(document, 'touchcancel', this._onDrop);
					_on(document, 'pointermove', this._onTouchMove);
					_on(document, 'pointerup', this._onDrop);
				} else {
					// Old brwoser
					_on(document, 'mousemove', this._onTouchMove);
					_on(document, 'mouseup', this._onDrop);
				}

				this._loopId = setInterval(this._emulateDragOver, 50);
			} else {
				if (dataTransfer) {
					dataTransfer.effectAllowed = 'move';
					options.setData && options.setData.call(this, dataTransfer, dragEl);
				}

				_on(document, 'drop', this);
				setTimeout(this._dragStarted, 0);
			}
		},

		_onDragOver: function _onDragOver( /**Event*/evt) {
			var el = this.el,
			    target,
			    dragRect,
			    targetRect,
			    revert,
			    options = this.options,
			    group = options.group,
			    activeSortable = Sortable.active,
			    isOwner = activeGroup === group,
			    isMovingBetweenSortable = false,
			    canSort = options.sort;

			if (evt.preventDefault !== void 0) {
				evt.preventDefault();
				!options.dragoverBubble && evt.stopPropagation();
			}

			if (dragEl.animated) {
				return;
			}

			moved = true;

			if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = !rootEl.contains(dragEl)) // Reverting item into the original list
			: putSortable === this || (activeSortable.lastPullMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt)) && (evt.rootEl === void 0 || evt.rootEl === this.el) // touch fallback
			) {
					// Smart auto-scrolling
					_autoScroll(evt, options, this.el);

					if (_silent) {
						return;
					}

					target = _closest(evt.target, options.draggable, el);
					dragRect = dragEl.getBoundingClientRect();

					if (putSortable !== this) {
						putSortable = this;
						isMovingBetweenSortable = true;
					}

					if (revert) {
						_cloneHide(activeSortable, true);
						parentEl = rootEl; // actualization

						if (cloneEl || nextEl) {
							rootEl.insertBefore(dragEl, cloneEl || nextEl);
						} else if (!canSort) {
							rootEl.appendChild(dragEl);
						}

						return;
					}

					if (el.children.length === 0 || el.children[0] === ghostEl || el === evt.target && _ghostIsLast(el, evt)) {
						//assign target only if condition is true
						if (el.children.length !== 0 && el.children[0] !== ghostEl && el === evt.target) {
							target = el.lastElementChild;
						}

						if (target) {
							if (target.animated) {
								return;
							}

							targetRect = target.getBoundingClientRect();
						}

						_cloneHide(activeSortable, isOwner);

						if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt) !== false) {
							if (!dragEl.contains(el)) {
								el.appendChild(dragEl);
								parentEl = el; // actualization
							}

							this._animate(dragRect, dragEl);
							target && this._animate(targetRect, target);
						}
					} else if (target && !target.animated && target !== dragEl && target.parentNode[expando] !== void 0) {
						if (lastEl !== target) {
							lastEl = target;
							lastCSS = _css(target);
							lastParentCSS = _css(target.parentNode);
						}

						targetRect = target.getBoundingClientRect();

						var width = targetRect.right - targetRect.left,
						    height = targetRect.bottom - targetRect.top,
						    floating = R_FLOAT.test(lastCSS.cssFloat + lastCSS.display) || lastParentCSS.display == 'flex' && lastParentCSS['flex-direction'].indexOf('row') === 0,
						    isWide = target.offsetWidth > dragEl.offsetWidth,
						    isLong = target.offsetHeight > dragEl.offsetHeight,
						    halfway = (floating ? (evt.clientX - targetRect.left) / width : (evt.clientY - targetRect.top) / height) > 0.5,
						    nextSibling = target.nextElementSibling,
						    after = false;

						if (floating) {
							var elTop = dragEl.offsetTop,
							    tgTop = target.offsetTop;

							if (elTop === tgTop) {
								after = target.previousElementSibling === dragEl && !isWide || halfway && isWide;
							} else if (target.previousElementSibling === dragEl || dragEl.previousElementSibling === target) {
								after = (evt.clientY - targetRect.top) / height > 0.5;
							} else {
								after = tgTop > elTop;
							}
						} else if (!isMovingBetweenSortable) {
							after = nextSibling !== dragEl && !isLong || halfway && isLong;
						}

						var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);

						if (moveVector !== false) {
							if (moveVector === 1 || moveVector === -1) {
								after = moveVector === 1;
							}

							_silent = true;
							setTimeout(_unsilent, 30);

							_cloneHide(activeSortable, isOwner);

							if (!dragEl.contains(el)) {
								if (after && !nextSibling) {
									el.appendChild(dragEl);
								} else {
									target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
								}
							}

							parentEl = dragEl.parentNode; // actualization

							this._animate(dragRect, dragEl);
							this._animate(targetRect, target);
						}
					}
				}
		},

		_animate: function _animate(prevRect, target) {
			var ms = this.options.animation;

			if (ms) {
				var currentRect = target.getBoundingClientRect();

				if (prevRect.nodeType === 1) {
					prevRect = prevRect.getBoundingClientRect();
				}

				_css(target, 'transition', 'none');
				_css(target, 'transform', 'translate3d(' + (prevRect.left - currentRect.left) + 'px,' + (prevRect.top - currentRect.top) + 'px,0)');

				target.offsetWidth; // repaint

				_css(target, 'transition', 'all ' + ms + 'ms');
				_css(target, 'transform', 'translate3d(0,0,0)');

				clearTimeout(target.animated);
				target.animated = setTimeout(function () {
					_css(target, 'transition', '');
					_css(target, 'transform', '');
					target.animated = false;
				}, ms);
			}
		},

		_offUpEvents: function _offUpEvents() {
			var ownerDocument = this.el.ownerDocument;

			_off(document, 'touchmove', this._onTouchMove);
			_off(document, 'pointermove', this._onTouchMove);
			_off(ownerDocument, 'mouseup', this._onDrop);
			_off(ownerDocument, 'touchend', this._onDrop);
			_off(ownerDocument, 'pointerup', this._onDrop);
			_off(ownerDocument, 'touchcancel', this._onDrop);
			_off(ownerDocument, 'pointercancel', this._onDrop);
			_off(ownerDocument, 'selectstart', this);
		},

		_onDrop: function _onDrop( /**Event*/evt) {
			var el = this.el,
			    options = this.options;

			clearInterval(this._loopId);
			clearInterval(autoScroll.pid);
			clearTimeout(this._dragStartTimer);

			// Unbind events
			_off(document, 'mousemove', this._onTouchMove);

			if (this.nativeDraggable) {
				_off(document, 'drop', this);
				_off(el, 'dragstart', this._onDragStart);
			}

			this._offUpEvents();

			if (evt) {
				if (moved) {
					evt.preventDefault();
					!options.dropBubble && evt.stopPropagation();
				}

				ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);

				if (rootEl === parentEl || Sortable.active.lastPullMode !== 'clone') {
					// Remove clone
					cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
				}

				if (dragEl) {
					if (this.nativeDraggable) {
						_off(dragEl, 'dragend', this);
					}

					_disableDraggable(dragEl);
					dragEl.style['will-change'] = '';

					// Remove class's
					_toggleClass(dragEl, this.options.ghostClass, false);
					_toggleClass(dragEl, this.options.chosenClass, false);

					// Drag stop event
					_dispatchEvent(this, rootEl, 'unchoose', dragEl, rootEl, oldIndex);

					if (rootEl !== parentEl) {
						newIndex = _index(dragEl, options.draggable);

						if (newIndex >= 0) {
							// Add event
							_dispatchEvent(null, parentEl, 'add', dragEl, rootEl, oldIndex, newIndex);

							// Remove event
							_dispatchEvent(this, rootEl, 'remove', dragEl, rootEl, oldIndex, newIndex);

							// drag from one list and drop into another
							_dispatchEvent(null, parentEl, 'sort', dragEl, rootEl, oldIndex, newIndex);
							_dispatchEvent(this, rootEl, 'sort', dragEl, rootEl, oldIndex, newIndex);
						}
					} else {
						if (dragEl.nextSibling !== nextEl) {
							// Get the index of the dragged element within its parent
							newIndex = _index(dragEl, options.draggable);

							if (newIndex >= 0) {
								// drag & drop within the same list
								_dispatchEvent(this, rootEl, 'update', dragEl, rootEl, oldIndex, newIndex);
								_dispatchEvent(this, rootEl, 'sort', dragEl, rootEl, oldIndex, newIndex);
							}
						}
					}

					if (Sortable.active) {
						/* jshint eqnull:true */
						if (newIndex == null || newIndex === -1) {
							newIndex = oldIndex;
						}

						_dispatchEvent(this, rootEl, 'end', dragEl, rootEl, oldIndex, newIndex);

						// Save sorting
						this.save();
					}
				}
			}

			this._nulling();
		},

		_nulling: function _nulling() {
			rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = scrollEl = scrollParentEl = tapEvt = touchEvt = moved = newIndex = lastEl = lastCSS = putSortable = activeGroup = Sortable.active = null;

			savedInputChecked.forEach(function (el) {
				el.checked = true;
			});
			savedInputChecked.length = 0;
		},

		handleEvent: function handleEvent( /**Event*/evt) {
			switch (evt.type) {
				case 'drop':
				case 'dragend':
					this._onDrop(evt);
					break;

				case 'dragover':
				case 'dragenter':
					if (dragEl) {
						this._onDragOver(evt);
						_globalDragOver(evt);
					}
					break;

				case 'selectstart':
					evt.preventDefault();
					break;
			}
		},

		/**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
		toArray: function toArray() {
			var order = [],
			    el,
			    children = this.el.children,
			    i = 0,
			    n = children.length,
			    options = this.options;

			for (; i < n; i++) {
				el = children[i];
				if (_closest(el, options.draggable, this.el)) {
					order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
				}
			}

			return order;
		},

		/**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
		sort: function sort(order) {
			var items = {},
			    rootEl = this.el;

			this.toArray().forEach(function (id, i) {
				var el = rootEl.children[i];

				if (_closest(el, this.options.draggable, rootEl)) {
					items[id] = el;
				}
			}, this);

			order.forEach(function (id) {
				if (items[id]) {
					rootEl.removeChild(items[id]);
					rootEl.appendChild(items[id]);
				}
			});
		},

		/**
   * Save the current sorting
   */
		save: function save() {
			var store = this.options.store;
			store && store.set(this);
		},

		/**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
		closest: function closest(el, selector) {
			return _closest(el, selector || this.options.draggable, this.el);
		},

		/**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
		option: function option(name, value) {
			var options = this.options;

			if (value === void 0) {
				return options[name];
			} else {
				options[name] = value;

				if (name === 'group') {
					_prepareGroup(options);
				}
			}
		},

		/**
   * Destroy
   */
		destroy: function destroy() {
			var el = this.el;

			el[expando] = null;

			_off(el, 'mousedown', this._onTapStart);
			_off(el, 'touchstart', this._onTapStart);
			_off(el, 'pointerdown', this._onTapStart);

			if (this.nativeDraggable) {
				_off(el, 'dragover', this);
				_off(el, 'dragenter', this);
			}

			// Remove draggable attributes
			Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
				el.removeAttribute('draggable');
			});

			touchDragOverListeners.splice(touchDragOverListeners.indexOf(this._onDragOver), 1);

			this._onDrop();

			this.el = el = null;
		}
	};

	function _cloneHide(sortable, state) {
		if (sortable.lastPullMode !== 'clone') {
			state = true;
		}

		if (cloneEl && cloneEl.state !== state) {
			_css(cloneEl, 'display', state ? 'none' : '');

			if (!state) {
				if (cloneEl.state) {
					if (sortable.options.group.revertClone) {
						rootEl.insertBefore(cloneEl, nextEl);
						sortable._animate(dragEl, cloneEl);
					} else {
						rootEl.insertBefore(cloneEl, dragEl);
					}
				}
			}

			cloneEl.state = state;
		}
	}

	function _closest( /**HTMLElement*/el, /**String*/selector, /**HTMLElement*/ctx) {
		if (el) {
			ctx = ctx || document;

			do {
				if (selector === '>*' && el.parentNode === ctx || _matches(el, selector)) {
					return el;
				}
				/* jshint boss:true */
			} while (el = _getParentOrHost(el));
		}

		return null;
	}

	function _getParentOrHost(el) {
		var parent = el.host;

		return parent && parent.nodeType ? parent : el.parentNode;
	}

	function _globalDragOver( /**Event*/evt) {
		if (evt.dataTransfer) {
			evt.dataTransfer.dropEffect = 'move';
		}
		evt.preventDefault();
	}

	function _on(el, event, fn) {
		el.addEventListener(event, fn, captureMode);
	}

	function _off(el, event, fn) {
		el.removeEventListener(event, fn, captureMode);
	}

	function _toggleClass(el, name, state) {
		if (el) {
			if (el.classList) {
				el.classList[state ? 'add' : 'remove'](name);
			} else {
				var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
				el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
			}
		}
	}

	function _css(el, prop, val) {
		var style = el && el.style;

		if (style) {
			if (val === void 0) {
				if (document.defaultView && document.defaultView.getComputedStyle) {
					val = document.defaultView.getComputedStyle(el, '');
				} else if (el.currentStyle) {
					val = el.currentStyle;
				}

				return prop === void 0 ? val : val[prop];
			} else {
				if (!(prop in style)) {
					prop = '-webkit-' + prop;
				}

				style[prop] = val + (typeof val === 'string' ? '' : 'px');
			}
		}
	}

	function _find(ctx, tagName, iterator) {
		if (ctx) {
			var list = ctx.getElementsByTagName(tagName),
			    i = 0,
			    n = list.length;

			if (iterator) {
				for (; i < n; i++) {
					iterator(list[i], i);
				}
			}

			return list;
		}

		return [];
	}

	function _dispatchEvent(sortable, rootEl, name, targetEl, fromEl, startIndex, newIndex) {
		sortable = sortable || rootEl[expando];

		var evt = document.createEvent('Event'),
		    options = sortable.options,
		    onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1);

		evt.initEvent(name, true, true);

		evt.to = rootEl;
		evt.from = fromEl || rootEl;
		evt.item = targetEl || rootEl;
		evt.clone = cloneEl;

		evt.oldIndex = startIndex;
		evt.newIndex = newIndex;

		rootEl.dispatchEvent(evt);

		if (options[onName]) {
			options[onName].call(sortable, evt);
		}
	}

	function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvt, willInsertAfter) {
		var evt,
		    sortable = fromEl[expando],
		    onMoveFn = sortable.options.onMove,
		    retVal;

		evt = document.createEvent('Event');
		evt.initEvent('move', true, true);

		evt.to = toEl;
		evt.from = fromEl;
		evt.dragged = dragEl;
		evt.draggedRect = dragRect;
		evt.related = targetEl || toEl;
		evt.relatedRect = targetRect || toEl.getBoundingClientRect();
		evt.willInsertAfter = willInsertAfter;

		fromEl.dispatchEvent(evt);

		if (onMoveFn) {
			retVal = onMoveFn.call(sortable, evt, originalEvt);
		}

		return retVal;
	}

	function _disableDraggable(el) {
		el.draggable = false;
	}

	function _unsilent() {
		_silent = false;
	}

	/** @returns {HTMLElement|false} */
	function _ghostIsLast(el, evt) {
		var lastEl = el.lastElementChild,
		    rect = lastEl.getBoundingClientRect();

		// 5 — min delta
		// abs — нельзя добавлять, а то глюки при наведении сверху
		return evt.clientY - (rect.top + rect.height) > 5 || evt.clientX - (rect.left + rect.width) > 5;
	}

	/**
  * Generate id
  * @param   {HTMLElement} el
  * @returns {String}
  * @private
  */
	function _generateId(el) {
		var str = el.tagName + el.className + el.src + el.href + el.textContent,
		    i = str.length,
		    sum = 0;

		while (i--) {
			sum += str.charCodeAt(i);
		}

		return sum.toString(36);
	}

	/**
  * Returns the index of an element within its parent for a selected set of
  * elements
  * @param  {HTMLElement} el
  * @param  {selector} selector
  * @return {number}
  */
	function _index(el, selector) {
		var index = 0;

		if (!el || !el.parentNode) {
			return -1;
		}

		while (el && (el = el.previousElementSibling)) {
			if (el.nodeName.toUpperCase() !== 'TEMPLATE' && (selector === '>*' || _matches(el, selector))) {
				index++;
			}
		}

		return index;
	}

	function _matches( /**HTMLElement*/el, /**String*/selector) {
		if (el) {
			selector = selector.split('.');

			var tag = selector.shift().toUpperCase(),
			    re = new RegExp('\\s(' + selector.join('|') + ')(?=\\s)', 'g');

			return (tag === '' || el.nodeName.toUpperCase() == tag) && (!selector.length || ((' ' + el.className + ' ').match(re) || []).length == selector.length);
		}

		return false;
	}

	function _throttle(callback, ms) {
		var args, _this;

		return function () {
			if (args === void 0) {
				args = arguments;
				_this = this;

				setTimeout(function () {
					if (args.length === 1) {
						callback.call(_this, args[0]);
					} else {
						callback.apply(_this, args);
					}

					args = void 0;
				}, ms);
			}
		};
	}

	function _extend(dst, src) {
		if (dst && src) {
			for (var key in src) {
				if (src.hasOwnProperty(key)) {
					dst[key] = src[key];
				}
			}
		}

		return dst;
	}

	function _clone(el) {
		return $ ? $(el).clone(true)[0] : Polymer && Polymer.dom ? Polymer.dom(el).cloneNode(true) : el.cloneNode(true);
	}

	function _saveInputCheckedState(root) {
		var inputs = root.getElementsByTagName('input');
		var idx = inputs.length;

		while (idx--) {
			var el = inputs[idx];
			el.checked && savedInputChecked.push(el);
		}
	}

	// Fixed #973: 
	_on(document, 'touchmove', function (evt) {
		if (Sortable.active) {
			evt.preventDefault();
		}
	});

	try {
		window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
			get: function get() {
				captureMode = {
					capture: false,
					passive: false
				};
			}
		}));
	} catch (err) {}

	// Export utils
	Sortable.utils = {
		on: _on,
		off: _off,
		css: _css,
		find: _find,
		is: function is(el, selector) {
			return !!_closest(el, selector, el);
		},
		extend: _extend,
		throttle: _throttle,
		closest: _closest,
		toggleClass: _toggleClass,
		clone: _clone,
		index: _index
	};

	/**
  * Create sortable instance
  * @param {HTMLElement}  el
  * @param {Object}      [options]
  */
	Sortable.create = function (el, options) {
		return new Sortable(el, options);
	};

	// Export
	Sortable.version = '1.6.1';
	return Sortable;
});

/***/ }),

/***/ "uE+1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),

/***/ "vMhP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _resolvePathname = __webpack_require__("7YO4");

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__("t+Vk");

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__("4gcd");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),

/***/ "vV8Q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__("5D9O"));

var _react = _interopRequireWildcard(__webpack_require__("eW0v"));

var _sortablejs = _interopRequireDefault(__webpack_require__("tZHd"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];
    }
  }return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }return _typeof(obj);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};var ownKeys = Object.keys(source);if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

var store = {
  nextSibling: null,
  activeComponent: null
};

var Sortable =
/*#__PURE__*/
function (_Component) {
  _inherits(Sortable, _Component);

  function Sortable() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Sortable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Sortable)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "sortable", null);

    return _this;
  }

  _createClass(Sortable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var options = _objectSpread({}, this.props.options);

      ['onChoose', 'onStart', 'onEnd', 'onAdd', 'onUpdate', 'onSort', 'onRemove', 'onFilter', 'onMove', 'onClone'].forEach(function (name) {
        var eventHandler = options[name];

        options[name] = function () {
          for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            params[_key2] = arguments[_key2];
          }

          var evt = params[0];

          if (name === 'onChoose') {
            store.nextSibling = evt.item.nextElementSibling;
            store.activeComponent = _this2;
          } else if ((name === 'onAdd' || name === 'onUpdate') && _this2.props.onChange) {
            var items = _this2.sortable.toArray();

            var remote = store.activeComponent;
            var remoteItems = remote.sortable.toArray();
            var referenceNode = store.nextSibling && store.nextSibling.parentNode !== null ? store.nextSibling : null;
            evt.from.insertBefore(evt.item, referenceNode);

            if (remote !== _this2) {
              var remoteOptions = remote.props.options || {};

              if (_typeof(remoteOptions.group) === 'object' && remoteOptions.group.pull === 'clone') {
                // Remove the node with the same data-reactid
                evt.item.parentNode.removeChild(evt.item);
              }

              remote.props.onChange && remote.props.onChange(remoteItems, remote.sortable, evt);
            }

            _this2.props.onChange && _this2.props.onChange(items, _this2.sortable, evt);
          }

          if (evt.type === 'move') {
            var _evt = params[0],
                originalEvent = params[1];
            var canMove = eventHandler ? eventHandler(_evt, originalEvent) : true;
            return canMove;
          }

          setTimeout(function () {
            eventHandler && eventHandler(evt);
          }, 0);
        };
      });
      this.sortable = _sortablejs.default.create(this.node, options);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      // If onChange is null, it is an UnControlled component
      // Don't let React re-render it by setting return to false
      if (!nextProps.onChange) {
        return false;
      }

      return true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.sortable) {
        this.sortable.destroy();
        this.sortable = null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          Component = _this$props.tag,
          options = _this$props.options,
          onChange = _this$props.onChange,
          props = _objectWithoutProperties(_this$props, ["tag", "options", "onChange"]);

      return _react.default.createElement(Component, _extends({}, props, {
        ref: function ref(node) {
          _this3.node = node;
        }
      }));
    }
  }]);

  return Sortable;
}(_react.Component);

_defineProperty(Sortable, "propTypes", {
  options: _propTypes.default.object,
  onChange: _propTypes.default.func,
  tag: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  style: _propTypes.default.object
});

_defineProperty(Sortable, "defaultProps", {
  options: {},
  tag: 'div',
  style: {}
});

var _default = Sortable;
exports.default = _default;

/***/ }),

/***/ "wJDa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _warning = __webpack_require__("/sXU");

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__("2gTp");

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__("vMhP");

var _PathUtils = __webpack_require__("4gcd");

var _createTransitionManager = __webpack_require__("/Uqj");

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__("uE+1");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;

    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),

/***/ "wMfb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"control-box":"_FUa9","toggle-wrapper":"_3d6m","small-txt":"_EYo4","switch":"_34HF","slider":"_3MpY","round":"_2PBq"};

/***/ }),

/***/ "wVGV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__("Asjh");

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),

/***/ "x75c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"error-page-wrap":"_eprJ","error-heading":"_21kl","error-para":"_FpRv","retry-btn":"_3F0r"};

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.e522c.js